import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Json: any;
  Upload: any;
};

export type ActiveMember = {
  __typename?: 'ActiveMember';
  active_member_total?: Maybe<Scalars['Int']>;
};

export type Activity = {
  __typename?: 'Activity';
  causer_id?: Maybe<Scalars['Int']>;
  causer_type?: Maybe<Scalars['String']>;
  changes?: Maybe<Scalars['Json']>;
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  properties?: Maybe<Scalars['Json']>;
  subject_id?: Maybe<Scalars['Int']>;
  subject_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  user_causer?: Maybe<UserCauser>;
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  batch_uuid?: Maybe<Scalars['String']>;
  causer_id?: Maybe<Scalars['String']>;
  causer_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  log_name?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['String']>;
  subject_id?: Maybe<Scalars['String']>;
  subject_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type ActivityLogListingInput = {
  description?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['Date']>;
  log_name: LogName;
  start_date?: InputMaybe<Scalars['Date']>;
  subject_id: Scalars['Int'];
};

/** A paginated list of Activity items. */
export type ActivityPaginator = {
  __typename?: 'ActivityPaginator';
  /** A list of Activity items. */
  data: Array<Activity>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type AdminCreateInput = {
  admin_role?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  user_address?: InputMaybe<Scalars['String']>;
  user_address2?: InputMaybe<Scalars['String']>;
  user_city?: InputMaybe<Scalars['Int']>;
  user_department?: InputMaybe<Scalars['String']>;
  user_email?: InputMaybe<Scalars['String']>;
  user_fullname?: InputMaybe<Scalars['String']>;
  user_mobile?: InputMaybe<Scalars['String']>;
  user_postcode?: InputMaybe<Scalars['String']>;
  user_state?: InputMaybe<Scalars['Int']>;
  user_status?: InputMaybe<UserStatus>;
};

export type AdminListingInput = {
  client_id?: InputMaybe<Scalars['Int']>;
  clinic_id?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  role_id?: InputMaybe<Scalars['Int']>;
  role_name?: InputMaybe<Scalars['String']>;
  user_status?: InputMaybe<UserStatus>;
  user_type_slug?: InputMaybe<UserTypeRole>;
};

export type AdminRolesInputListingQuery = {
  keyword?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RolesStatus>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_type_slug?: InputMaybe<UserTypeRole>;
};

export type AdminRolesInputQuery = {
  team_id?: InputMaybe<Scalars['Int']>;
  user_type_slug?: InputMaybe<UserTypeRole>;
};

export type AdminStatusCount = {
  __typename?: 'AdminStatusCount';
  admin_status_count?: Maybe<Scalars['Int']>;
  admin_status_name?: Maybe<Scalars['String']>;
};

export type AdminUpdateInput = {
  admin_role?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  user_address?: InputMaybe<Scalars['String']>;
  user_address2?: InputMaybe<Scalars['String']>;
  user_city?: InputMaybe<Scalars['Int']>;
  user_department?: InputMaybe<Scalars['String']>;
  user_email?: InputMaybe<Scalars['String']>;
  user_fullname?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  user_mobile?: InputMaybe<Scalars['String']>;
  user_postcode?: InputMaybe<Scalars['String']>;
  user_state?: InputMaybe<Scalars['Int']>;
  user_status?: InputMaybe<UserStatus>;
};

export type AverageAmountPerWeek = {
  __typename?: 'AverageAmountPerWeek';
  average_amount?: Maybe<Scalars['Float']>;
};

export enum BankStatus {
  Active = 'active',
  Suspend = 'suspend',
}

export type BulkManagement = {
  __typename?: 'BulkManagement';
  bulk_management_created?: Maybe<Scalars['DateTime']>;
  bulk_management_id?: Maybe<Scalars['Int']>;
  bulk_management_media?: Maybe<MediaData>;
  bulk_management_module?: Maybe<Scalars['String']>;
  bulk_management_status?: Maybe<BulkManagementStatus>;
  bulk_management_type?: Maybe<BulkManagementType>;
  bulk_management_updated?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type BulkManagementListingInput = {
  bulk_management_status?: InputMaybe<BulkManagementStatus>;
  bulk_management_type?: InputMaybe<BulkManagementType>;
  end_date?: InputMaybe<Scalars['Date']>;
  keyword?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['Date']>;
};

/** A paginated list of BulkManagement items. */
export type BulkManagementPaginator = {
  __typename?: 'BulkManagementPaginator';
  /** A list of BulkManagement items. */
  data: Array<BulkManagement>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum BulkManagementStatus {
  Completed = 'completed',
  Failed = 'failed',
  Processing = 'processing',
}

export enum BulkManagementType {
  Export = 'export',
  Import = 'import',
  Update = 'update',
}

export type CLaimMedicationInputs = {
  medication_amount?: InputMaybe<Scalars['Float']>;
  medication_name?: InputMaybe<Scalars['String']>;
  medication_quantity?: InputMaybe<Scalars['Int']>;
};

export type Claim = {
  __typename?: 'Claim';
  claim_approved?: Maybe<Scalars['Float']>;
  claim_created?: Maybe<Scalars['DateTime']>;
  claim_declined?: Maybe<Scalars['Float']>;
  claim_diagnosis?: Maybe<Array<Maybe<ClaimDiagnosis>>>;
  claim_id?: Maybe<Scalars['Int']>;
  claim_incurred?: Maybe<Scalars['Float']>;
  claim_medication?: Maybe<Array<Maybe<ClaimMedication>>>;
  claim_not_approved?: Maybe<Scalars['Float']>;
  claim_number?: Maybe<Scalars['String']>;
  claim_reject_reason?: Maybe<ClaimRejectReason>;
  claim_service?: Maybe<Array<Maybe<ClaimService>>>;
  claim_status?: Maybe<ClaimStatus>;
  claim_updated?: Maybe<Scalars['DateTime']>;
  client?: Maybe<Client>;
  clinic?: Maybe<Clinic>;
  clinic_patient?: Maybe<Patient>;
  letter_of_appointment?: Maybe<MediaData>;
  medical_certificate?: Maybe<MedicalCertificate>;
  member?: Maybe<Member>;
  reject_reason?: Maybe<Scalars['String']>;
  session?: Maybe<Session>;
  setting_benefit_plan?: Maybe<SettingBenefitPlan>;
  total_amount?: Maybe<Scalars['Float']>;
  total_medication?: Maybe<Scalars['Float']>;
  total_service?: Maybe<Scalars['Float']>;
};

export type ClaimDiagnosis = {
  __typename?: 'ClaimDiagnosis';
  diagnosis?: Maybe<SettingDiagnosis>;
  is_eligible?: Maybe<Scalars['Boolean']>;
};

export type ClaimListingInput = {
  card_no?: InputMaybe<Scalars['String']>;
  claim_id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  claim_number?: InputMaybe<Scalars['String']>;
  claim_status_slug?: InputMaybe<ClaimStatusSlug>;
  client_branch_id?: InputMaybe<Scalars['Int']>;
  client_corporate_id?: InputMaybe<Scalars['Int']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinic_id?: InputMaybe<Scalars['Int']>;
  clinic_patient_name?: InputMaybe<Scalars['String']>;
  clinic_patient_nric?: InputMaybe<Scalars['String']>;
  dependent_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['Date']>;
  member_id?: InputMaybe<Scalars['Int']>;
  member_name?: InputMaybe<Scalars['String']>;
  member_nric?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['Date']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ClaimMedication = {
  __typename?: 'ClaimMedication';
  medication_amount?: Maybe<Scalars['Float']>;
  medication_name?: Maybe<Scalars['String']>;
  medication_quantity?: Maybe<Scalars['Int']>;
};

/** A paginated list of Claim items. */
export type ClaimPaginator = {
  __typename?: 'ClaimPaginator';
  /** A list of Claim items. */
  data: Array<Claim>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ClaimRejectReason = {
  __typename?: 'ClaimRejectReason';
  reject_reason_id?: Maybe<Scalars['Int']>;
  reject_reason_name?: Maybe<Scalars['String']>;
  reject_reason_slug?: Maybe<Scalars['String']>;
  reject_reason_status?: Maybe<Scalars['String']>;
};

export type ClaimRejectReasonLessDetail = {
  __typename?: 'ClaimRejectReasonLessDetail';
  reject_reason_id?: Maybe<Scalars['Int']>;
  reject_reason_name?: Maybe<Scalars['String']>;
};

export type ClaimService = {
  __typename?: 'ClaimService';
  service_amount?: Maybe<Scalars['Float']>;
  service_remark?: Maybe<Scalars['String']>;
  setting_service?: Maybe<SettingService>;
};

export type ClaimServiceInput = {
  service_amount?: InputMaybe<Scalars['Float']>;
  service_id?: InputMaybe<Scalars['Int']>;
  service_remark?: InputMaybe<Scalars['String']>;
};

export type ClaimStatus = {
  __typename?: 'ClaimStatus';
  claim_status_id?: Maybe<Scalars['Int']>;
  claim_status_name?: Maybe<Scalars['String']>;
  claim_status_slug?: Maybe<Scalars['String']>;
};

export type ClaimStatusCount = {
  __typename?: 'ClaimStatusCount';
  claim_status_count?: Maybe<Scalars['Int']>;
  claim_status_name?: Maybe<Scalars['String']>;
  claim_status_slug?: Maybe<Scalars['String']>;
};

export enum ClaimStatusSlug {
  All = 'all',
  Approved = 'approved',
  Declined = 'declined',
  Incurred = 'incurred',
  PaidToProvider = 'paid_to_provider',
  Rejected = 'rejected',
}

export type ClaimSummary = {
  __typename?: 'ClaimSummary';
  claim_count?: Maybe<Scalars['Int']>;
  claim_total?: Maybe<Scalars['Float']>;
};

export type Claims = {
  __typename?: 'Claims';
  claims_amount?: Maybe<Scalars['Float']>;
  claims_count?: Maybe<Scalars['Int']>;
  claims_date?: Maybe<Scalars['Date']>;
};

export type Client = {
  __typename?: 'Client';
  activity_log?: Maybe<Array<Maybe<ActivityLog>>>;
  city_id?: Maybe<Scalars['Int']>;
  client_address_1?: Maybe<Scalars['String']>;
  client_address_2?: Maybe<Scalars['String']>;
  client_admin?: Maybe<User>;
  client_benefit_plan?: Maybe<Array<Maybe<SettingBenefitPlan>>>;
  client_clinic?: Maybe<Array<Maybe<Clinic>>>;
  client_corporate?: Maybe<Array<Maybe<ClientCorporate>>>;
  client_created?: Maybe<Scalars['DateTime']>;
  client_diagnosis_exclusion?: Maybe<Array<Maybe<SettingDiagnosis>>>;
  client_diagnosis_exclusion_file?: Maybe<Scalars['String']>;
  client_financial_month?: Maybe<Scalars['Int']>;
  client_full_address?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['Int']>;
  client_live_date?: Maybe<Scalars['Date']>;
  client_mobile?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  client_number?: Maybe<Scalars['String']>;
  client_payment_term_day?: Maybe<Scalars['String']>;
  client_pic?: Maybe<Array<Maybe<ClientPic>>>;
  client_postcode?: Maybe<Scalars['String']>;
  client_ssm_number?: Maybe<Scalars['String']>;
  client_sst_number?: Maybe<Scalars['String']>;
  client_status?: Maybe<ClientStatus>;
  client_step?: Maybe<ClientStep>;
  client_updated?: Maybe<Scalars['DateTime']>;
  client_website?: Maybe<Scalars['String']>;
  clinic_category_count?: Maybe<Array<Maybe<ClinicCategoryCount>>>;
  current_financial_year?: Maybe<Scalars['String']>;
  industry_id?: Maybe<Scalars['Int']>;
  is_dependant?: Maybe<Scalars['Int']>;
  is_increment_mode?: Maybe<Scalars['Int']>;
  is_prorate_mode?: Maybe<Scalars['Int']>;
  setting_city?: Maybe<SettingCity>;
  setting_state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']>;
  user?: Maybe<Array<Maybe<User>>>;
};

export type ClientBenefitPlan = {
  __typename?: 'ClientBenefitPlan';
  client?: Maybe<Client>;
  client_benefit_limit_per_visit?: Maybe<Scalars['Float']>;
  client_benefit_plan_amount?: Maybe<Scalars['Float']>;
  client_benefit_plan_created?: Maybe<Scalars['DateTime']>;
  client_benefit_plan_id?: Maybe<Scalars['Int']>;
  client_benefit_plan_name?: Maybe<Scalars['String']>;
  client_benefit_plan_updated?: Maybe<Scalars['DateTime']>;
};

export type ClientBenefitPlanLessDetail = {
  __typename?: 'ClientBenefitPlanLessDetail';
  client_benefit_plan_id?: Maybe<Scalars['Int']>;
  client_benefit_plan_name?: Maybe<Scalars['String']>;
};

export type ClientBranch = {
  __typename?: 'ClientBranch';
  city_id?: Maybe<Scalars['Int']>;
  client?: Maybe<Client>;
  client_branch_address_1?: Maybe<Scalars['String']>;
  client_branch_address_2?: Maybe<Scalars['String']>;
  client_branch_clinic?: Maybe<Array<Maybe<Clinic>>>;
  client_branch_created?: Maybe<Scalars['DateTime']>;
  client_branch_full_address?: Maybe<Scalars['String']>;
  client_branch_id?: Maybe<Scalars['Int']>;
  client_branch_mobile?: Maybe<Scalars['String']>;
  client_branch_name?: Maybe<Scalars['String']>;
  client_branch_number?: Maybe<Scalars['String']>;
  client_branch_postcode?: Maybe<Scalars['String']>;
  client_branch_ssm_number?: Maybe<Scalars['String']>;
  client_branch_sst_number?: Maybe<Scalars['String']>;
  client_branch_status?: Maybe<ClientBranchStatus>;
  client_branch_updated?: Maybe<Scalars['DateTime']>;
  client_corporate?: Maybe<ClientCorporate>;
  client_corporate_id?: Maybe<Scalars['Int']>;
  client_corporate_payor?: Maybe<ClientCorporate>;
  client_id?: Maybe<Scalars['Int']>;
  is_all_clinic?: Maybe<Scalars['Boolean']>;
  member?: Maybe<Array<Maybe<Member>>>;
  setting_city?: Maybe<SettingCity>;
  setting_state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']>;
};

export type ClientBranchLessDetail = {
  __typename?: 'ClientBranchLessDetail';
  client_branch_id?: Maybe<Scalars['Int']>;
  client_branch_name?: Maybe<Scalars['String']>;
};

/** A paginated list of ClientBranch items. */
export type ClientBranchPaginator = {
  __typename?: 'ClientBranchPaginator';
  /** A list of ClientBranch items. */
  data: Array<ClientBranch>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ClientBranchStatus {
  Active = 'active',
  Draft = 'draft',
  Suspend = 'suspend',
}

export type ClientCorporate = {
  __typename?: 'ClientCorporate';
  city_id?: Maybe<Scalars['Int']>;
  client?: Maybe<Client>;
  client_branch?: Maybe<Array<Maybe<ClientBranch>>>;
  client_corporate_address_1?: Maybe<Scalars['String']>;
  client_corporate_address_2?: Maybe<Scalars['String']>;
  client_corporate_clinic?: Maybe<Array<Maybe<Clinic>>>;
  client_corporate_email?: Maybe<Array<Maybe<ClientCorporateEmail>>>;
  client_corporate_full_address?: Maybe<Scalars['String']>;
  client_corporate_id?: Maybe<Scalars['Int']>;
  client_corporate_live_date?: Maybe<Scalars['Date']>;
  client_corporate_mobile?: Maybe<Scalars['String']>;
  client_corporate_name?: Maybe<Scalars['String']>;
  client_corporate_number?: Maybe<Scalars['String']>;
  client_corporate_payor?: Maybe<ClientCorporate>;
  client_corporate_postcode?: Maybe<Scalars['String']>;
  client_corporate_ssm_number?: Maybe<Scalars['String']>;
  client_corporate_sst_number?: Maybe<Scalars['String']>;
  client_corporate_status?: Maybe<ClientCorporateStatus>;
  client_corporate_website?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['Int']>;
  industry_id?: Maybe<Scalars['Int']>;
  is_all_clinic?: Maybe<Scalars['Boolean']>;
  is_payor?: Maybe<Scalars['Int']>;
  is_send_email?: Maybe<Scalars['Int']>;
  member?: Maybe<Array<Maybe<Member>>>;
  setting_city?: Maybe<SettingCity>;
  setting_industry?: Maybe<SettingIndustry>;
  setting_state?: Maybe<State>;
  state_id?: Maybe<Scalars['Int']>;
};

export type ClientCorporateEmail = {
  __typename?: 'ClientCorporateEmail';
  client_corporate_email?: Maybe<Scalars['String']>;
  client_corporate_email_id?: Maybe<Scalars['Int']>;
  client_corporate_id?: Maybe<Scalars['Int']>;
  is_enabled?: Maybe<Scalars['Int']>;
};

export type ClientCorporateEmailLessDetail = {
  __typename?: 'ClientCorporateEmailLessDetail';
  client_corporate_email?: Maybe<Scalars['String']>;
  client_corporate_email_id?: Maybe<Scalars['Int']>;
};

export type ClientCorporateLessDetail = {
  __typename?: 'ClientCorporateLessDetail';
  client_corporate_id?: Maybe<Scalars['Int']>;
  client_corporate_name?: Maybe<Scalars['String']>;
};

export type ClientCorporateListingInput = {
  city_id?: InputMaybe<Scalars['Int']>;
  client_corporate_status?: InputMaybe<ClientCorporateStatus>;
  client_id?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  setting_benefit_plan_id?: InputMaybe<Scalars['Int']>;
  state_id?: InputMaybe<Scalars['Int']>;
};

/** A paginated list of ClientCorporate items. */
export type ClientCorporatePaginator = {
  __typename?: 'ClientCorporatePaginator';
  /** A list of ClientCorporate items. */
  data: Array<ClientCorporate>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ClientCorporateStatus {
  Active = 'active',
  Draft = 'draft',
  Suspend = 'suspend',
}

export type ClientCorporateStatusCount = {
  __typename?: 'ClientCorporateStatusCount';
  client_corporate_status?: Maybe<Scalars['String']>;
  client_corporate_status_count?: Maybe<Scalars['Int']>;
};

export type ClientLessDetail = {
  __typename?: 'ClientLessDetail';
  client_id?: Maybe<Scalars['Int']>;
  client_name?: Maybe<Scalars['String']>;
};

export type ClientListingInput = {
  city_id?: InputMaybe<Scalars['Int']>;
  client_status?: InputMaybe<ClientStatus>;
  keyword?: InputMaybe<Scalars['String']>;
  setting_clinic_category_id?: InputMaybe<Scalars['Int']>;
  state_id?: InputMaybe<Scalars['Int']>;
};

/** A paginated list of Client items. */
export type ClientPaginator = {
  __typename?: 'ClientPaginator';
  /** A list of Client items. */
  data: Array<Client>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ClientPic = {
  __typename?: 'ClientPic';
  client_id?: Maybe<Scalars['Int']>;
  client_pic_department?: Maybe<Scalars['String']>;
  client_pic_email?: Maybe<Scalars['String']>;
  client_pic_id?: Maybe<Scalars['Int']>;
  client_pic_mobile?: Maybe<Array<Maybe<Scalars['String']>>>;
  client_pic_name?: Maybe<Scalars['String']>;
};

export type ClientPicLessDetail = {
  __typename?: 'ClientPicLessDetail';
  client_pic_id?: Maybe<Scalars['Int']>;
  client_pic_name?: Maybe<Scalars['String']>;
};

export enum ClientStatus {
  Active = 'active',
  Draft = 'draft',
  Suspend = 'suspend',
}

export enum ClientStep {
  Client = 'client',
  ClientAdmin = 'client_admin',
  ClientBenefitPlan = 'client_benefit_plan',
  ClientClinic = 'client_clinic',
  ClientDiagnosis = 'client_diagnosis',
  ClientPic = 'client_pic',
  ClientSetting = 'client_setting',
  Completed = 'completed',
}

export type Clinic = {
  __typename?: 'Clinic';
  bank_id?: Maybe<Scalars['Int']>;
  city?: Maybe<SettingCity>;
  claim_summary?: Maybe<ClaimSummary>;
  client_branch_clinic?: Maybe<Array<Maybe<ClientBranch>>>;
  client_clinic?: Maybe<Array<Maybe<Client>>>;
  client_corporate_clinic?: Maybe<Array<Maybe<ClientCorporate>>>;
  clinic_address_1?: Maybe<Scalars['String']>;
  clinic_address_2?: Maybe<Scalars['String']>;
  clinic_admin?: Maybe<User>;
  clinic_administration_fee?: Maybe<Scalars['String']>;
  clinic_bank_account_name?: Maybe<Scalars['String']>;
  clinic_bank_account_number?: Maybe<Scalars['String']>;
  clinic_check_list_status?: Maybe<Scalars['Boolean']>;
  clinic_distance?: Maybe<Scalars['String']>;
  clinic_doctor?: Maybe<Array<Maybe<ClinicDoctor>>>;
  clinic_email?: Maybe<Scalars['String']>;
  clinic_full_address?: Maybe<Scalars['String']>;
  clinic_id?: Maybe<Scalars['Int']>;
  clinic_image?: Maybe<Scalars['String']>;
  clinic_latitude?: Maybe<Scalars['String']>;
  clinic_logo?: Maybe<Scalars['String']>;
  clinic_longitude?: Maybe<Scalars['String']>;
  clinic_mobile?: Maybe<Scalars['String']>;
  clinic_name?: Maybe<Scalars['String']>;
  clinic_number?: Maybe<Scalars['String']>;
  clinic_open_status?: Maybe<ClinicOpenStatus>;
  clinic_opening_hour?: Maybe<Array<Maybe<ClinicOpeningHour>>>;
  clinic_overall_rating?: Maybe<Scalars['Float']>;
  clinic_pic?: Maybe<Array<Maybe<ClinicPic>>>;
  clinic_postcode?: Maybe<Scalars['String']>;
  clinic_registration_number?: Maybe<Scalars['String']>;
  clinic_remark?: Maybe<Scalars['String']>;
  clinic_status?: Maybe<ClinicStatus>;
  clinic_step?: Maybe<ClinicStep>;
  ongoing_session_count?: Maybe<Scalars['Int']>;
  payment_term?: Maybe<Scalars['String']>;
  setting_bank?: Maybe<SettingBank>;
  setting_clinic_category?: Maybe<SettingClinicCategory>;
  setting_clinic_check_list?: Maybe<Array<Maybe<SettingClinicCheckList>>>;
  setting_clinic_group?: Maybe<SettingClinicGroup>;
  state?: Maybe<State>;
  user?: Maybe<Array<Maybe<User>>>;
};

export type ClinicAdminCreateInput = {
  clinic_id?: InputMaybe<Scalars['Int']>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  user_address?: InputMaybe<Scalars['String']>;
  user_address2?: InputMaybe<Scalars['String']>;
  user_city?: InputMaybe<Scalars['Int']>;
  user_department?: InputMaybe<Scalars['String']>;
  user_email?: InputMaybe<Scalars['String']>;
  user_fullname?: InputMaybe<Scalars['String']>;
  user_mobile?: InputMaybe<Scalars['String']>;
  user_postcode?: InputMaybe<Scalars['String']>;
  user_state?: InputMaybe<Scalars['Int']>;
  user_status?: InputMaybe<UserStatus>;
};

export type ClinicAdminUpdateInput = {
  clinic_id?: InputMaybe<Scalars['Int']>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  user_address?: InputMaybe<Scalars['String']>;
  user_address2?: InputMaybe<Scalars['String']>;
  user_city?: InputMaybe<Scalars['Int']>;
  user_department?: InputMaybe<Scalars['String']>;
  user_email?: InputMaybe<Scalars['String']>;
  user_fullname?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
  user_mobile?: InputMaybe<Scalars['String']>;
  user_postcode?: InputMaybe<Scalars['String']>;
  user_state?: InputMaybe<Scalars['Int']>;
  user_status?: InputMaybe<UserStatus>;
};

export type ClinicAssociatedBranch = {
  __typename?: 'ClinicAssociatedBranch';
  client_branch_name?: Maybe<Scalars['String']>;
  client_branch_number?: Maybe<Scalars['String']>;
  client_corporate_name?: Maybe<Scalars['String']>;
  client_corporate_number?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  client_number?: Maybe<Scalars['String']>;
  user_fullname?: Maybe<Scalars['String']>;
  user_mobile?: Maybe<Scalars['String']>;
};

/** A paginated list of ClinicAssociatedBranch items. */
export type ClinicAssociatedBranchPaginator = {
  __typename?: 'ClinicAssociatedBranchPaginator';
  /** A list of ClinicAssociatedBranch items. */
  data: Array<ClinicAssociatedBranch>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ClinicCategoriesCount = {
  __typename?: 'ClinicCategoriesCount';
  category_name?: Maybe<Scalars['String']>;
  clinic_count?: Maybe<Scalars['Int']>;
};

export type ClinicCategoryCount = {
  __typename?: 'ClinicCategoryCount';
  setting_clinic_category_display_name?: Maybe<Scalars['String']>;
  setting_clinic_category_id?: Maybe<Scalars['Int']>;
  setting_clinic_category_name?: Maybe<Scalars['String']>;
  total_number_of_category?: Maybe<Scalars['Int']>;
};

export type ClinicCreateInput = {
  bank_id?: InputMaybe<Scalars['Int']>;
  clinic_administration_fee?: InputMaybe<Scalars['String']>;
  clinic_bank_account_name?: InputMaybe<Scalars['String']>;
  clinic_bank_account_number?: InputMaybe<Scalars['String']>;
  clinic_email?: InputMaybe<Scalars['String']>;
  clinic_group_id?: InputMaybe<Scalars['Int']>;
  clinic_image?: InputMaybe<Scalars['Upload']>;
  clinic_logo?: InputMaybe<Scalars['Upload']>;
  clinic_mobile?: InputMaybe<Scalars['String']>;
  clinic_name?: InputMaybe<Scalars['String']>;
  clinic_registration_number?: InputMaybe<Scalars['String']>;
  clinic_remark?: InputMaybe<Scalars['String']>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  payment_term?: InputMaybe<Scalars['String']>;
  setting_clinic_category_id?: InputMaybe<Scalars['Int']>;
  setting_clinic_check_list_id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ClinicDoctor = {
  __typename?: 'ClinicDoctor';
  clinic_doctor_email?: Maybe<Scalars['String']>;
  clinic_doctor_id?: Maybe<Scalars['Int']>;
  clinic_doctor_mobile?: Maybe<Scalars['String']>;
  clinic_doctor_name?: Maybe<Scalars['String']>;
  clinic_id?: Maybe<Scalars['Int']>;
};

export type ClinicDoctorLessDetail = {
  __typename?: 'ClinicDoctorLessDetail';
  clinic_doctor_id?: Maybe<Scalars['Int']>;
  clinic_doctor_name?: Maybe<Scalars['String']>;
};

export type ClinicLessDetail = {
  __typename?: 'ClinicLessDetail';
  clinic_id?: Maybe<Scalars['Int']>;
  clinic_name?: Maybe<Scalars['String']>;
};

export type ClinicListingInput = {
  city_id?: InputMaybe<Scalars['Int']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinic_group_id?: InputMaybe<Scalars['Int']>;
  clinic_status?: InputMaybe<ClinicStatus>;
  keyword?: InputMaybe<Scalars['String']>;
  setting_clinic_category_id?: InputMaybe<Scalars['Int']>;
  state_id?: InputMaybe<Scalars['Int']>;
};

export enum ClinicOpenStatus {
  Closed = 'Closed',
  Lunch = 'Lunch',
  Open = 'Open',
}

export type ClinicOpeningHour = {
  __typename?: 'ClinicOpeningHour';
  clinic?: Maybe<Clinic>;
  closing_time?: Maybe<Scalars['String']>;
  has_lunch_hour?: Maybe<Scalars['Boolean']>;
  is_24_hour?: Maybe<Scalars['Boolean']>;
  lunch_end_time?: Maybe<Scalars['String']>;
  lunch_start_time?: Maybe<Scalars['String']>;
  opening_time?: Maybe<Scalars['String']>;
  setting_day?: Maybe<SettingDay>;
};

/** A paginated list of Clinic items. */
export type ClinicPaginator = {
  __typename?: 'ClinicPaginator';
  /** A list of Clinic items. */
  data: Array<Clinic>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ClinicPic = {
  __typename?: 'ClinicPic';
  clinic_id?: Maybe<Scalars['Int']>;
  clinic_pic_email?: Maybe<Scalars['String']>;
  clinic_pic_id?: Maybe<Scalars['Int']>;
  clinic_pic_mobile?: Maybe<Scalars['String']>;
  clinic_pic_name?: Maybe<Scalars['String']>;
  clinic_pic_position?: Maybe<Scalars['String']>;
};

export type ClinicPicLessDetail = {
  __typename?: 'ClinicPicLessDetail';
  clinic_pic_id?: Maybe<Scalars['Int']>;
  clinic_pic_name?: Maybe<Scalars['String']>;
};

export enum ClinicStatus {
  Active = 'active',
  Draft = 'draft',
  Suspend = 'suspend',
}

export type ClinicStatusCount = {
  __typename?: 'ClinicStatusCount';
  clinic_status?: Maybe<Scalars['String']>;
  clinic_status_count?: Maybe<Scalars['Int']>;
};

export enum ClinicStep {
  Clinic = 'clinic',
  ClinicAddress = 'clinic_address',
  ClinicAdmin = 'clinic_admin',
  ClinicDoctor = 'clinic_doctor',
  ClinicOpeningHour = 'clinic_opening_hour',
  ClinicPic = 'clinic_pic',
  Completed = 'completed',
}

export type ClinicUpdateAddressInput = {
  city_id?: InputMaybe<Scalars['Int']>;
  clinic_address_1?: InputMaybe<Scalars['String']>;
  clinic_address_2?: InputMaybe<Scalars['String']>;
  clinic_id?: InputMaybe<Scalars['Int']>;
  clinic_latitude?: InputMaybe<Scalars['String']>;
  clinic_longitude?: InputMaybe<Scalars['String']>;
  clinic_postcode?: InputMaybe<Scalars['String']>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  state_id?: InputMaybe<Scalars['Int']>;
};

export type ClinicUpdateInput = {
  bank_id?: InputMaybe<Scalars['Int']>;
  clinic_administration_fee?: InputMaybe<Scalars['String']>;
  clinic_bank_account_name?: InputMaybe<Scalars['String']>;
  clinic_bank_account_number?: InputMaybe<Scalars['String']>;
  clinic_email?: InputMaybe<Scalars['String']>;
  clinic_group_id?: InputMaybe<Scalars['Int']>;
  clinic_id?: InputMaybe<Scalars['Int']>;
  clinic_image?: InputMaybe<Scalars['Upload']>;
  clinic_logo?: InputMaybe<Scalars['Upload']>;
  clinic_mobile?: InputMaybe<Scalars['String']>;
  clinic_name?: InputMaybe<Scalars['String']>;
  clinic_registration_number?: InputMaybe<Scalars['String']>;
  clinic_remark?: InputMaybe<Scalars['String']>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  payment_term?: InputMaybe<Scalars['String']>;
  setting_clinic_category_id?: InputMaybe<Scalars['Int']>;
  setting_clinic_check_list_id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ClinicUpdateStatusInput = {
  clinic_id?: InputMaybe<Scalars['Int']>;
  clinic_status?: InputMaybe<ClinicStatus>;
};

export type ClinicUploadFileInput = {
  clinic_id?: InputMaybe<Scalars['Int']>;
  image_file?: InputMaybe<Scalars['Upload']>;
};

export type ContactForm = {
  __typename?: 'ContactForm';
  contact_attachments?: Maybe<Array<Maybe<MediaData>>>;
  contact_claim_amount?: Maybe<Scalars['Float']>;
  contact_form_created?: Maybe<Scalars['Date']>;
  contact_form_id?: Maybe<Scalars['Int']>;
  contact_patient_email?: Maybe<Scalars['String']>;
  contact_patient_illness?: Maybe<Scalars['String']>;
  contact_patient_mobile?: Maybe<Scalars['String']>;
  contact_patient_name?: Maybe<Scalars['String']>;
  contact_patient_nric?: Maybe<Scalars['String']>;
  member?: Maybe<Member>;
};

export type ContactFormListingInput = {
  keyword?: InputMaybe<Scalars['String']>;
  member_id?: InputMaybe<Scalars['Int']>;
};

export type Dependent = {
  __typename?: 'Dependent';
  credit_used?: Maybe<Scalars['Float']>;
  dependent_dob?: Maybe<Scalars['Date']>;
  dependent_email?: Maybe<Scalars['String']>;
  dependent_gender?: Maybe<Gender>;
  dependent_id?: Maybe<Scalars['Int']>;
  dependent_joined_date?: Maybe<Scalars['Date']>;
  dependent_mobile?: Maybe<Scalars['String']>;
  dependent_name?: Maybe<Scalars['String']>;
  dependent_no?: Maybe<Scalars['String']>;
  dependent_nric?: Maybe<Scalars['String']>;
  dependent_nric_type?: Maybe<NricType>;
  dependent_relationship?: Maybe<Scalars['String']>;
  dependent_status?: Maybe<DependentStatus>;
  member?: Maybe<Member>;
  member_id?: Maybe<Scalars['Int']>;
};

export enum DependentStatus {
  Active = 'active',
  Pending = 'pending',
  Suspend = 'suspend',
}

export type Export = {
  __typename?: 'Export';
  export_created?: Maybe<Scalars['DateTime']>;
  export_file?: Maybe<Media>;
  export_id?: Maybe<Scalars['Int']>;
  export_module?: Maybe<Scalars['String']>;
  export_status?: Maybe<ExportStatus>;
  export_type?: Maybe<Scalars['String']>;
  export_updated?: Maybe<Scalars['DateTime']>;
};

export enum ExportStatus {
  Failed = 'failed',
  Processing = 'processing',
  Success = 'success',
}

export enum Gender {
  Female = 'female',
  Male = 'male',
}

export enum IdType {
  CardNo = 'card_no',
  Nric = 'nric',
  StaffNo = 'staff_no',
}

export type Images = {
  __typename?: 'Images';
  full?: Maybe<Scalars['String']>;
  media_id?: Maybe<Scalars['Int']>;
  thumb?: Maybe<Scalars['String']>;
};

export enum IndustryStatus {
  Active = 'active',
  Draft = 'draft',
}

export enum Language {
  /** Bahasa Malaysia */
  Bm = 'bm',
  /** Chinese */
  Cn = 'cn',
  /** English */
  En = 'en',
}

export type LanguageStringInput = {
  bm?: InputMaybe<Scalars['String']>;
  cn?: InputMaybe<Scalars['String']>;
  en?: InputMaybe<Scalars['String']>;
};

export enum LogName {
  BenefitPlanClinicCategory = 'benefit_plan_clinic_category',
  Claim = 'claim',
  Client = 'client',
  ClientBenefitPlan = 'client_benefit_plan',
  ClientBranch = 'client_branch',
  ClientCorporate = 'client_corporate',
  ClientPic = 'client_pic',
  Clinic = 'clinic',
  ClinicDoctor = 'clinic_doctor',
  ClinicOpeningHour = 'clinic_opening_hour',
  ClinicPic = 'clinic_pic',
  Dependent = 'dependent',
  Faq = 'faq',
  Member = 'member',
  MemberBalance = 'member_balance',
  MemberBalanceHistory = 'member_balance_history',
  MemberMobileReset = 'member_mobile_reset',
  Notification = 'notification',
  Setting = 'setting',
  SettingBenefitPlan = 'setting_benefit_plan',
  User = 'user',
}

export type LoginInput = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  user_type?: InputMaybe<UserTypeSlug>;
};

export type Media = {
  __typename?: 'Media';
  media_id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MediaData = {
  __typename?: 'MediaData';
  media_name?: Maybe<Scalars['String']>;
  media_type?: Maybe<Scalars['String']>;
  media_url?: Maybe<Scalars['String']>;
};

export type MedicalCertificate = {
  __typename?: 'MedicalCertificate';
  end_date?: Maybe<Scalars['Date']>;
  number_of_days?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['Date']>;
};

export type MedicalCertificateInput = {
  end_date?: InputMaybe<Scalars['Date']>;
  number_of_days?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['Date']>;
};

export type Member = {
  __typename?: 'Member';
  activity_log?: Maybe<Array<Maybe<Activity>>>;
  card_no?: Maybe<Scalars['String']>;
  client?: Maybe<Client>;
  client_branch?: Maybe<ClientBranch>;
  client_corporate?: Maybe<ClientCorporate>;
  dependent?: Maybe<Array<Maybe<Dependent>>>;
  first_time_login?: Maybe<Scalars['Boolean']>;
  member_active_balance?: Maybe<MemberBalance>;
  member_balance?: Maybe<Array<Maybe<MemberBalance>>>;
  member_clinic_remark?: Maybe<Scalars['String']>;
  member_department?: Maybe<Scalars['String']>;
  member_dob?: Maybe<Scalars['Date']>;
  member_email?: Maybe<Scalars['String']>;
  member_gender?: Maybe<Gender>;
  member_id?: Maybe<Scalars['Int']>;
  member_joined_date?: Maybe<Scalars['Date']>;
  member_mobile?: Maybe<Scalars['String']>;
  member_name?: Maybe<Scalars['String']>;
  member_no?: Maybe<Scalars['String']>;
  member_nric?: Maybe<Scalars['String']>;
  member_nric_type?: Maybe<NricType>;
  member_position?: Maybe<Scalars['String']>;
  member_profile_photo?: Maybe<MediaData>;
  member_remark?: Maybe<Scalars['String']>;
  member_staff_no?: Maybe<Scalars['String']>;
  member_status?: Maybe<MemberStatus>;
  member_suspended_date?: Maybe<Scalars['Date']>;
  member_yearly_usage?: Maybe<Scalars['Float']>;
  next_year_prorate_amount?: Maybe<Scalars['Float']>;
  setting_benefit_plan?: Maybe<SettingBenefitPlan>;
  user?: Maybe<User>;
};

export type MemberBalance = {
  __typename?: 'MemberBalance';
  benefit_plan_year?: Maybe<Scalars['Int']>;
  member_balance_id?: Maybe<Scalars['Int']>;
  member_balance_remaining?: Maybe<Scalars['Float']>;
  member_balance_status?: Maybe<MemberBalanceStatus>;
  member_balance_usage?: Maybe<Scalars['Float']>;
  member_id?: Maybe<Scalars['Int']>;
  setting_benefit_plan_id?: Maybe<Scalars['Int']>;
};

export enum MemberBalanceStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export type MemberLessDetail = {
  __typename?: 'MemberLessDetail';
  member_id?: Maybe<Scalars['Int']>;
  member_name?: Maybe<Scalars['String']>;
};

export type MemberListingInput = {
  card_no?: InputMaybe<Scalars['String']>;
  client_branch_id?: InputMaybe<Scalars['Int']>;
  client_corporate_id?: InputMaybe<Scalars['Int']>;
  client_id?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  member_id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  member_joined_date_end?: InputMaybe<Scalars['Date']>;
  member_joined_date_start?: InputMaybe<Scalars['Date']>;
  member_name?: InputMaybe<Scalars['String']>;
  member_nric?: InputMaybe<Scalars['String']>;
  member_staff_no?: InputMaybe<Scalars['String']>;
  member_status?: InputMaybe<MemberStatus>;
};

export type MemberLoginInput = {
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type MemberMobileReset = {
  __typename?: 'MemberMobileReset';
  current_member_mobile?: Maybe<Scalars['String']>;
  member?: Maybe<Member>;
  member_mobile_reset_created?: Maybe<Scalars['Date']>;
  member_mobile_reset_id?: Maybe<Scalars['Int']>;
  member_mobile_reset_status?: Maybe<MobileResetStatus>;
  member_mobile_reset_updated?: Maybe<Scalars['Date']>;
  new_member_mobile?: Maybe<Scalars['String']>;
};

export enum MemberStatus {
  Active = 'active',
  Pending = 'pending',
  Suspend = 'suspend',
}

export type MobileNotification = {
  __typename?: 'MobileNotification';
  clinic?: Maybe<Clinic>;
  clinic_rating?: Maybe<Scalars['Int']>;
  member?: Maybe<Member>;
  notification_claim_amount?: Maybe<Scalars['Float']>;
  notification_claim_status?: Maybe<NotificationClaimStatus>;
  notification_created?: Maybe<Scalars['DateTime']>;
  notification_description?: Maybe<Scalars['String']>;
  notification_id?: Maybe<Scalars['Int']>;
  notification_is_new?: Maybe<Scalars['Boolean']>;
  notification_news_title?: Maybe<Scalars['String']>;
  notification_type?: Maybe<NotificationType>;
  notification_updated?: Maybe<Scalars['DateTime']>;
};

export enum MobileResetStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
}

export type Mutation = {
  __typename?: 'Mutation';
  AdminActivate?: Maybe<SuccessResponse>;
  AdminCreate?: Maybe<SuccessResponse>;
  AdminDelete?: Maybe<SuccessResponse>;
  AdminSuspend?: Maybe<SuccessResponse>;
  AdminTeamRolesActivate?: Maybe<SuccessResponse>;
  AdminTeamRolesCreate?: Maybe<SuccessResponse>;
  AdminTeamRolesSuspend?: Maybe<SuccessResponse>;
  AdminTeamRolesUpdate?: Maybe<SuccessResponse>;
  AdminUpdate?: Maybe<SuccessResponse>;
  ClinicCreate?: Maybe<SuccessResponse>;
  ClinicCreateAdmin?: Maybe<SuccessResponse>;
  ClinicCreateUpdateSuperAdmin?: Maybe<SuccessResponse>;
  ClinicDelete?: Maybe<SuccessResponse>;
  ClinicDeleteDraft?: Maybe<SuccessResponse>;
  ClinicExportSample?: Maybe<UrlResponse>;
  ClinicExportUrl?: Maybe<SuccessResponse>;
  ClinicImageUpload?: Maybe<UrlResponse>;
  ClinicImport?: Maybe<SuccessResponse>;
  ClinicPreview?: Maybe<SuccessResponse>;
  ClinicUpdate?: Maybe<SuccessResponse>;
  ClinicUpdateAddress?: Maybe<SuccessResponse>;
  ClinicUpdateAdmin?: Maybe<SuccessResponse>;
  ClinicUpdateStatus?: Maybe<SuccessResponse>;
  Login?: Maybe<TokenResponse>;
  Logout?: Maybe<SuccessResponse>;
  MemberLogin?: Maybe<TokenResponseWithUserId>;
  ReportExportUrl?: Maybe<SuccessResponse>;
  ResetPassword?: Maybe<SuccessResponse>;
  ResetPasswordCheck?: Maybe<SuccessResponse>;
  ResetPasswordSendEmail?: Maybe<SuccessResponse>;
  SessionCancel?: Maybe<SuccessResponse>;
  SessionCheckout?: Maybe<SuccessResponseCheckout>;
  SessionCreate?: Maybe<SuccessResponse>;
  TeamRolesAttachPermission?: Maybe<SuccessResponse>;
  TeamRolesDelete?: Maybe<SuccessResponse>;
  UserAddressUpdate: SuccessResponse;
  UserCreate?: Maybe<SuccessResponse>;
  UserDOBUpdate: SuccessResponse;
  UserDescriptionUpdate: SuccessResponse;
  UserFullnameUpdate: SuccessResponse;
  UserMobileUpdate: SuccessResponse;
  UserProfilePhotoUpload: SuccessResponse;
  UserUpdateEmail: SuccessResponse;
  UserUpdatePassword: SuccessResponse;
};

export type MutationAdminActivateArgs = {
  user_id?: InputMaybe<Scalars['Int']>;
};

export type MutationAdminCreateArgs = {
  input?: InputMaybe<AdminCreateInput>;
};

export type MutationAdminDeleteArgs = {
  user_id?: InputMaybe<Scalars['Int']>;
};

export type MutationAdminSuspendArgs = {
  user_id?: InputMaybe<Scalars['Int']>;
};

export type MutationAdminTeamRolesActivateArgs = {
  id?: InputMaybe<Scalars['Int']>;
};

export type MutationAdminTeamRolesCreateArgs = {
  input?: InputMaybe<TeamRolesInput>;
};

export type MutationAdminTeamRolesSuspendArgs = {
  id?: InputMaybe<Scalars['Int']>;
};

export type MutationAdminTeamRolesUpdateArgs = {
  input?: InputMaybe<TeamRolesUpdateInput>;
};

export type MutationAdminUpdateArgs = {
  input?: InputMaybe<AdminUpdateInput>;
};

export type MutationClinicCreateArgs = {
  input?: InputMaybe<ClinicCreateInput>;
};

export type MutationClinicCreateAdminArgs = {
  input?: InputMaybe<ClinicAdminCreateInput>;
};

export type MutationClinicCreateUpdateSuperAdminArgs = {
  input?: InputMaybe<ClinicAdminCreateInput>;
};

export type MutationClinicDeleteArgs = {
  clinic_id?: InputMaybe<Scalars['Int']>;
};

export type MutationClinicDeleteDraftArgs = {
  clinic_id?: InputMaybe<Scalars['Int']>;
};

export type MutationClinicExportUrlArgs = {
  input?: InputMaybe<ClinicListingInput>;
};

export type MutationClinicImageUploadArgs = {
  input?: InputMaybe<ClinicUploadFileInput>;
};

export type MutationClinicImportArgs = {
  excel_file?: InputMaybe<Scalars['Upload']>;
};

export type MutationClinicPreviewArgs = {
  excel_file?: InputMaybe<Scalars['Upload']>;
};

export type MutationClinicUpdateArgs = {
  input?: InputMaybe<ClinicUpdateInput>;
};

export type MutationClinicUpdateAddressArgs = {
  input?: InputMaybe<ClinicUpdateAddressInput>;
};

export type MutationClinicUpdateAdminArgs = {
  input?: InputMaybe<ClinicAdminUpdateInput>;
};

export type MutationClinicUpdateStatusArgs = {
  input?: InputMaybe<ClinicUpdateStatusInput>;
};

export type MutationLoginArgs = {
  input?: InputMaybe<LoginInput>;
};

export type MutationMemberLoginArgs = {
  input?: InputMaybe<MemberLoginInput>;
};

export type MutationReportExportUrlArgs = {
  input?: InputMaybe<ReportInput>;
};

export type MutationResetPasswordArgs = {
  input?: InputMaybe<ResetPasswordInput>;
};

export type MutationResetPasswordCheckArgs = {
  token?: InputMaybe<Scalars['String']>;
};

export type MutationResetPasswordSendEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};

export type MutationSessionCancelArgs = {
  input?: InputMaybe<SessionCancelInput>;
};

export type MutationSessionCheckoutArgs = {
  input?: InputMaybe<SessionCheckoutInput>;
};

export type MutationSessionCreateArgs = {
  input?: InputMaybe<SessionCreateInput>;
};

export type MutationTeamRolesAttachPermissionArgs = {
  input?: InputMaybe<TeamRolesPermissionInput>;
};

export type MutationTeamRolesDeleteArgs = {
  id?: InputMaybe<Scalars['Int']>;
};

export type MutationUserAddressUpdateArgs = {
  input?: InputMaybe<UserAddressUpdateInput>;
};

export type MutationUserCreateArgs = {
  input?: InputMaybe<UserCreateInput>;
};

export type MutationUserDobUpdateArgs = {
  input?: InputMaybe<UserDobInput>;
};

export type MutationUserDescriptionUpdateArgs = {
  input?: InputMaybe<UserDescriptionUpdateInput>;
};

export type MutationUserFullnameUpdateArgs = {
  input?: InputMaybe<UserFullnameUpdateInput>;
};

export type MutationUserMobileUpdateArgs = {
  input?: InputMaybe<UserMobileUpdateInput>;
};

export type MutationUserProfilePhotoUploadArgs = {
  user_profile_photo?: InputMaybe<Scalars['Upload']>;
};

export type MutationUserUpdateEmailArgs = {
  input?: InputMaybe<UserUpdateEmailInput>;
};

export type MutationUserUpdatePasswordArgs = {
  input?: InputMaybe<UserUpdatePasswordInput>;
};

export enum NricType {
  Ic = 'ic',
  Passport = 'passport',
}

export type Notification = {
  __typename?: 'Notification';
  notification_content?: Maybe<Scalars['String']>;
  notification_created?: Maybe<Scalars['DateTime']>;
  notification_id?: Maybe<Scalars['Int']>;
  notification_scheduled_at?: Maybe<Scalars['DateTime']>;
  notification_status?: Maybe<NotificationStatus>;
  notification_title?: Maybe<Scalars['String']>;
  notification_updated?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  user_type?: Maybe<UserType>;
};

export enum NotificationClaimStatus {
  Approved = 'approved',
  Declined = 'declined',
  Rejected = 'rejected',
  Submitted = 'submitted',
}

export type NotificationLessDetail = {
  __typename?: 'NotificationLessDetail';
  notification_id?: Maybe<Scalars['Int']>;
  notification_title?: Maybe<Scalars['String']>;
};

export type NotificationListingInput = {
  keyword?: InputMaybe<Scalars['String']>;
  notification_status?: InputMaybe<NotificationStatus>;
  user_type_slug?: InputMaybe<UserTypeSlug>;
};

/** A paginated list of Notification items. */
export type NotificationPaginator = {
  __typename?: 'NotificationPaginator';
  /** A list of Notification items. */
  data: Array<Notification>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum NotificationStatus {
  Draft = 'draft',
  Past = 'past',
  Scheduled = 'scheduled',
}

export type NotificationStatusCount = {
  __typename?: 'NotificationStatusCount';
  count?: Maybe<Scalars['Int']>;
  notification_status?: Maybe<NotificationStatus>;
};

export type NotificationStatusCountInput = {
  keyword?: InputMaybe<Scalars['String']>;
  user_type_slug?: InputMaybe<UserTypeSlug>;
};

export enum NotificationType {
  Claim = 'claim',
  ClinicRating = 'clinic_rating',
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT',
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM',
}

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Number of total available items. */
  total: Scalars['Int'];
};

export type Patient = {
  __typename?: 'Patient';
  clinic_patient_dob?: Maybe<Scalars['Date']>;
  clinic_patient_gender?: Maybe<Gender>;
  clinic_patient_name?: Maybe<Scalars['String']>;
  clinic_patient_no?: Maybe<Scalars['String']>;
  clinic_patient_nric?: Maybe<Scalars['String']>;
  clinic_patient_nric_type?: Maybe<NricType>;
  dependent?: Maybe<Dependent>;
  is_dependent?: Maybe<Scalars['Boolean']>;
};

export type PatientDetailInput = {
  client_id?: InputMaybe<Scalars['String']>;
  id_number?: InputMaybe<Scalars['String']>;
  id_type?: InputMaybe<IdType>;
};

export type PatientDetails = {
  __typename?: 'PatientDetails';
  client?: Maybe<Client>;
  client_branch?: Maybe<ClientBranch>;
  client_corporate?: Maybe<ClientCorporate>;
  clinic?: Maybe<Clinic>;
  member?: Maybe<Member>;
  patient?: Maybe<Patient>;
};

export type Permission = {
  __typename?: 'Permission';
  display_name?: Maybe<Scalars['String']>;
  group_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  ranking?: Maybe<Scalars['Int']>;
  user_type_slug?: Maybe<Scalars['String']>;
};

export enum Provider {
  Apple = 'apple',
  Facebook = 'facebook',
  Google = 'google',
  Huawei = 'huawei',
}

export type Query = {
  __typename?: 'Query';
  ActivityLogListing?: Maybe<ActivityPaginator>;
  AdminDetail?: Maybe<UserHasRoles>;
  AdminListing?: Maybe<UserHasRolesPaginator>;
  AdminPermissionListing?: Maybe<Array<Maybe<Permission>>>;
  AdminRolesDetail?: Maybe<Role>;
  AdminRolesDropdown?: Maybe<Array<Maybe<RoleLessDetail>>>;
  AdminRolesListing?: Maybe<RolePaginator>;
  AdminRolesStatusCount?: Maybe<Array<Maybe<RoleStatusCount>>>;
  AdminStatusCount?: Maybe<Array<Maybe<AdminStatusCount>>>;
  BulkManagementDetail?: Maybe<BulkManagement>;
  BulkManagementListing?: Maybe<BulkManagementPaginator>;
  ClaimDetail?: Maybe<Claim>;
  ClaimListing?: Maybe<ClaimPaginator>;
  ClaimStatusCount?: Maybe<Array<Maybe<ClaimStatusCount>>>;
  ClientCorporateDetail?: Maybe<ClientCorporate>;
  ClientCorporateDropdown?: Maybe<Array<Maybe<ClientCorporateLessDetail>>>;
  ClientCorporateListing?: Maybe<ClientCorporatePaginator>;
  ClientCorporateStatusCount?: Maybe<Array<Maybe<ClientCorporateStatusCount>>>;
  ClientDetail?: Maybe<Client>;
  ClientDropdown?: Maybe<Array<Maybe<ClientLessDetail>>>;
  ClientListing?: Maybe<ClientPaginator>;
  ClinicAssociatedBranchListing?: Maybe<ClinicAssociatedBranchPaginator>;
  ClinicClientBranchListing?: Maybe<ClientBranchPaginator>;
  ClinicClientCorporateListing?: Maybe<ClientCorporatePaginator>;
  ClinicClientDropdown?: Maybe<Array<Maybe<ClientLessDetail>>>;
  ClinicDetail?: Maybe<Clinic>;
  ClinicDropdown?: Maybe<Array<Maybe<ClinicLessDetail>>>;
  ClinicListing?: Maybe<ClinicPaginator>;
  ClinicStatusCount?: Maybe<Array<Maybe<ClinicStatusCount>>>;
  Me?: Maybe<User>;
  NotificationDetail?: Maybe<Notification>;
  NotificationDropdown?: Maybe<Array<Maybe<NotificationLessDetail>>>;
  NotificationListing?: Maybe<NotificationPaginator>;
  NotificationStatusCount?: Maybe<Array<Maybe<NotificationStatusCount>>>;
  PatientDetail?: Maybe<PatientDetails>;
  Report?: Maybe<ClaimPaginator>;
  SessionListing?: Maybe<SessionPaginator>;
  SessionReminder?: Maybe<SessionReminderCount>;
  SessionStatusCount?: Maybe<Array<Maybe<SessionStatusCount>>>;
  SettingBankDetail?: Maybe<SettingBank>;
  SettingBankDropdown?: Maybe<Array<Maybe<SettingBankLessDetail>>>;
  SettingBankListing?: Maybe<SettingBankPaginator>;
  SettingBankStatusCount?: Maybe<Array<Maybe<SettingBankStatusCount>>>;
  SettingCityDropdown?: Maybe<Array<Maybe<SettingCity>>>;
  SettingClinicCategoryDropdown?: Maybe<Array<Maybe<SettingClinicCategory>>>;
  SettingClinicCategoryListing?: Maybe<Array<Maybe<SettingClinicCategory>>>;
  SettingClinicGroupDropdown?: Maybe<Array<Maybe<SettingClinicGroup>>>;
  SettingDetail?: Maybe<Setting>;
  SettingDiagnosisCategoryDetail?: Maybe<SettingDiagnosisCategory>;
  SettingDiagnosisCategoryDropdown?: Maybe<
    Array<Maybe<SettingDiagnosisCategoryLessDetail>>
  >;
  SettingDiagnosisCategoryListing?: Maybe<SettingDiagnosisCategoryPaginator>;
  SettingDiagnosisDetail?: Maybe<SettingDiagnosis>;
  SettingDiagnosisDropdown?: Maybe<Array<Maybe<SettingDiagnosisLessDetail>>>;
  SettingDiagnosisListing?: Maybe<SettingDiagnosisPaginator>;
  SettingDiagnosisStatusCount?: Maybe<
    Array<Maybe<SettingDiagnosisStatusCount>>
  >;
  SettingDiagnosisSubCategoryDetail?: Maybe<SettingDiagnosisSubCategory>;
  SettingDiagnosisSubCategoryDropdown?: Maybe<
    Array<Maybe<SettingDiagnosisSubCategoryLessDetail>>
  >;
  SettingDiagnosisSubCategoryListing?: Maybe<SettingDiagnosisSubCategoryPaginator>;
  SettingFaqDetail?: Maybe<SettingFaq>;
  SettingFaqListing?: Maybe<SettingFaqPaginator>;
  SettingFaqPublishedListing?: Maybe<SettingFaqPaginator>;
  SettingServiceDetail?: Maybe<SettingService>;
  SettingServiceDropdown?: Maybe<Array<Maybe<SettingServiceLessDetail>>>;
  SettingServiceListing?: Maybe<SettingServicePaginator>;
  SettingServiceStatusCount?: Maybe<Array<Maybe<SettingServiceStatusCount>>>;
  SettingStateDropdown?: Maybe<Array<Maybe<SettingStateLessDetail>>>;
  SettingUrl?: Maybe<UrlResponse>;
  UserDetail?: Maybe<User>;
  UserListing?: Maybe<UserPaginator>;
};

export type QueryActivityLogListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<ActivityLogListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminDetailArgs = {
  user_id?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<AdminListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminPermissionListingArgs = {
  user_type_slug?: InputMaybe<UserTypeRole>;
};

export type QueryAdminRolesDetailArgs = {
  role_id?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminRolesDropdownArgs = {
  input?: InputMaybe<AdminRolesInputQuery>;
};

export type QueryAdminRolesListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<AdminRolesInputListingQuery>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryAdminRolesStatusCountArgs = {
  input?: InputMaybe<AdminRolesInputListingQuery>;
};

export type QueryAdminStatusCountArgs = {
  input?: InputMaybe<AdminListingInput>;
};

export type QueryBulkManagementDetailArgs = {
  bulk_management_id?: InputMaybe<Scalars['Int']>;
};

export type QueryBulkManagementListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<BulkManagementListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryClaimDetailArgs = {
  claim_id?: InputMaybe<Scalars['Int']>;
};

export type QueryClaimListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<ClaimListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryClaimStatusCountArgs = {
  input?: InputMaybe<ClaimListingInput>;
};

export type QueryClientCorporateDetailArgs = {
  client_corporate_id?: InputMaybe<Scalars['Int']>;
};

export type QueryClientCorporateDropdownArgs = {
  client_id?: InputMaybe<Scalars['Int']>;
};

export type QueryClientCorporateListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<ClientCorporateListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryClientCorporateStatusCountArgs = {
  input?: InputMaybe<ClientCorporateListingInput>;
};

export type QueryClientDetailArgs = {
  client_id?: InputMaybe<Scalars['Int']>;
};

export type QueryClientDropdownArgs = {
  member_staff_no?: InputMaybe<Scalars['String']>;
};

export type QueryClientListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<ClientListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryClinicAssociatedBranchListingArgs = {
  clinic_id?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryClinicClientBranchListingArgs = {
  clinic_id?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryClinicClientCorporateListingArgs = {
  clinic_id?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryClinicDetailArgs = {
  clinic_id?: InputMaybe<Scalars['Int']>;
};

export type QueryClinicDropdownArgs = {
  client_corporate_id?: InputMaybe<Scalars['Int']>;
};

export type QueryClinicListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<ClinicListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryClinicStatusCountArgs = {
  input?: InputMaybe<ClinicListingInput>;
};

export type QueryNotificationDetailArgs = {
  notification_id?: InputMaybe<Scalars['Int']>;
};

export type QueryNotificationListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<NotificationListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QueryNotificationStatusCountArgs = {
  input?: InputMaybe<NotificationListingInput>;
};

export type QueryPatientDetailArgs = {
  input?: InputMaybe<PatientDetailInput>;
};

export type QueryReportArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<ReportInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QuerySessionListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<SessionListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QuerySessionStatusCountArgs = {
  input?: InputMaybe<SessionListingInput>;
};

export type QuerySettingBankDetailArgs = {
  bank_id?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingBankListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<SettingBankListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingBankStatusCountArgs = {
  input?: InputMaybe<SettingBankListingInput>;
};

export type QuerySettingCityDropdownArgs = {
  state_id?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingDetailArgs = {
  setting_slug?: InputMaybe<SettingSlug>;
};

export type QuerySettingDiagnosisCategoryDetailArgs = {
  diagnosis_category_id?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingDiagnosisCategoryListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<SettingDiagnosisCategoryListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingDiagnosisDetailArgs = {
  diagnosis_id?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingDiagnosisListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<SettingDiagnosisListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingDiagnosisStatusCountArgs = {
  input?: InputMaybe<SettingDiagnosisListingInput>;
};

export type QuerySettingDiagnosisSubCategoryDetailArgs = {
  diagnosis_sub_category_id?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingDiagnosisSubCategoryDropdownArgs = {
  diagnosis_category_id?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingDiagnosisSubCategoryListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<SettingDiagnosisSubCategoryListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingFaqDetailArgs = {
  setting_faq_id?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingFaqListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<SettingFaqListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingFaqPublishedListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<SettingFaqPublishedListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingServiceDetailArgs = {
  service_id?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingServiceListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<SettingServiceListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QuerySettingServiceStatusCountArgs = {
  input?: InputMaybe<SettingServiceListingInput>;
};

export type QuerySettingUrlArgs = {
  setting_slug?: InputMaybe<SettingSlug>;
};

export type QueryUserDetailArgs = {
  user_id?: InputMaybe<Scalars['Int']>;
};

export type QueryUserListingArgs = {
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<UserListingInput>;
  page?: InputMaybe<Scalars['Int']>;
};

export type RegisteredClinic = {
  __typename?: 'RegisteredClinic';
  clinic_categories?: Maybe<Array<Maybe<ClinicCategoriesCount>>>;
  registered_clinic_total?: Maybe<Scalars['Int']>;
};

export type ReportInput = {
  card_no?: InputMaybe<Scalars['String']>;
  claim_status_slug?: InputMaybe<ClaimStatusSlug>;
  client_branch_id?: InputMaybe<Scalars['Int']>;
  client_corporate_id?: InputMaybe<Scalars['Int']>;
  client_id?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['Date']>;
  member_name?: InputMaybe<Scalars['String']>;
  member_nric?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['Date']>;
};

export type ResetPasswordInput = {
  confirm_password?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type Role = {
  __typename?: 'Role';
  client?: Maybe<Client>;
  clinic?: Maybe<Clinic>;
  description?: Maybe<Scalars['String']>;
  guard_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  status?: Maybe<RolesStatus>;
  team_id?: Maybe<Scalars['Int']>;
  user_type_slug?: Maybe<UserTypeRole>;
};

export type RoleLessDetail = {
  __typename?: 'RoleLessDetail';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** A paginated list of Role items. */
export type RolePaginator = {
  __typename?: 'RolePaginator';
  /** A list of Role items. */
  data: Array<Role>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RoleStatusCount = {
  __typename?: 'RoleStatusCount';
  role_status_count?: Maybe<Scalars['Int']>;
  role_status_name?: Maybe<Scalars['String']>;
};

export enum RolesStatus {
  Active = 'active',
  Suspend = 'suspend',
}

export enum ServiceStatus {
  Active = 'active',
  Suspend = 'suspend',
}

export type Session = {
  __typename?: 'Session';
  claim?: Maybe<Claim>;
  clinic?: Maybe<Clinic>;
  clinic_patient?: Maybe<Patient>;
  member?: Maybe<Member>;
  session_created?: Maybe<Scalars['DateTime']>;
  session_id?: Maybe<Scalars['Int']>;
  session_status?: Maybe<SessionStatus>;
  session_updated?: Maybe<Scalars['DateTime']>;
};

export type SessionCancelInput = {
  clinic_session_remark?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['Int']>;
};

export type SessionCheckoutInput = {
  claim_diagnosis?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  claim_medication?: InputMaybe<Array<InputMaybe<CLaimMedicationInputs>>>;
  claim_service?: InputMaybe<Array<InputMaybe<ClaimServiceInput>>>;
  medical_certificate?: InputMaybe<MedicalCertificateInput>;
  session_id?: InputMaybe<Scalars['Int']>;
  total_amount?: InputMaybe<Scalars['Float']>;
  total_medication?: InputMaybe<Scalars['Float']>;
  total_service?: InputMaybe<Scalars['Float']>;
};

export type SessionCreateInput = {
  clinic_patient_dob?: InputMaybe<Scalars['Date']>;
  clinic_patient_gender?: InputMaybe<Gender>;
  clinic_patient_name?: InputMaybe<Scalars['String']>;
  clinic_patient_no?: InputMaybe<Scalars['String']>;
  clinic_patient_nric?: InputMaybe<Scalars['String']>;
  clinic_patient_nric_type?: InputMaybe<NricType>;
  dependent_id?: InputMaybe<Scalars['Int']>;
  is_dependent?: InputMaybe<Scalars['Boolean']>;
  member_id?: InputMaybe<Scalars['Int']>;
};

export type SessionListingInput = {
  card_no?: InputMaybe<Scalars['String']>;
  client_branch_id?: InputMaybe<Scalars['Int']>;
  client_corporate_id?: InputMaybe<Scalars['Int']>;
  client_id?: InputMaybe<Scalars['Int']>;
  clinic_patient_name?: InputMaybe<Scalars['String']>;
  clinic_patient_nric?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['Date']>;
  session_over_3_hours?: InputMaybe<Scalars['Boolean']>;
  session_status_slug?: InputMaybe<SessionStatusSlug>;
  start_date?: InputMaybe<Scalars['Date']>;
};

/** A paginated list of Session items. */
export type SessionPaginator = {
  __typename?: 'SessionPaginator';
  /** A list of Session items. */
  data: Array<Session>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SessionReminderCount = {
  __typename?: 'SessionReminderCount';
  pending_session?: Maybe<Scalars['Int']>;
};

export type SessionStatus = {
  __typename?: 'SessionStatus';
  session_status_id?: Maybe<Scalars['Int']>;
  session_status_name?: Maybe<Scalars['String']>;
  session_status_slug?: Maybe<Scalars['String']>;
};

export type SessionStatusCount = {
  __typename?: 'SessionStatusCount';
  session_status_count?: Maybe<Scalars['Int']>;
  session_status_name?: Maybe<Scalars['String']>;
  session_status_slug?: Maybe<Scalars['String']>;
};

export enum SessionStatusSlug {
  All = 'all',
  Cancelled = 'cancelled',
  Checkout = 'checkout',
  Ongoing = 'ongoing',
}

export type Setting = {
  __typename?: 'Setting';
  is_editable?: Maybe<Scalars['Int']>;
  setting_description?: Maybe<Scalars['String']>;
  setting_id?: Maybe<Scalars['Int']>;
  setting_media?: Maybe<MediaData>;
  setting_slug?: Maybe<Scalars['String']>;
  setting_type?: Maybe<Scalars['String']>;
  setting_value?: Maybe<Scalars['String']>;
};

export type SettingBank = {
  __typename?: 'SettingBank';
  bank_id?: Maybe<Scalars['Int']>;
  bank_name?: Maybe<Scalars['String']>;
  bank_slug?: Maybe<Scalars['String']>;
  bank_status?: Maybe<BankStatus>;
};

export type SettingBankLessDetail = {
  __typename?: 'SettingBankLessDetail';
  bank_id?: Maybe<Scalars['Int']>;
  bank_name?: Maybe<Scalars['String']>;
};

export type SettingBankListingInput = {
  bank_status?: InputMaybe<BankStatus>;
  keyword?: InputMaybe<Scalars['String']>;
};

/** A paginated list of SettingBank items. */
export type SettingBankPaginator = {
  __typename?: 'SettingBankPaginator';
  /** A list of SettingBank items. */
  data: Array<SettingBank>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SettingBankStatusCount = {
  __typename?: 'SettingBankStatusCount';
  bank_status?: Maybe<BankStatus>;
  bank_status_count?: Maybe<Scalars['Int']>;
};

export type SettingBenefitPlan = {
  __typename?: 'SettingBenefitPlan';
  active_member_count?: Maybe<Scalars['Int']>;
  benefit_plan_clinic_category?: Maybe<
    Array<Maybe<SettingClinicCategoryAmount>>
  >;
  setting_benefit_plan_amount?: Maybe<Scalars['Float']>;
  setting_benefit_plan_code?: Maybe<Scalars['String']>;
  setting_benefit_plan_created?: Maybe<Scalars['DateTime']>;
  setting_benefit_plan_id?: Maybe<Scalars['Int']>;
  setting_benefit_plan_name?: Maybe<Scalars['String']>;
  setting_benefit_plan_status?: Maybe<Scalars['String']>;
  setting_benefit_plan_updated?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type SettingBenefitPlanLessDetail = {
  __typename?: 'SettingBenefitPlanLessDetail';
  setting_benefit_plan_id?: Maybe<Scalars['Int']>;
  setting_benefit_plan_name?: Maybe<Scalars['String']>;
};

export enum SettingBenefitPlanStatus {
  Active = 'active',
  Suspended = 'suspended',
}

export type SettingBenefitPlanStatusCount = {
  __typename?: 'SettingBenefitPlanStatusCount';
  setting_benefit_plan_status_count?: Maybe<Scalars['Int']>;
  setting_benefit_plan_status_name?: Maybe<Scalars['String']>;
};

export type SettingBenefitPlanUpdateInput = {
  setting_benefit_limit_per_visit?: InputMaybe<Scalars['Float']>;
  setting_benefit_plan_amount?: InputMaybe<Scalars['Float']>;
  setting_benefit_plan_id?: InputMaybe<Scalars['Int']>;
  setting_benefit_plan_name?: InputMaybe<Scalars['String']>;
};

export type SettingCity = {
  __typename?: 'SettingCity';
  city_id: Scalars['Int'];
  city_name: Scalars['String'];
};

export type SettingClinicCategory = {
  __typename?: 'SettingClinicCategory';
  setting_clinic_category_display_name?: Maybe<Scalars['String']>;
  setting_clinic_category_icon?: Maybe<Scalars['String']>;
  setting_clinic_category_id: Scalars['Int'];
  setting_clinic_category_name: Scalars['String'];
};

export type SettingClinicCategoryAmount = {
  __typename?: 'SettingClinicCategoryAmount';
  amount_per_visit?: Maybe<Scalars['Float']>;
  setting_clinic_category_display_name?: Maybe<Scalars['String']>;
  setting_clinic_category_id: Scalars['Int'];
  setting_clinic_category_name: Scalars['String'];
};

export type SettingClinicCheckList = {
  __typename?: 'SettingClinicCheckList';
  setting_clinic_check_list_id: Scalars['Int'];
  setting_clinic_check_list_name: Scalars['String'];
};

export type SettingClinicGroup = {
  __typename?: 'SettingClinicGroup';
  clinic_group_id: Scalars['Int'];
  clinic_group_name: Scalars['String'];
};

export type SettingDay = {
  __typename?: 'SettingDay';
  setting_day_id: Scalars['Int'];
  setting_day_name: Scalars['String'];
};

export type SettingDiagnosis = {
  __typename?: 'SettingDiagnosis';
  activity_log?: Maybe<Array<Maybe<Activity>>>;
  diagnosis_category?: Maybe<SettingDiagnosisCategory>;
  diagnosis_code?: Maybe<Scalars['String']>;
  diagnosis_created?: Maybe<Scalars['DateTime']>;
  diagnosis_id?: Maybe<Scalars['Int']>;
  diagnosis_name?: Maybe<Scalars['String']>;
  diagnosis_note?: Maybe<Scalars['String']>;
  diagnosis_status?: Maybe<SettingDiagnosisStatus>;
  diagnosis_sub_category?: Maybe<SettingDiagnosisSubCategory>;
  diagnosis_updated?: Maybe<Scalars['DateTime']>;
};

export type SettingDiagnosisCategory = {
  __typename?: 'SettingDiagnosisCategory';
  diagnosis_category_created?: Maybe<Scalars['DateTime']>;
  diagnosis_category_id?: Maybe<Scalars['Int']>;
  diagnosis_category_name?: Maybe<Scalars['String']>;
  diagnosis_category_status?: Maybe<SettingDiagnosisCategoryStatus>;
  diagnosis_category_updated?: Maybe<Scalars['DateTime']>;
};

export type SettingDiagnosisCategoryLessDetail = {
  __typename?: 'SettingDiagnosisCategoryLessDetail';
  diagnosis_category_id?: Maybe<Scalars['Int']>;
  diagnosis_category_name?: Maybe<Scalars['String']>;
};

export type SettingDiagnosisCategoryListingInput = {
  diagnosis_category_status?: InputMaybe<SettingDiagnosisCategoryStatus>;
  keyword?: InputMaybe<Scalars['String']>;
};

/** A paginated list of SettingDiagnosisCategory items. */
export type SettingDiagnosisCategoryPaginator = {
  __typename?: 'SettingDiagnosisCategoryPaginator';
  /** A list of SettingDiagnosisCategory items. */
  data: Array<SettingDiagnosisCategory>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum SettingDiagnosisCategoryStatus {
  Active = 'active',
  Suspend = 'suspend',
}

export type SettingDiagnosisLessDetail = {
  __typename?: 'SettingDiagnosisLessDetail';
  diagnosis_code?: Maybe<Scalars['String']>;
  diagnosis_id?: Maybe<Scalars['Int']>;
  diagnosis_name?: Maybe<Scalars['String']>;
};

export type SettingDiagnosisListingInput = {
  diagnosis_category_id?: InputMaybe<Scalars['Int']>;
  diagnosis_status?: InputMaybe<SettingDiagnosisStatus>;
  diagnosis_sub_category_id?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
};

/** A paginated list of SettingDiagnosis items. */
export type SettingDiagnosisPaginator = {
  __typename?: 'SettingDiagnosisPaginator';
  /** A list of SettingDiagnosis items. */
  data: Array<SettingDiagnosis>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum SettingDiagnosisStatus {
  Active = 'active',
  Suspend = 'suspend',
}

export type SettingDiagnosisStatusCount = {
  __typename?: 'SettingDiagnosisStatusCount';
  diagnosis_status?: Maybe<Scalars['String']>;
  diagnosis_status_count?: Maybe<Scalars['Int']>;
};

export type SettingDiagnosisSubCategory = {
  __typename?: 'SettingDiagnosisSubCategory';
  diagnosis_category?: Maybe<SettingDiagnosisCategory>;
  diagnosis_sub_category_created?: Maybe<Scalars['DateTime']>;
  diagnosis_sub_category_id?: Maybe<Scalars['Int']>;
  diagnosis_sub_category_name?: Maybe<Scalars['String']>;
  diagnosis_sub_category_status?: Maybe<SettingDiagnosisSubCategoryStatus>;
  diagnosis_sub_category_updated?: Maybe<Scalars['DateTime']>;
};

export type SettingDiagnosisSubCategoryLessDetail = {
  __typename?: 'SettingDiagnosisSubCategoryLessDetail';
  diagnosis_sub_category_id?: Maybe<Scalars['Int']>;
  diagnosis_sub_category_name?: Maybe<Scalars['String']>;
};

export type SettingDiagnosisSubCategoryListingInput = {
  diagnosis_category_id?: InputMaybe<Scalars['Int']>;
  diagnosis_sub_category_status?: InputMaybe<SettingDiagnosisSubCategoryStatus>;
  keyword?: InputMaybe<Scalars['String']>;
};

/** A paginated list of SettingDiagnosisSubCategory items. */
export type SettingDiagnosisSubCategoryPaginator = {
  __typename?: 'SettingDiagnosisSubCategoryPaginator';
  /** A list of SettingDiagnosisSubCategory items. */
  data: Array<SettingDiagnosisSubCategory>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum SettingDiagnosisSubCategoryStatus {
  Active = 'active',
  Suspend = 'suspend',
}

export type SettingFaq = {
  __typename?: 'SettingFaq';
  setting_faq_description?: Maybe<Scalars['String']>;
  setting_faq_id?: Maybe<Scalars['Int']>;
  setting_faq_priority?: Maybe<Scalars['Int']>;
  setting_faq_status?: Maybe<SettingFaqStatus>;
  setting_faq_title?: Maybe<Scalars['String']>;
};

export type SettingFaqListingInput = {
  keyword?: InputMaybe<Scalars['String']>;
  setting_faq_status?: InputMaybe<SettingFaqStatus>;
};

/** A paginated list of SettingFaq items. */
export type SettingFaqPaginator = {
  __typename?: 'SettingFaqPaginator';
  /** A list of SettingFaq items. */
  data: Array<SettingFaq>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SettingFaqPublishedListingInput = {
  keyword?: InputMaybe<Scalars['String']>;
};

export enum SettingFaqStatus {
  Draft = 'draft',
  Published = 'published',
}

export type SettingIndustry = {
  __typename?: 'SettingIndustry';
  industry_created?: Maybe<Scalars['DateTime']>;
  industry_id?: Maybe<Scalars['Int']>;
  industry_name?: Maybe<Scalars['String']>;
  industry_status?: Maybe<IndustryStatus>;
  industry_updated?: Maybe<Scalars['DateTime']>;
};

export type SettingIndustryLessDetail = {
  __typename?: 'SettingIndustryLessDetail';
  industry_id?: Maybe<Scalars['Int']>;
  industry_name?: Maybe<Scalars['String']>;
};

export type SettingService = {
  __typename?: 'SettingService';
  service_created?: Maybe<Scalars['DateTime']>;
  service_id?: Maybe<Scalars['Int']>;
  service_name?: Maybe<Scalars['String']>;
  service_status?: Maybe<ServiceStatus>;
  service_updated?: Maybe<Scalars['DateTime']>;
};

export type SettingServiceLessDetail = {
  __typename?: 'SettingServiceLessDetail';
  service_id?: Maybe<Scalars['Int']>;
  service_name?: Maybe<Scalars['String']>;
};

export type SettingServiceListingInput = {
  keyword?: InputMaybe<Scalars['String']>;
  service_status?: InputMaybe<ServiceStatus>;
};

/** A paginated list of SettingService items. */
export type SettingServicePaginator = {
  __typename?: 'SettingServicePaginator';
  /** A list of SettingService items. */
  data: Array<SettingService>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SettingServiceStatusCount = {
  __typename?: 'SettingServiceStatusCount';
  service_status?: Maybe<ServiceStatus>;
  service_status_count?: Maybe<Scalars['Int']>;
};

export enum SettingSlug {
  HotlineNumber = 'hotline_number',
  ImportClient = 'import_client',
  ImportClinic = 'import_clinic',
  ImportMemberWithUsage = 'import_member_with_usage',
  ImportMemberWithoutUsage = 'import_member_without_usage',
  PrivacyPolicy = 'privacy_policy',
  TermsConditions = 'terms_conditions',
}

export type SettingStateLessDetail = {
  __typename?: 'SettingStateLessDetail';
  state_id?: Maybe<Scalars['Int']>;
  state_name?: Maybe<Scalars['String']>;
};

export enum SettingStatus {
  Draft = 'draft',
  Publish = 'publish',
}

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Number of items per page. */
  perPage: Scalars['Int'];
};

export type SocialAccount = {
  __typename?: 'SocialAccount';
  provider?: Maybe<Provider>;
  provider_email?: Maybe<Scalars['String']>;
  provider_image?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC',
}

export type State = {
  __typename?: 'State';
  state_code?: Maybe<Scalars['String']>;
  state_id?: Maybe<Scalars['Int']>;
  state_name?: Maybe<Scalars['String']>;
  state_region?: Maybe<Scalars['String']>;
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  data?: Maybe<Scalars['Json']>;
  message?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

export type SuccessResponseCheckout = {
  __typename?: 'SuccessResponseCheckout';
  claim?: Maybe<Claim>;
  message?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

export type TeamRolesInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permission_id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_type_slug?: InputMaybe<UserTypeRole>;
};

export type TeamRolesPermissionInput = {
  permission_id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  role_id?: InputMaybe<Scalars['Int']>;
};

export type TeamRolesUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  permission_id?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type TokenResponse = {
  __typename?: 'TokenResponse';
  token?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
};

export type TokenResponseWithUserId = {
  __typename?: 'TokenResponseWithUserID';
  token?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type TotalClaims = {
  __typename?: 'TotalClaims';
  number_of_claims?: Maybe<Scalars['Int']>;
  total_claims?: Maybe<Scalars['Float']>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT',
}

export type UrlResponse = {
  __typename?: 'UrlResponse';
  message?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  activity_log?: Maybe<Array<Maybe<Activity>>>;
  client?: Maybe<Client>;
  client_corporate?: Maybe<ClientCorporate>;
  clinic?: Maybe<Clinic>;
  member?: Maybe<Member>;
  user_address?: Maybe<Scalars['String']>;
  user_address2?: Maybe<Scalars['String']>;
  user_alternative_email?: Maybe<Scalars['String']>;
  user_alternative_mobile?: Maybe<Scalars['String']>;
  user_city?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['DateTime']>;
  user_department?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_dob?: Maybe<Scalars['Date']>;
  user_email?: Maybe<Scalars['String']>;
  user_email_verified_at?: Maybe<Scalars['DateTime']>;
  user_fullname?: Maybe<Scalars['String']>;
  user_gender?: Maybe<Gender>;
  user_id?: Maybe<Scalars['Int']>;
  user_logindate?: Maybe<Scalars['DateTime']>;
  user_mobile?: Maybe<Scalars['String']>;
  user_mobile_verified_at?: Maybe<Scalars['DateTime']>;
  user_nationality?: Maybe<Scalars['String']>;
  user_no?: Maybe<Scalars['String']>;
  user_notification?: Maybe<UserNotification>;
  user_nric?: Maybe<Scalars['String']>;
  user_postcode?: Maybe<Scalars['String']>;
  user_profile_photo?: Maybe<Images>;
  user_role?: Maybe<Role>;
  user_state?: Maybe<Scalars['Int']>;
  user_status?: Maybe<UserStatus>;
  user_type?: Maybe<UserType>;
  user_updated?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type UserAddressUpdateInput = {
  user_address?: InputMaybe<Scalars['String']>;
  user_address2?: InputMaybe<Scalars['String']>;
  user_city?: InputMaybe<Scalars['Int']>;
  user_postcode?: InputMaybe<Scalars['String']>;
  user_state?: InputMaybe<Scalars['Int']>;
};

export type UserCauser = {
  __typename?: 'UserCauser';
  user_address?: Maybe<Scalars['String']>;
  user_address2?: Maybe<Scalars['String']>;
  user_alternative_email?: Maybe<Scalars['String']>;
  user_alternative_mobile?: Maybe<Scalars['String']>;
  user_city?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['DateTime']>;
  user_department?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_dob?: Maybe<Scalars['Date']>;
  user_email?: Maybe<Scalars['String']>;
  user_email_verified_at?: Maybe<Scalars['DateTime']>;
  user_fullname?: Maybe<Scalars['String']>;
  user_gender?: Maybe<Gender>;
  user_id?: Maybe<Scalars['Int']>;
  user_logindate?: Maybe<Scalars['DateTime']>;
  user_mobile?: Maybe<Scalars['String']>;
  user_mobile_verified_at?: Maybe<Scalars['DateTime']>;
  user_nationality?: Maybe<Scalars['String']>;
  user_no?: Maybe<Scalars['String']>;
  user_nric?: Maybe<Scalars['String']>;
  user_postcode?: Maybe<Scalars['String']>;
  user_profile_photo?: Maybe<Images>;
  user_state?: Maybe<Scalars['Int']>;
  user_status?: Maybe<UserStatus>;
  user_type?: Maybe<UserType>;
  user_updated?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

export type UserCreateInput = {
  password?: InputMaybe<Scalars['String']>;
  user_dob?: InputMaybe<Scalars['Date']>;
  user_email?: InputMaybe<Scalars['String']>;
  user_fullname?: InputMaybe<Scalars['String']>;
  user_gender?: InputMaybe<Gender>;
  user_nric?: InputMaybe<Scalars['String']>;
  user_type?: InputMaybe<UserTypeSlug>;
  username?: InputMaybe<Scalars['String']>;
};

export type UserDobInput = {
  user_dob?: InputMaybe<Scalars['Date']>;
};

export type UserDescriptionUpdateInput = {
  user_description?: InputMaybe<Scalars['String']>;
};

export type UserFullnameUpdateInput = {
  user_fullname?: InputMaybe<Scalars['String']>;
};

export type UserHasRoles = {
  __typename?: 'UserHasRoles';
  activity_log?: Maybe<Array<Maybe<Activity>>>;
  client?: Maybe<Client>;
  clinic?: Maybe<Clinic>;
  user_address?: Maybe<Scalars['String']>;
  user_address2?: Maybe<Scalars['String']>;
  user_alternative_email?: Maybe<Scalars['String']>;
  user_alternative_mobile?: Maybe<Scalars['String']>;
  user_city?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['DateTime']>;
  user_department?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_dob?: Maybe<Scalars['Date']>;
  user_email?: Maybe<Scalars['String']>;
  user_email_verified_at?: Maybe<Scalars['DateTime']>;
  user_fullname?: Maybe<Scalars['String']>;
  user_gender?: Maybe<Gender>;
  user_id?: Maybe<Scalars['Int']>;
  user_logindate?: Maybe<Scalars['DateTime']>;
  user_mobile?: Maybe<Scalars['String']>;
  user_mobile_verified_at?: Maybe<Scalars['DateTime']>;
  user_nationality?: Maybe<Scalars['String']>;
  user_no?: Maybe<Scalars['String']>;
  user_nric?: Maybe<Scalars['String']>;
  user_postcode?: Maybe<Scalars['String']>;
  user_profile_photo?: Maybe<Images>;
  user_role?: Maybe<Role>;
  user_state?: Maybe<Scalars['Int']>;
  user_status?: Maybe<UserStatus>;
  user_type?: Maybe<UserType>;
  user_updated?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
};

/** A paginated list of UserHasRoles items. */
export type UserHasRolesPaginator = {
  __typename?: 'UserHasRolesPaginator';
  /** A list of UserHasRoles items. */
  data: Array<UserHasRoles>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UserListing = {
  __typename?: 'UserListing';
  user_address_1?: Maybe<Scalars['String']>;
  user_address_2?: Maybe<Scalars['String']>;
  user_alternative_email?: Maybe<Scalars['String']>;
  user_alternative_mobile?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['DateTime']>;
  user_department?: Maybe<Scalars['String']>;
  user_description?: Maybe<Scalars['String']>;
  user_dob?: Maybe<Scalars['Date']>;
  user_email?: Maybe<Scalars['String']>;
  user_email_verified_at?: Maybe<Scalars['DateTime']>;
  user_fullname?: Maybe<Scalars['String']>;
  user_gender?: Maybe<Gender>;
  user_id?: Maybe<Scalars['Int']>;
  user_logindate?: Maybe<Scalars['DateTime']>;
  user_mobile?: Maybe<Scalars['String']>;
  user_mobile_verified_at?: Maybe<Scalars['DateTime']>;
  user_nric?: Maybe<Scalars['String']>;
  user_postcode?: Maybe<Scalars['String']>;
  user_status?: Maybe<UserStatus>;
  user_type?: Maybe<UserType>;
  user_updated?: Maybe<Scalars['DateTime']>;
};

export type UserListingInput = {
  keyword?: InputMaybe<Scalars['String']>;
  user_gender?: InputMaybe<Gender>;
  user_status?: InputMaybe<UserStatus>;
  user_type?: InputMaybe<UserTypeSlug>;
};

export type UserMobileUpdateInput = {
  tac_no?: InputMaybe<Scalars['String']>;
  user_mobile?: InputMaybe<Scalars['String']>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  notification_count?: Maybe<Scalars['Int']>;
  notification_new?: Maybe<Scalars['Boolean']>;
};

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum UserStatus {
  Active = 'active',
  Suspend = 'suspend',
}

export type UserType = {
  __typename?: 'UserType';
  user_type_id?: Maybe<Scalars['Int']>;
  user_type_name?: Maybe<Scalars['String']>;
  user_type_slug?: Maybe<Scalars['String']>;
};

export type UserTypeLessDetail = {
  __typename?: 'UserTypeLessDetail';
  user_type_name?: Maybe<Scalars['String']>;
  user_type_slug?: Maybe<Scalars['String']>;
};

export enum UserTypeRole {
  Admin = 'admin',
  Client = 'client',
  Clinic = 'clinic',
}

export enum UserTypeSlug {
  Admin = 'admin',
  Client = 'client',
  Clinic = 'clinic',
  Member = 'member',
}

export type UserUpdateEmailInput = {
  user_alternative_email?: InputMaybe<Scalars['String']>;
  user_email?: InputMaybe<Scalars['String']>;
};

export type UserUpdatePasswordInput = {
  confirm_password?: InputMaybe<Scalars['String']>;
  current_password?: InputMaybe<Scalars['String']>;
  new_password?: InputMaybe<Scalars['String']>;
};

export type WeeklyClaimsAmount = {
  __typename?: 'WeeklyClaimsAmount';
  claims?: Maybe<Array<Maybe<Claims>>>;
  total_claims_amount?: Maybe<Scalars['Float']>;
};

export type AdminListingQueryVariables = Exact<{
  input?: InputMaybe<AdminListingInput>;
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;

export type AdminListingQuery = {
  __typename?: 'Query';
  AdminListing?: {
    __typename?: 'UserHasRolesPaginator';
    data: Array<{
      __typename?: 'UserHasRoles';
      user_id?: number | null;
      user_no?: string | null;
      username?: string | null;
      user_email?: string | null;
      user_mobile?: string | null;
      user_fullname?: string | null;
      user_gender?: Gender | null;
      user_address?: string | null;
      user_address2?: string | null;
      user_nric?: string | null;
      user_dob?: any | null;
      user_city?: number | null;
      user_state?: number | null;
      user_postcode?: string | null;
      user_department?: string | null;
      user_created?: any | null;
      user_status?: UserStatus | null;
      user_profile_photo?: {
        __typename?: 'Images';
        media_id?: number | null;
        full?: string | null;
        thumb?: string | null;
      } | null;
      user_type?: {
        __typename?: 'UserType';
        user_type_id?: number | null;
        user_type_name?: string | null;
        user_type_slug?: string | null;
      } | null;
      user_role?: {
        __typename?: 'Role';
        id?: number | null;
        name?: string | null;
        guard_name?: string | null;
        user_type_slug?: UserTypeRole | null;
        description?: string | null;
        status?: RolesStatus | null;
        permissions?: Array<{
          __typename?: 'Permission';
          id?: number | null;
          name?: string | null;
          group_name?: string | null;
          display_name?: string | null;
          user_type_slug?: string | null;
        } | null> | null;
      } | null;
      clinic?: {
        __typename?: 'Clinic';
        clinic_id?: number | null;
        clinic_name?: string | null;
        clinic_number?: string | null;
      } | null;
      client?: {
        __typename?: 'Client';
        client_id?: number | null;
        client_name?: string | null;
        client_number?: string | null;
      } | null;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
  } | null;
  AdminStatusCount?: Array<{
    __typename?: 'AdminStatusCount';
    admin_status_name?: string | null;
    admin_status_count?: number | null;
  } | null> | null;
};

export type AdminDetailQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['Int']>;
}>;

export type AdminDetailQuery = {
  __typename?: 'Query';
  AdminDetail?: {
    __typename?: 'UserHasRoles';
    user_id?: number | null;
    user_no?: string | null;
    username?: string | null;
    user_email?: string | null;
    user_mobile?: string | null;
    user_fullname?: string | null;
    user_gender?: Gender | null;
    user_address?: string | null;
    user_address2?: string | null;
    user_nric?: string | null;
    user_dob?: any | null;
    user_city?: number | null;
    user_state?: number | null;
    user_postcode?: string | null;
    user_department?: string | null;
    user_created?: any | null;
    user_status?: UserStatus | null;
    user_profile_photo?: {
      __typename?: 'Images';
      media_id?: number | null;
      full?: string | null;
      thumb?: string | null;
    } | null;
    user_type?: {
      __typename?: 'UserType';
      user_type_id?: number | null;
      user_type_name?: string | null;
      user_type_slug?: string | null;
    } | null;
    user_role?: {
      __typename?: 'Role';
      id?: number | null;
      name?: string | null;
      guard_name?: string | null;
      user_type_slug?: UserTypeRole | null;
      description?: string | null;
      status?: RolesStatus | null;
      permissions?: Array<{
        __typename?: 'Permission';
        id?: number | null;
        name?: string | null;
        group_name?: string | null;
        display_name?: string | null;
        user_type_slug?: string | null;
      } | null> | null;
    } | null;
    clinic?: {
      __typename?: 'Clinic';
      clinic_id?: number | null;
      clinic_name?: string | null;
      clinic_number?: string | null;
    } | null;
    client?: {
      __typename?: 'Client';
      client_id?: number | null;
      client_name?: string | null;
      client_number?: string | null;
    } | null;
  } | null;
};

export type AdminRolesListingQueryVariables = Exact<{
  input?: InputMaybe<AdminRolesInputListingQuery>;
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;

export type AdminRolesListingQuery = {
  __typename?: 'Query';
  AdminRolesListing?: {
    __typename?: 'RolePaginator';
    data: Array<{
      __typename?: 'Role';
      id?: number | null;
      name?: string | null;
      team_id?: number | null;
      guard_name?: string | null;
      user_type_slug?: UserTypeRole | null;
      description?: string | null;
      status?: RolesStatus | null;
      permissions?: Array<{
        __typename?: 'Permission';
        id?: number | null;
        name?: string | null;
        group_name?: string | null;
        display_name?: string | null;
        user_type_slug?: string | null;
      } | null> | null;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
  } | null;
  AdminRolesStatusCount?: Array<{
    __typename?: 'RoleStatusCount';
    role_status_name?: string | null;
    role_status_count?: number | null;
  } | null> | null;
};

export type AdminPermissionListingQueryVariables = Exact<{
  user_type_slug?: InputMaybe<UserTypeRole>;
}>;

export type AdminPermissionListingQuery = {
  __typename?: 'Query';
  AdminPermissionListing?: Array<{
    __typename?: 'Permission';
    id?: number | null;
    name?: string | null;
    group_name?: string | null;
    display_name?: string | null;
    user_type_slug?: string | null;
  } | null> | null;
};

export type AdminStatusCountQueryVariables = Exact<{
  input?: InputMaybe<AdminListingInput>;
}>;

export type AdminStatusCountQuery = {
  __typename?: 'Query';
  AdminStatusCount?: Array<{
    __typename?: 'AdminStatusCount';
    admin_status_name?: string | null;
    admin_status_count?: number | null;
  } | null> | null;
};

export type AdminRolesStatusCountQueryVariables = Exact<{
  input?: InputMaybe<AdminRolesInputListingQuery>;
}>;

export type AdminRolesStatusCountQuery = {
  __typename?: 'Query';
  AdminRolesStatusCount?: Array<{
    __typename?: 'RoleStatusCount';
    role_status_name?: string | null;
    role_status_count?: number | null;
  } | null> | null;
};

export type AdminRolesDetailQueryVariables = Exact<{
  role_id?: InputMaybe<Scalars['Int']>;
}>;

export type AdminRolesDetailQuery = {
  __typename?: 'Query';
  AdminRolesDetail?: {
    __typename?: 'Role';
    id?: number | null;
    name?: string | null;
    team_id?: number | null;
    guard_name?: string | null;
    user_type_slug?: UserTypeRole | null;
    description?: string | null;
    status?: RolesStatus | null;
    permissions?: Array<{
      __typename?: 'Permission';
      id?: number | null;
      name?: string | null;
      group_name?: string | null;
      display_name?: string | null;
      user_type_slug?: string | null;
    } | null> | null;
  } | null;
};

export type AdminTeamRolesCreateMutationVariables = Exact<{
  input?: InputMaybe<TeamRolesInput>;
}>;

export type AdminTeamRolesCreateMutation = {
  __typename?: 'Mutation';
  AdminTeamRolesCreate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type AdminTeamRolesUpdateMutationVariables = Exact<{
  input?: InputMaybe<TeamRolesUpdateInput>;
}>;

export type AdminTeamRolesUpdateMutation = {
  __typename?: 'Mutation';
  AdminTeamRolesUpdate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type AdminTeamRolesSuspendMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;

export type AdminTeamRolesSuspendMutation = {
  __typename?: 'Mutation';
  AdminTeamRolesSuspend?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type AdminTeamRolesActivateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;

export type AdminTeamRolesActivateMutation = {
  __typename?: 'Mutation';
  AdminTeamRolesActivate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type AdminCreateMutationVariables = Exact<{
  input?: InputMaybe<AdminCreateInput>;
}>;

export type AdminCreateMutation = {
  __typename?: 'Mutation';
  AdminCreate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type AdminUpdateMutationVariables = Exact<{
  input?: InputMaybe<AdminUpdateInput>;
}>;

export type AdminUpdateMutation = {
  __typename?: 'Mutation';
  AdminUpdate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type AdminDeleteMutationVariables = Exact<{
  user_id?: InputMaybe<Scalars['Int']>;
}>;

export type AdminDeleteMutation = {
  __typename?: 'Mutation';
  AdminDelete?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type AdminSuspendMutationVariables = Exact<{
  user_id?: InputMaybe<Scalars['Int']>;
}>;

export type AdminSuspendMutation = {
  __typename?: 'Mutation';
  AdminSuspend?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type AdminActivateMutationVariables = Exact<{
  user_id?: InputMaybe<Scalars['Int']>;
}>;

export type AdminActivateMutation = {
  __typename?: 'Mutation';
  AdminActivate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type BulkManagementListingQueryVariables = Exact<{
  input?: InputMaybe<BulkManagementListingInput>;
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;

export type BulkManagementListingQuery = {
  __typename?: 'Query';
  BulkManagementListing?: {
    __typename?: 'BulkManagementPaginator';
    data: Array<{
      __typename?: 'BulkManagement';
      bulk_management_id?: number | null;
      bulk_management_module?: string | null;
      bulk_management_type?: BulkManagementType | null;
      bulk_management_status?: BulkManagementStatus | null;
      bulk_management_created?: any | null;
      bulk_management_updated?: any | null;
      bulk_management_media?: {
        __typename?: 'MediaData';
        media_url?: string | null;
        media_name?: string | null;
        media_type?: string | null;
      } | null;
      user?: {
        __typename?: 'User';
        user_id?: number | null;
        username?: string | null;
        user_email?: string | null;
        user_mobile?: string | null;
        user_fullname?: string | null;
        user_gender?: Gender | null;
        user_nric?: string | null;
        user_nationality?: string | null;
        user_address?: string | null;
        user_address2?: string | null;
        user_dob?: any | null;
        user_postcode?: string | null;
        user_status?: UserStatus | null;
        user_logindate?: any | null;
        user_description?: string | null;
        user_state?: number | null;
        user_city?: number | null;
        user_profile_photo?: {
          __typename?: 'Images';
          media_id?: number | null;
          full?: string | null;
          thumb?: string | null;
        } | null;
        user_type?: {
          __typename?: 'UserType';
          user_type_id?: number | null;
          user_type_name?: string | null;
          user_type_slug?: string | null;
        } | null;
        clinic?: {
          __typename?: 'Clinic';
          clinic_id?: number | null;
          clinic_number?: string | null;
          clinic_logo?: string | null;
          clinic_name?: string | null;
          clinic_image?: string | null;
          clinic_overall_rating?: number | null;
        } | null;
        user_role?: {
          __typename?: 'Role';
          id?: number | null;
          name?: string | null;
          team_id?: number | null;
          guard_name?: string | null;
          user_type_slug?: UserTypeRole | null;
          description?: string | null;
          status?: RolesStatus | null;
          permissions?: Array<{
            __typename?: 'Permission';
            id?: number | null;
            name?: string | null;
            group_name?: string | null;
            display_name?: string | null;
            user_type_slug?: string | null;
          } | null> | null;
          client?: {
            __typename?: 'Client';
            client_id?: number | null;
            client_name?: string | null;
            client_number?: string | null;
            client_diagnosis_exclusion_file?: string | null;
          } | null;
          clinic?: {
            __typename?: 'Clinic';
            clinic_id?: number | null;
            clinic_name?: string | null;
            clinic_number?: string | null;
            clinic_overall_rating?: number | null;
            ongoing_session_count?: number | null;
            setting_clinic_category?: {
              __typename?: 'SettingClinicCategory';
              setting_clinic_category_id: number;
              setting_clinic_category_name: string;
            } | null;
          } | null;
        } | null;
      } | null;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
  } | null;
};

export type BulkManagementFragment = {
  __typename?: 'BulkManagement';
  bulk_management_id?: number | null;
  bulk_management_module?: string | null;
  bulk_management_type?: BulkManagementType | null;
  bulk_management_status?: BulkManagementStatus | null;
  bulk_management_created?: any | null;
  bulk_management_updated?: any | null;
  bulk_management_media?: {
    __typename?: 'MediaData';
    media_url?: string | null;
    media_name?: string | null;
    media_type?: string | null;
  } | null;
  user?: {
    __typename?: 'User';
    user_id?: number | null;
    username?: string | null;
    user_email?: string | null;
    user_mobile?: string | null;
    user_fullname?: string | null;
    user_gender?: Gender | null;
    user_nric?: string | null;
    user_nationality?: string | null;
    user_address?: string | null;
    user_address2?: string | null;
    user_dob?: any | null;
    user_postcode?: string | null;
    user_status?: UserStatus | null;
    user_logindate?: any | null;
    user_description?: string | null;
    user_state?: number | null;
    user_city?: number | null;
    user_profile_photo?: {
      __typename?: 'Images';
      media_id?: number | null;
      full?: string | null;
      thumb?: string | null;
    } | null;
    user_type?: {
      __typename?: 'UserType';
      user_type_id?: number | null;
      user_type_name?: string | null;
      user_type_slug?: string | null;
    } | null;
    clinic?: {
      __typename?: 'Clinic';
      clinic_id?: number | null;
      clinic_number?: string | null;
      clinic_logo?: string | null;
      clinic_name?: string | null;
      clinic_image?: string | null;
      clinic_overall_rating?: number | null;
    } | null;
    user_role?: {
      __typename?: 'Role';
      id?: number | null;
      name?: string | null;
      team_id?: number | null;
      guard_name?: string | null;
      user_type_slug?: UserTypeRole | null;
      description?: string | null;
      status?: RolesStatus | null;
      permissions?: Array<{
        __typename?: 'Permission';
        id?: number | null;
        name?: string | null;
        group_name?: string | null;
        display_name?: string | null;
        user_type_slug?: string | null;
      } | null> | null;
      client?: {
        __typename?: 'Client';
        client_id?: number | null;
        client_name?: string | null;
        client_number?: string | null;
        client_diagnosis_exclusion_file?: string | null;
      } | null;
      clinic?: {
        __typename?: 'Clinic';
        clinic_id?: number | null;
        clinic_name?: string | null;
        clinic_number?: string | null;
        clinic_overall_rating?: number | null;
        ongoing_session_count?: number | null;
        setting_clinic_category?: {
          __typename?: 'SettingClinicCategory';
          setting_clinic_category_id: number;
          setting_clinic_category_name: string;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type ClinicClientDropdownQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ClinicClientDropdownQuery = {
  __typename?: 'Query';
  ClinicClientDropdown?: Array<{
    __typename?: 'ClientLessDetail';
    client_id?: number | null;
    client_name?: string | null;
  } | null> | null;
};

export type ClientDropdownQueryVariables = Exact<{
  member_staff_no?: InputMaybe<Scalars['String']>;
}>;

export type ClientDropdownQuery = {
  __typename?: 'Query';
  ClientDropdown?: Array<{
    __typename?: 'ClientLessDetail';
    client_id?: number | null;
    client_name?: string | null;
  } | null> | null;
};

export type ClientCorporateDropdownQueryVariables = Exact<{
  client_id?: InputMaybe<Scalars['Int']>;
}>;

export type ClientCorporateDropdownQuery = {
  __typename?: 'Query';
  ClientCorporateDropdown?: Array<{
    __typename?: 'ClientCorporateLessDetail';
    client_corporate_id?: number | null;
    client_corporate_name?: string | null;
  } | null> | null;
};

export type SettingDiagnosisDropdownQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SettingDiagnosisDropdownQuery = {
  __typename?: 'Query';
  SettingDiagnosisDropdown?: Array<{
    __typename?: 'SettingDiagnosisLessDetail';
    diagnosis_id?: number | null;
    diagnosis_name?: string | null;
    diagnosis_code?: string | null;
  } | null> | null;
};

export type SettingServiceDropdownQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SettingServiceDropdownQuery = {
  __typename?: 'Query';
  SettingServiceDropdown?: Array<{
    __typename?: 'SettingServiceLessDetail';
    service_id?: number | null;
    service_name?: string | null;
  } | null> | null;
};

export type SettingStateDropdownQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SettingStateDropdownQuery = {
  __typename?: 'Query';
  SettingStateDropdown?: Array<{
    __typename?: 'SettingStateLessDetail';
    state_id?: number | null;
    state_name?: string | null;
  } | null> | null;
};

export type SettingCityDropdownQueryVariables = Exact<{
  state_id?: InputMaybe<Scalars['Int']>;
}>;

export type SettingCityDropdownQuery = {
  __typename?: 'Query';
  SettingCityDropdown?: Array<{
    __typename?: 'SettingCity';
    city_id: number;
    city_name: string;
  } | null> | null;
};

export type AdminRolesDropdownQueryVariables = Exact<{
  input?: InputMaybe<AdminRolesInputQuery>;
}>;

export type AdminRolesDropdownQuery = {
  __typename?: 'Query';
  AdminRolesDropdown?: Array<{
    __typename?: 'RoleLessDetail';
    id?: number | null;
    name?: string | null;
  } | null> | null;
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  __typename?: 'Query';
  Me?: {
    __typename?: 'User';
    user_id?: number | null;
    username?: string | null;
    user_email?: string | null;
    user_mobile?: string | null;
    user_fullname?: string | null;
    user_gender?: Gender | null;
    user_nric?: string | null;
    user_nationality?: string | null;
    user_address?: string | null;
    user_address2?: string | null;
    user_dob?: any | null;
    user_postcode?: string | null;
    user_status?: UserStatus | null;
    user_logindate?: any | null;
    user_description?: string | null;
    user_state?: number | null;
    user_city?: number | null;
    user_profile_photo?: {
      __typename?: 'Images';
      media_id?: number | null;
      full?: string | null;
      thumb?: string | null;
    } | null;
    user_type?: {
      __typename?: 'UserType';
      user_type_id?: number | null;
      user_type_name?: string | null;
      user_type_slug?: string | null;
    } | null;
    clinic?: {
      __typename?: 'Clinic';
      clinic_id?: number | null;
      clinic_number?: string | null;
      clinic_logo?: string | null;
      clinic_name?: string | null;
      clinic_image?: string | null;
      clinic_overall_rating?: number | null;
    } | null;
    user_role?: {
      __typename?: 'Role';
      id?: number | null;
      name?: string | null;
      team_id?: number | null;
      guard_name?: string | null;
      user_type_slug?: UserTypeRole | null;
      description?: string | null;
      status?: RolesStatus | null;
      permissions?: Array<{
        __typename?: 'Permission';
        id?: number | null;
        name?: string | null;
        group_name?: string | null;
        display_name?: string | null;
        user_type_slug?: string | null;
      } | null> | null;
      client?: {
        __typename?: 'Client';
        client_id?: number | null;
        client_name?: string | null;
        client_number?: string | null;
        client_diagnosis_exclusion_file?: string | null;
      } | null;
      clinic?: {
        __typename?: 'Clinic';
        clinic_id?: number | null;
        clinic_name?: string | null;
        clinic_number?: string | null;
        clinic_overall_rating?: number | null;
        ongoing_session_count?: number | null;
        setting_clinic_category?: {
          __typename?: 'SettingClinicCategory';
          setting_clinic_category_id: number;
          setting_clinic_category_name: string;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type LoginMutationVariables = Exact<{
  input?: InputMaybe<LoginInput>;
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  Login?: {
    __typename?: 'TokenResponse';
    token?: string | null;
    token_type?: string | null;
  } | null;
};

export type ResetPasswordSendEmailMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;

export type ResetPasswordSendEmailMutation = {
  __typename?: 'Mutation';
  ResetPasswordSendEmail?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type ResetPasswordCheckMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
}>;

export type ResetPasswordCheckMutation = {
  __typename?: 'Mutation';
  ResetPasswordCheck?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type ResetPasswordMutationVariables = Exact<{
  input?: InputMaybe<ResetPasswordInput>;
}>;

export type ResetPasswordMutation = {
  __typename?: 'Mutation';
  ResetPassword?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type SessionListingQueryVariables = Exact<{
  input?: InputMaybe<SessionListingInput>;
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;

export type SessionListingQuery = {
  __typename?: 'Query';
  SessionListing?: {
    __typename?: 'SessionPaginator';
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
    data: Array<{
      __typename?: 'Session';
      session_id?: number | null;
      session_created?: any | null;
      clinic_patient?: {
        __typename?: 'Patient';
        clinic_patient_no?: string | null;
        clinic_patient_name?: string | null;
        clinic_patient_dob?: any | null;
        clinic_patient_nric?: string | null;
        clinic_patient_nric_type?: NricType | null;
        clinic_patient_gender?: Gender | null;
        is_dependent?: boolean | null;
        dependent?: {
          __typename?: 'Dependent';
          dependent_id?: number | null;
          dependent_name?: string | null;
          dependent_dob?: any | null;
          dependent_nric?: string | null;
          dependent_gender?: Gender | null;
          dependent_joined_date?: any | null;
          dependent_relationship?: string | null;
          dependent_status?: DependentStatus | null;
          dependent_mobile?: string | null;
          dependent_email?: string | null;
          member_id?: number | null;
        } | null;
      } | null;
      member?: {
        __typename?: 'Member';
        member_no?: string | null;
        member_id?: number | null;
        member_name?: string | null;
        member_position?: string | null;
        member_department?: string | null;
        member_nric?: string | null;
        member_gender?: Gender | null;
        member_dob?: any | null;
        member_joined_date?: any | null;
        card_no?: string | null;
        member_mobile?: string | null;
        member_email?: string | null;
        member_remark?: string | null;
        member_clinic_remark?: string | null;
        dependent?: Array<{
          __typename?: 'Dependent';
          dependent_id?: number | null;
          dependent_name?: string | null;
          dependent_dob?: any | null;
          dependent_nric?: string | null;
          dependent_gender?: Gender | null;
          dependent_joined_date?: any | null;
          dependent_relationship?: string | null;
          dependent_status?: DependentStatus | null;
          dependent_mobile?: string | null;
          dependent_email?: string | null;
          member_id?: number | null;
        } | null> | null;
        member_balance?: Array<{
          __typename?: 'MemberBalance';
          member_balance_id?: number | null;
          member_id?: number | null;
          setting_benefit_plan_id?: number | null;
          benefit_plan_year?: number | null;
          member_balance_remaining?: number | null;
          member_balance_status?: MemberBalanceStatus | null;
        } | null> | null;
        member_active_balance?: {
          __typename?: 'MemberBalance';
          member_balance_id?: number | null;
          member_id?: number | null;
          setting_benefit_plan_id?: number | null;
          benefit_plan_year?: number | null;
          member_balance_remaining?: number | null;
          member_balance_status?: MemberBalanceStatus | null;
        } | null;
        setting_benefit_plan?: {
          __typename?: 'SettingBenefitPlan';
          setting_benefit_plan_id?: number | null;
          setting_benefit_plan_name?: string | null;
          setting_benefit_plan_amount?: number | null;
          setting_benefit_plan_created?: any | null;
          setting_benefit_plan_updated?: any | null;
          benefit_plan_clinic_category?: Array<{
            __typename?: 'SettingClinicCategoryAmount';
            setting_clinic_category_id: number;
            setting_clinic_category_name: string;
            amount_per_visit?: number | null;
          } | null> | null;
        } | null;
        client?: {
          __typename?: 'Client';
          client_id?: number | null;
          client_name?: string | null;
          client_number?: string | null;
          client_diagnosis_exclusion_file?: string | null;
        } | null;
        client_corporate?: {
          __typename?: 'ClientCorporate';
          client_corporate_name?: string | null;
          client_corporate_number?: string | null;
        } | null;
        client_branch?: {
          __typename?: 'ClientBranch';
          client_branch_name?: string | null;
          client_branch_number?: string | null;
        } | null;
      } | null;
      session_status?: {
        __typename?: 'SessionStatus';
        session_status_id?: number | null;
        session_status_name?: string | null;
        session_status_slug?: string | null;
      } | null;
      claim?: {
        __typename?: 'Claim';
        claim_number?: string | null;
        claim_created?: any | null;
      } | null;
    }>;
  } | null;
  SessionStatusCount?: Array<{
    __typename?: 'SessionStatusCount';
    session_status_count?: number | null;
    session_status_name?: string | null;
    session_status_slug?: string | null;
  } | null> | null;
};

export type SessionStatusCountQueryVariables = Exact<{
  input?: InputMaybe<SessionListingInput>;
}>;

export type SessionStatusCountQuery = {
  __typename?: 'Query';
  SessionStatusCount?: Array<{
    __typename?: 'SessionStatusCount';
    session_status_count?: number | null;
    session_status_name?: string | null;
    session_status_slug?: string | null;
  } | null> | null;
};

export type SessionCancelMutationVariables = Exact<{
  input?: InputMaybe<SessionCancelInput>;
}>;

export type SessionCancelMutation = {
  __typename?: 'Mutation';
  SessionCancel?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type PatientDetailQueryVariables = Exact<{
  input?: InputMaybe<PatientDetailInput>;
}>;

export type PatientDetailQuery = {
  __typename?: 'Query';
  PatientDetail?: {
    __typename?: 'PatientDetails';
    patient?: {
      __typename?: 'Patient';
      clinic_patient_no?: string | null;
      clinic_patient_name?: string | null;
      clinic_patient_dob?: any | null;
      clinic_patient_nric?: string | null;
      clinic_patient_nric_type?: NricType | null;
      clinic_patient_gender?: Gender | null;
      is_dependent?: boolean | null;
      dependent?: {
        __typename?: 'Dependent';
        dependent_id?: number | null;
        dependent_name?: string | null;
        dependent_dob?: any | null;
        dependent_nric?: string | null;
        dependent_gender?: Gender | null;
        dependent_joined_date?: any | null;
        dependent_relationship?: string | null;
        dependent_status?: DependentStatus | null;
        dependent_mobile?: string | null;
        dependent_email?: string | null;
        member_id?: number | null;
      } | null;
    } | null;
    member?: {
      __typename?: 'Member';
      member_no?: string | null;
      member_id?: number | null;
      member_name?: string | null;
      member_position?: string | null;
      member_department?: string | null;
      member_nric?: string | null;
      member_gender?: Gender | null;
      member_dob?: any | null;
      member_joined_date?: any | null;
      card_no?: string | null;
      member_mobile?: string | null;
      member_email?: string | null;
      member_remark?: string | null;
      member_clinic_remark?: string | null;
      dependent?: Array<{
        __typename?: 'Dependent';
        dependent_id?: number | null;
        dependent_name?: string | null;
        dependent_dob?: any | null;
        dependent_nric?: string | null;
        dependent_gender?: Gender | null;
        dependent_joined_date?: any | null;
        dependent_relationship?: string | null;
        dependent_status?: DependentStatus | null;
        dependent_mobile?: string | null;
        dependent_email?: string | null;
        member_id?: number | null;
      } | null> | null;
      member_balance?: Array<{
        __typename?: 'MemberBalance';
        member_balance_id?: number | null;
        member_id?: number | null;
        setting_benefit_plan_id?: number | null;
        benefit_plan_year?: number | null;
        member_balance_remaining?: number | null;
        member_balance_status?: MemberBalanceStatus | null;
      } | null> | null;
      member_active_balance?: {
        __typename?: 'MemberBalance';
        member_balance_id?: number | null;
        member_id?: number | null;
        setting_benefit_plan_id?: number | null;
        benefit_plan_year?: number | null;
        member_balance_remaining?: number | null;
        member_balance_status?: MemberBalanceStatus | null;
      } | null;
      setting_benefit_plan?: {
        __typename?: 'SettingBenefitPlan';
        setting_benefit_plan_id?: number | null;
        setting_benefit_plan_name?: string | null;
        setting_benefit_plan_amount?: number | null;
        setting_benefit_plan_created?: any | null;
        setting_benefit_plan_updated?: any | null;
        benefit_plan_clinic_category?: Array<{
          __typename?: 'SettingClinicCategoryAmount';
          setting_clinic_category_id: number;
          setting_clinic_category_name: string;
          amount_per_visit?: number | null;
        } | null> | null;
      } | null;
      client?: {
        __typename?: 'Client';
        client_id?: number | null;
        client_name?: string | null;
        client_number?: string | null;
        client_diagnosis_exclusion_file?: string | null;
      } | null;
      client_corporate?: {
        __typename?: 'ClientCorporate';
        client_corporate_name?: string | null;
        client_corporate_number?: string | null;
      } | null;
      client_branch?: {
        __typename?: 'ClientBranch';
        client_branch_name?: string | null;
        client_branch_number?: string | null;
      } | null;
    } | null;
    client?: {
      __typename?: 'Client';
      client_id?: number | null;
      client_name?: string | null;
      client_number?: string | null;
      client_diagnosis_exclusion_file?: string | null;
    } | null;
    client_corporate?: {
      __typename?: 'ClientCorporate';
      client_corporate_name?: string | null;
      client_corporate_number?: string | null;
    } | null;
    client_branch?: {
      __typename?: 'ClientBranch';
      client_branch_name?: string | null;
      client_branch_number?: string | null;
    } | null;
    clinic?: {
      __typename?: 'Clinic';
      clinic_id?: number | null;
      clinic_name?: string | null;
      clinic_number?: string | null;
      clinic_overall_rating?: number | null;
      ongoing_session_count?: number | null;
      setting_clinic_category?: {
        __typename?: 'SettingClinicCategory';
        setting_clinic_category_id: number;
        setting_clinic_category_name: string;
      } | null;
    } | null;
  } | null;
};

export type SessionCreateMutationVariables = Exact<{
  input?: InputMaybe<SessionCreateInput>;
}>;

export type SessionCreateMutation = {
  __typename?: 'Mutation';
  SessionCreate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type SessionCheckoutMutationVariables = Exact<{
  input?: InputMaybe<SessionCheckoutInput>;
}>;

export type SessionCheckoutMutation = {
  __typename?: 'Mutation';
  SessionCheckout?: {
    __typename?: 'SuccessResponseCheckout';
    status: boolean;
    message?: string | null;
    claim?: {
      __typename?: 'Claim';
      claim_id?: number | null;
      claim_number?: string | null;
      total_medication?: number | null;
      total_service?: number | null;
      total_amount?: number | null;
      claim_incurred?: number | null;
      claim_approved?: number | null;
      claim_not_approved?: number | null;
      claim_declined?: number | null;
      reject_reason?: string | null;
      claim_created?: any | null;
      claim_updated?: any | null;
      clinic_patient?: {
        __typename?: 'Patient';
        clinic_patient_no?: string | null;
        clinic_patient_name?: string | null;
        clinic_patient_dob?: any | null;
        clinic_patient_nric?: string | null;
        clinic_patient_nric_type?: NricType | null;
        clinic_patient_gender?: Gender | null;
        is_dependent?: boolean | null;
        dependent?: {
          __typename?: 'Dependent';
          dependent_id?: number | null;
          dependent_name?: string | null;
          dependent_dob?: any | null;
          dependent_nric?: string | null;
          dependent_gender?: Gender | null;
          dependent_joined_date?: any | null;
          dependent_relationship?: string | null;
          dependent_status?: DependentStatus | null;
          dependent_mobile?: string | null;
          dependent_email?: string | null;
          member_id?: number | null;
        } | null;
      } | null;
      member?: {
        __typename?: 'Member';
        member_no?: string | null;
        member_id?: number | null;
        member_name?: string | null;
        member_position?: string | null;
        member_department?: string | null;
        member_nric?: string | null;
        member_gender?: Gender | null;
        member_dob?: any | null;
        member_joined_date?: any | null;
        card_no?: string | null;
        member_mobile?: string | null;
        member_email?: string | null;
        member_remark?: string | null;
        member_clinic_remark?: string | null;
        dependent?: Array<{
          __typename?: 'Dependent';
          dependent_id?: number | null;
          dependent_name?: string | null;
          dependent_dob?: any | null;
          dependent_nric?: string | null;
          dependent_gender?: Gender | null;
          dependent_joined_date?: any | null;
          dependent_relationship?: string | null;
          dependent_status?: DependentStatus | null;
          dependent_mobile?: string | null;
          dependent_email?: string | null;
          member_id?: number | null;
        } | null> | null;
        member_balance?: Array<{
          __typename?: 'MemberBalance';
          member_balance_id?: number | null;
          member_id?: number | null;
          setting_benefit_plan_id?: number | null;
          benefit_plan_year?: number | null;
          member_balance_remaining?: number | null;
          member_balance_status?: MemberBalanceStatus | null;
        } | null> | null;
        member_active_balance?: {
          __typename?: 'MemberBalance';
          member_balance_id?: number | null;
          member_id?: number | null;
          setting_benefit_plan_id?: number | null;
          benefit_plan_year?: number | null;
          member_balance_remaining?: number | null;
          member_balance_status?: MemberBalanceStatus | null;
        } | null;
        setting_benefit_plan?: {
          __typename?: 'SettingBenefitPlan';
          setting_benefit_plan_id?: number | null;
          setting_benefit_plan_name?: string | null;
          setting_benefit_plan_amount?: number | null;
          setting_benefit_plan_created?: any | null;
          setting_benefit_plan_updated?: any | null;
          benefit_plan_clinic_category?: Array<{
            __typename?: 'SettingClinicCategoryAmount';
            setting_clinic_category_id: number;
            setting_clinic_category_name: string;
            amount_per_visit?: number | null;
          } | null> | null;
        } | null;
        client?: {
          __typename?: 'Client';
          client_id?: number | null;
          client_name?: string | null;
          client_number?: string | null;
          client_diagnosis_exclusion_file?: string | null;
        } | null;
        client_corporate?: {
          __typename?: 'ClientCorporate';
          client_corporate_name?: string | null;
          client_corporate_number?: string | null;
        } | null;
        client_branch?: {
          __typename?: 'ClientBranch';
          client_branch_name?: string | null;
          client_branch_number?: string | null;
        } | null;
      } | null;
      client?: {
        __typename?: 'Client';
        client_id?: number | null;
        client_name?: string | null;
        client_number?: string | null;
        client_diagnosis_exclusion_file?: string | null;
      } | null;
      clinic?: {
        __typename?: 'Clinic';
        clinic_id?: number | null;
        clinic_name?: string | null;
        clinic_number?: string | null;
        clinic_overall_rating?: number | null;
        ongoing_session_count?: number | null;
        setting_clinic_category?: {
          __typename?: 'SettingClinicCategory';
          setting_clinic_category_id: number;
          setting_clinic_category_name: string;
        } | null;
      } | null;
      claim_status?: {
        __typename?: 'ClaimStatus';
        claim_status_id?: number | null;
        claim_status_name?: string | null;
        claim_status_slug?: string | null;
      } | null;
      claim_service?: Array<{
        __typename?: 'ClaimService';
        service_amount?: number | null;
        service_remark?: string | null;
        setting_service?: {
          __typename?: 'SettingService';
          service_id?: number | null;
          service_name?: string | null;
        } | null;
      } | null> | null;
      claim_medication?: Array<{
        __typename?: 'ClaimMedication';
        medication_name?: string | null;
        medication_amount?: number | null;
        medication_quantity?: number | null;
      } | null> | null;
      claim_diagnosis?: Array<{
        __typename?: 'ClaimDiagnosis';
        is_eligible?: boolean | null;
        diagnosis?: {
          __typename?: 'SettingDiagnosis';
          diagnosis_name?: string | null;
          diagnosis_code?: string | null;
        } | null;
      } | null> | null;
      medical_certificate?: {
        __typename?: 'MedicalCertificate';
        start_date?: any | null;
        end_date?: any | null;
        number_of_days?: number | null;
      } | null;
      claim_reject_reason?: {
        __typename?: 'ClaimRejectReason';
        reject_reason_id?: number | null;
        reject_reason_name?: string | null;
        reject_reason_slug?: string | null;
        reject_reason_status?: string | null;
      } | null;
      letter_of_appointment?: {
        __typename?: 'MediaData';
        media_url?: string | null;
        media_name?: string | null;
        media_type?: string | null;
      } | null;
      setting_benefit_plan?: {
        __typename?: 'SettingBenefitPlan';
        setting_benefit_plan_id?: number | null;
        setting_benefit_plan_name?: string | null;
        setting_benefit_plan_amount?: number | null;
        setting_benefit_plan_created?: any | null;
        setting_benefit_plan_updated?: any | null;
        benefit_plan_clinic_category?: Array<{
          __typename?: 'SettingClinicCategoryAmount';
          setting_clinic_category_id: number;
          setting_clinic_category_name: string;
          amount_per_visit?: number | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type ClaimListingQueryVariables = Exact<{
  input?: InputMaybe<ClaimListingInput>;
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;

export type ClaimListingQuery = {
  __typename?: 'Query';
  ClaimListing?: {
    __typename?: 'ClaimPaginator';
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
    data: Array<{
      __typename?: 'Claim';
      claim_id?: number | null;
      claim_number?: string | null;
      total_medication?: number | null;
      total_service?: number | null;
      total_amount?: number | null;
      claim_incurred?: number | null;
      claim_approved?: number | null;
      claim_not_approved?: number | null;
      claim_declined?: number | null;
      reject_reason?: string | null;
      claim_created?: any | null;
      claim_updated?: any | null;
      clinic_patient?: {
        __typename?: 'Patient';
        clinic_patient_no?: string | null;
        clinic_patient_name?: string | null;
        clinic_patient_dob?: any | null;
        clinic_patient_nric?: string | null;
        clinic_patient_nric_type?: NricType | null;
        clinic_patient_gender?: Gender | null;
        is_dependent?: boolean | null;
        dependent?: {
          __typename?: 'Dependent';
          dependent_id?: number | null;
          dependent_name?: string | null;
          dependent_dob?: any | null;
          dependent_nric?: string | null;
          dependent_gender?: Gender | null;
          dependent_joined_date?: any | null;
          dependent_relationship?: string | null;
          dependent_status?: DependentStatus | null;
          dependent_mobile?: string | null;
          dependent_email?: string | null;
          member_id?: number | null;
        } | null;
      } | null;
      member?: {
        __typename?: 'Member';
        member_no?: string | null;
        member_id?: number | null;
        member_name?: string | null;
        member_position?: string | null;
        member_department?: string | null;
        member_nric?: string | null;
        member_gender?: Gender | null;
        member_dob?: any | null;
        member_joined_date?: any | null;
        card_no?: string | null;
        member_mobile?: string | null;
        member_email?: string | null;
        member_remark?: string | null;
        member_clinic_remark?: string | null;
        dependent?: Array<{
          __typename?: 'Dependent';
          dependent_id?: number | null;
          dependent_name?: string | null;
          dependent_dob?: any | null;
          dependent_nric?: string | null;
          dependent_gender?: Gender | null;
          dependent_joined_date?: any | null;
          dependent_relationship?: string | null;
          dependent_status?: DependentStatus | null;
          dependent_mobile?: string | null;
          dependent_email?: string | null;
          member_id?: number | null;
        } | null> | null;
        member_balance?: Array<{
          __typename?: 'MemberBalance';
          member_balance_id?: number | null;
          member_id?: number | null;
          setting_benefit_plan_id?: number | null;
          benefit_plan_year?: number | null;
          member_balance_remaining?: number | null;
          member_balance_status?: MemberBalanceStatus | null;
        } | null> | null;
        member_active_balance?: {
          __typename?: 'MemberBalance';
          member_balance_id?: number | null;
          member_id?: number | null;
          setting_benefit_plan_id?: number | null;
          benefit_plan_year?: number | null;
          member_balance_remaining?: number | null;
          member_balance_status?: MemberBalanceStatus | null;
        } | null;
        setting_benefit_plan?: {
          __typename?: 'SettingBenefitPlan';
          setting_benefit_plan_id?: number | null;
          setting_benefit_plan_name?: string | null;
          setting_benefit_plan_amount?: number | null;
          setting_benefit_plan_created?: any | null;
          setting_benefit_plan_updated?: any | null;
          benefit_plan_clinic_category?: Array<{
            __typename?: 'SettingClinicCategoryAmount';
            setting_clinic_category_id: number;
            setting_clinic_category_name: string;
            amount_per_visit?: number | null;
          } | null> | null;
        } | null;
        client?: {
          __typename?: 'Client';
          client_id?: number | null;
          client_name?: string | null;
          client_number?: string | null;
          client_diagnosis_exclusion_file?: string | null;
        } | null;
        client_corporate?: {
          __typename?: 'ClientCorporate';
          client_corporate_name?: string | null;
          client_corporate_number?: string | null;
        } | null;
        client_branch?: {
          __typename?: 'ClientBranch';
          client_branch_name?: string | null;
          client_branch_number?: string | null;
        } | null;
      } | null;
      client?: {
        __typename?: 'Client';
        client_id?: number | null;
        client_name?: string | null;
        client_number?: string | null;
        client_diagnosis_exclusion_file?: string | null;
      } | null;
      clinic?: {
        __typename?: 'Clinic';
        clinic_id?: number | null;
        clinic_name?: string | null;
        clinic_number?: string | null;
        clinic_overall_rating?: number | null;
        ongoing_session_count?: number | null;
        setting_clinic_category?: {
          __typename?: 'SettingClinicCategory';
          setting_clinic_category_id: number;
          setting_clinic_category_name: string;
        } | null;
      } | null;
      claim_status?: {
        __typename?: 'ClaimStatus';
        claim_status_id?: number | null;
        claim_status_name?: string | null;
        claim_status_slug?: string | null;
      } | null;
      claim_service?: Array<{
        __typename?: 'ClaimService';
        service_amount?: number | null;
        service_remark?: string | null;
        setting_service?: {
          __typename?: 'SettingService';
          service_id?: number | null;
          service_name?: string | null;
        } | null;
      } | null> | null;
      claim_medication?: Array<{
        __typename?: 'ClaimMedication';
        medication_name?: string | null;
        medication_amount?: number | null;
        medication_quantity?: number | null;
      } | null> | null;
      claim_diagnosis?: Array<{
        __typename?: 'ClaimDiagnosis';
        is_eligible?: boolean | null;
        diagnosis?: {
          __typename?: 'SettingDiagnosis';
          diagnosis_name?: string | null;
          diagnosis_code?: string | null;
        } | null;
      } | null> | null;
      medical_certificate?: {
        __typename?: 'MedicalCertificate';
        start_date?: any | null;
        end_date?: any | null;
        number_of_days?: number | null;
      } | null;
      claim_reject_reason?: {
        __typename?: 'ClaimRejectReason';
        reject_reason_id?: number | null;
        reject_reason_name?: string | null;
        reject_reason_slug?: string | null;
        reject_reason_status?: string | null;
      } | null;
      letter_of_appointment?: {
        __typename?: 'MediaData';
        media_url?: string | null;
        media_name?: string | null;
        media_type?: string | null;
      } | null;
      setting_benefit_plan?: {
        __typename?: 'SettingBenefitPlan';
        setting_benefit_plan_id?: number | null;
        setting_benefit_plan_name?: string | null;
        setting_benefit_plan_amount?: number | null;
        setting_benefit_plan_created?: any | null;
        setting_benefit_plan_updated?: any | null;
        benefit_plan_clinic_category?: Array<{
          __typename?: 'SettingClinicCategoryAmount';
          setting_clinic_category_id: number;
          setting_clinic_category_name: string;
          amount_per_visit?: number | null;
        } | null> | null;
      } | null;
    }>;
  } | null;
  ClaimStatusCount?: Array<{
    __typename?: 'ClaimStatusCount';
    claim_status_count?: number | null;
    claim_status_name?: string | null;
    claim_status_slug?: string | null;
  } | null> | null;
};

export type ClaimStatusCountQueryVariables = Exact<{
  input?: InputMaybe<ClaimListingInput>;
}>;

export type ClaimStatusCountQuery = {
  __typename?: 'Query';
  ClaimStatusCount?: Array<{
    __typename?: 'ClaimStatusCount';
    claim_status_count?: number | null;
    claim_status_name?: string | null;
    claim_status_slug?: string | null;
  } | null> | null;
};

export type ReportExportUrlMutationVariables = Exact<{
  input?: InputMaybe<ReportInput>;
}>;

export type ReportExportUrlMutation = {
  __typename?: 'Mutation';
  ReportExportUrl?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type SessionReminderQueryVariables = Exact<{ [key: string]: never }>;

export type SessionReminderQuery = {
  __typename?: 'Query';
  SessionReminder?: {
    __typename?: 'SessionReminderCount';
    pending_session?: number | null;
  } | null;
};

export type SettingDetailQueryVariables = Exact<{
  setting_slug?: InputMaybe<SettingSlug>;
}>;

export type SettingDetailQuery = {
  __typename?: 'Query';
  SettingDetail?: {
    __typename?: 'Setting';
    setting_id?: number | null;
    setting_slug?: string | null;
    setting_value?: string | null;
    setting_description?: string | null;
    is_editable?: number | null;
    setting_type?: string | null;
    setting_media?: {
      __typename?: 'MediaData';
      media_url?: string | null;
      media_name?: string | null;
      media_type?: string | null;
    } | null;
  } | null;
};

export type UserHasRolesFragment = {
  __typename?: 'UserHasRoles';
  user_id?: number | null;
  user_no?: string | null;
  username?: string | null;
  user_email?: string | null;
  user_mobile?: string | null;
  user_fullname?: string | null;
  user_gender?: Gender | null;
  user_address?: string | null;
  user_address2?: string | null;
  user_nric?: string | null;
  user_dob?: any | null;
  user_city?: number | null;
  user_state?: number | null;
  user_postcode?: string | null;
  user_department?: string | null;
  user_created?: any | null;
  user_status?: UserStatus | null;
  user_profile_photo?: {
    __typename?: 'Images';
    media_id?: number | null;
    full?: string | null;
    thumb?: string | null;
  } | null;
  user_type?: {
    __typename?: 'UserType';
    user_type_id?: number | null;
    user_type_name?: string | null;
    user_type_slug?: string | null;
  } | null;
  user_role?: {
    __typename?: 'Role';
    id?: number | null;
    name?: string | null;
    guard_name?: string | null;
    user_type_slug?: UserTypeRole | null;
    description?: string | null;
    status?: RolesStatus | null;
    permissions?: Array<{
      __typename?: 'Permission';
      id?: number | null;
      name?: string | null;
      group_name?: string | null;
      display_name?: string | null;
      user_type_slug?: string | null;
    } | null> | null;
  } | null;
  clinic?: {
    __typename?: 'Clinic';
    clinic_id?: number | null;
    clinic_name?: string | null;
    clinic_number?: string | null;
  } | null;
  client?: {
    __typename?: 'Client';
    client_id?: number | null;
    client_name?: string | null;
    client_number?: string | null;
  } | null;
};

export type UserRoleFragment = {
  __typename?: 'Role';
  id?: number | null;
  name?: string | null;
  guard_name?: string | null;
  user_type_slug?: UserTypeRole | null;
  description?: string | null;
  status?: RolesStatus | null;
  permissions?: Array<{
    __typename?: 'Permission';
    id?: number | null;
    name?: string | null;
    group_name?: string | null;
    display_name?: string | null;
    user_type_slug?: string | null;
  } | null> | null;
};

export type UserTypeFragment = {
  __typename?: 'UserType';
  user_type_id?: number | null;
  user_type_name?: string | null;
  user_type_slug?: string | null;
};

export type ImagesFragment = {
  __typename?: 'Images';
  media_id?: number | null;
  full?: string | null;
  thumb?: string | null;
};

export type PaginatorInfoFragment = {
  __typename?: 'PaginatorInfo';
  count: number;
  currentPage: number;
  firstItem?: number | null;
  hasMorePages: boolean;
  lastItem?: number | null;
  lastPage: number;
  perPage: number;
  total: number;
};

export type SuccessResponseFragment = {
  __typename?: 'SuccessResponse';
  status: boolean;
  message?: string | null;
  data?: any | null;
};

export type SuccessResponseCheckoutFragment = {
  __typename?: 'SuccessResponseCheckout';
  status: boolean;
  message?: string | null;
  claim?: {
    __typename?: 'Claim';
    claim_id?: number | null;
    claim_number?: string | null;
    total_medication?: number | null;
    total_service?: number | null;
    total_amount?: number | null;
    claim_incurred?: number | null;
    claim_approved?: number | null;
    claim_not_approved?: number | null;
    claim_declined?: number | null;
    reject_reason?: string | null;
    claim_created?: any | null;
    claim_updated?: any | null;
    clinic_patient?: {
      __typename?: 'Patient';
      clinic_patient_no?: string | null;
      clinic_patient_name?: string | null;
      clinic_patient_dob?: any | null;
      clinic_patient_nric?: string | null;
      clinic_patient_nric_type?: NricType | null;
      clinic_patient_gender?: Gender | null;
      is_dependent?: boolean | null;
      dependent?: {
        __typename?: 'Dependent';
        dependent_id?: number | null;
        dependent_name?: string | null;
        dependent_dob?: any | null;
        dependent_nric?: string | null;
        dependent_gender?: Gender | null;
        dependent_joined_date?: any | null;
        dependent_relationship?: string | null;
        dependent_status?: DependentStatus | null;
        dependent_mobile?: string | null;
        dependent_email?: string | null;
        member_id?: number | null;
      } | null;
    } | null;
    member?: {
      __typename?: 'Member';
      member_no?: string | null;
      member_id?: number | null;
      member_name?: string | null;
      member_position?: string | null;
      member_department?: string | null;
      member_nric?: string | null;
      member_gender?: Gender | null;
      member_dob?: any | null;
      member_joined_date?: any | null;
      card_no?: string | null;
      member_mobile?: string | null;
      member_email?: string | null;
      member_remark?: string | null;
      member_clinic_remark?: string | null;
      dependent?: Array<{
        __typename?: 'Dependent';
        dependent_id?: number | null;
        dependent_name?: string | null;
        dependent_dob?: any | null;
        dependent_nric?: string | null;
        dependent_gender?: Gender | null;
        dependent_joined_date?: any | null;
        dependent_relationship?: string | null;
        dependent_status?: DependentStatus | null;
        dependent_mobile?: string | null;
        dependent_email?: string | null;
        member_id?: number | null;
      } | null> | null;
      member_balance?: Array<{
        __typename?: 'MemberBalance';
        member_balance_id?: number | null;
        member_id?: number | null;
        setting_benefit_plan_id?: number | null;
        benefit_plan_year?: number | null;
        member_balance_remaining?: number | null;
        member_balance_status?: MemberBalanceStatus | null;
      } | null> | null;
      member_active_balance?: {
        __typename?: 'MemberBalance';
        member_balance_id?: number | null;
        member_id?: number | null;
        setting_benefit_plan_id?: number | null;
        benefit_plan_year?: number | null;
        member_balance_remaining?: number | null;
        member_balance_status?: MemberBalanceStatus | null;
      } | null;
      setting_benefit_plan?: {
        __typename?: 'SettingBenefitPlan';
        setting_benefit_plan_id?: number | null;
        setting_benefit_plan_name?: string | null;
        setting_benefit_plan_amount?: number | null;
        setting_benefit_plan_created?: any | null;
        setting_benefit_plan_updated?: any | null;
        benefit_plan_clinic_category?: Array<{
          __typename?: 'SettingClinicCategoryAmount';
          setting_clinic_category_id: number;
          setting_clinic_category_name: string;
          amount_per_visit?: number | null;
        } | null> | null;
      } | null;
      client?: {
        __typename?: 'Client';
        client_id?: number | null;
        client_name?: string | null;
        client_number?: string | null;
        client_diagnosis_exclusion_file?: string | null;
      } | null;
      client_corporate?: {
        __typename?: 'ClientCorporate';
        client_corporate_name?: string | null;
        client_corporate_number?: string | null;
      } | null;
      client_branch?: {
        __typename?: 'ClientBranch';
        client_branch_name?: string | null;
        client_branch_number?: string | null;
      } | null;
    } | null;
    client?: {
      __typename?: 'Client';
      client_id?: number | null;
      client_name?: string | null;
      client_number?: string | null;
      client_diagnosis_exclusion_file?: string | null;
    } | null;
    clinic?: {
      __typename?: 'Clinic';
      clinic_id?: number | null;
      clinic_name?: string | null;
      clinic_number?: string | null;
      clinic_overall_rating?: number | null;
      ongoing_session_count?: number | null;
      setting_clinic_category?: {
        __typename?: 'SettingClinicCategory';
        setting_clinic_category_id: number;
        setting_clinic_category_name: string;
      } | null;
    } | null;
    claim_status?: {
      __typename?: 'ClaimStatus';
      claim_status_id?: number | null;
      claim_status_name?: string | null;
      claim_status_slug?: string | null;
    } | null;
    claim_service?: Array<{
      __typename?: 'ClaimService';
      service_amount?: number | null;
      service_remark?: string | null;
      setting_service?: {
        __typename?: 'SettingService';
        service_id?: number | null;
        service_name?: string | null;
      } | null;
    } | null> | null;
    claim_medication?: Array<{
      __typename?: 'ClaimMedication';
      medication_name?: string | null;
      medication_amount?: number | null;
      medication_quantity?: number | null;
    } | null> | null;
    claim_diagnosis?: Array<{
      __typename?: 'ClaimDiagnosis';
      is_eligible?: boolean | null;
      diagnosis?: {
        __typename?: 'SettingDiagnosis';
        diagnosis_name?: string | null;
        diagnosis_code?: string | null;
      } | null;
    } | null> | null;
    medical_certificate?: {
      __typename?: 'MedicalCertificate';
      start_date?: any | null;
      end_date?: any | null;
      number_of_days?: number | null;
    } | null;
    claim_reject_reason?: {
      __typename?: 'ClaimRejectReason';
      reject_reason_id?: number | null;
      reject_reason_name?: string | null;
      reject_reason_slug?: string | null;
      reject_reason_status?: string | null;
    } | null;
    letter_of_appointment?: {
      __typename?: 'MediaData';
      media_url?: string | null;
      media_name?: string | null;
      media_type?: string | null;
    } | null;
    setting_benefit_plan?: {
      __typename?: 'SettingBenefitPlan';
      setting_benefit_plan_id?: number | null;
      setting_benefit_plan_name?: string | null;
      setting_benefit_plan_amount?: number | null;
      setting_benefit_plan_created?: any | null;
      setting_benefit_plan_updated?: any | null;
      benefit_plan_clinic_category?: Array<{
        __typename?: 'SettingClinicCategoryAmount';
        setting_clinic_category_id: number;
        setting_clinic_category_name: string;
        amount_per_visit?: number | null;
      } | null> | null;
    } | null;
  } | null;
};

export type UserFragment = {
  __typename?: 'User';
  user_id?: number | null;
  username?: string | null;
  user_email?: string | null;
  user_mobile?: string | null;
  user_fullname?: string | null;
  user_gender?: Gender | null;
  user_nric?: string | null;
  user_nationality?: string | null;
  user_address?: string | null;
  user_address2?: string | null;
  user_dob?: any | null;
  user_postcode?: string | null;
  user_status?: UserStatus | null;
  user_logindate?: any | null;
  user_description?: string | null;
  user_state?: number | null;
  user_city?: number | null;
  user_profile_photo?: {
    __typename?: 'Images';
    media_id?: number | null;
    full?: string | null;
    thumb?: string | null;
  } | null;
  user_type?: {
    __typename?: 'UserType';
    user_type_id?: number | null;
    user_type_name?: string | null;
    user_type_slug?: string | null;
  } | null;
  clinic?: {
    __typename?: 'Clinic';
    clinic_id?: number | null;
    clinic_number?: string | null;
    clinic_logo?: string | null;
    clinic_name?: string | null;
    clinic_image?: string | null;
    clinic_overall_rating?: number | null;
  } | null;
  user_role?: {
    __typename?: 'Role';
    id?: number | null;
    name?: string | null;
    team_id?: number | null;
    guard_name?: string | null;
    user_type_slug?: UserTypeRole | null;
    description?: string | null;
    status?: RolesStatus | null;
    permissions?: Array<{
      __typename?: 'Permission';
      id?: number | null;
      name?: string | null;
      group_name?: string | null;
      display_name?: string | null;
      user_type_slug?: string | null;
    } | null> | null;
    client?: {
      __typename?: 'Client';
      client_id?: number | null;
      client_name?: string | null;
      client_number?: string | null;
      client_diagnosis_exclusion_file?: string | null;
    } | null;
    clinic?: {
      __typename?: 'Clinic';
      clinic_id?: number | null;
      clinic_name?: string | null;
      clinic_number?: string | null;
      clinic_overall_rating?: number | null;
      ongoing_session_count?: number | null;
      setting_clinic_category?: {
        __typename?: 'SettingClinicCategory';
        setting_clinic_category_id: number;
        setting_clinic_category_name: string;
      } | null;
    } | null;
  } | null;
};

export type MediaFragment = {
  __typename?: 'Images';
  media_id?: number | null;
  full?: string | null;
  thumb?: string | null;
};

export type SessionStatusFragment = {
  __typename?: 'SessionStatus';
  session_status_id?: number | null;
  session_status_name?: string | null;
  session_status_slug?: string | null;
};

export type PatientFragment = {
  __typename?: 'Patient';
  clinic_patient_no?: string | null;
  clinic_patient_name?: string | null;
  clinic_patient_dob?: any | null;
  clinic_patient_nric?: string | null;
  clinic_patient_nric_type?: NricType | null;
  clinic_patient_gender?: Gender | null;
  is_dependent?: boolean | null;
  dependent?: {
    __typename?: 'Dependent';
    dependent_id?: number | null;
    dependent_name?: string | null;
    dependent_dob?: any | null;
    dependent_nric?: string | null;
    dependent_gender?: Gender | null;
    dependent_joined_date?: any | null;
    dependent_relationship?: string | null;
    dependent_status?: DependentStatus | null;
    dependent_mobile?: string | null;
    dependent_email?: string | null;
    member_id?: number | null;
  } | null;
};

export type MemberFragment = {
  __typename?: 'Member';
  member_no?: string | null;
  member_id?: number | null;
  member_name?: string | null;
  member_position?: string | null;
  member_department?: string | null;
  member_nric?: string | null;
  member_gender?: Gender | null;
  member_dob?: any | null;
  member_joined_date?: any | null;
  card_no?: string | null;
  member_mobile?: string | null;
  member_email?: string | null;
  member_remark?: string | null;
  member_clinic_remark?: string | null;
  dependent?: Array<{
    __typename?: 'Dependent';
    dependent_id?: number | null;
    dependent_name?: string | null;
    dependent_dob?: any | null;
    dependent_nric?: string | null;
    dependent_gender?: Gender | null;
    dependent_joined_date?: any | null;
    dependent_relationship?: string | null;
    dependent_status?: DependentStatus | null;
    dependent_mobile?: string | null;
    dependent_email?: string | null;
    member_id?: number | null;
  } | null> | null;
  member_balance?: Array<{
    __typename?: 'MemberBalance';
    member_balance_id?: number | null;
    member_id?: number | null;
    setting_benefit_plan_id?: number | null;
    benefit_plan_year?: number | null;
    member_balance_remaining?: number | null;
    member_balance_status?: MemberBalanceStatus | null;
  } | null> | null;
  member_active_balance?: {
    __typename?: 'MemberBalance';
    member_balance_id?: number | null;
    member_id?: number | null;
    setting_benefit_plan_id?: number | null;
    benefit_plan_year?: number | null;
    member_balance_remaining?: number | null;
    member_balance_status?: MemberBalanceStatus | null;
  } | null;
  setting_benefit_plan?: {
    __typename?: 'SettingBenefitPlan';
    setting_benefit_plan_id?: number | null;
    setting_benefit_plan_name?: string | null;
    setting_benefit_plan_amount?: number | null;
    setting_benefit_plan_created?: any | null;
    setting_benefit_plan_updated?: any | null;
    benefit_plan_clinic_category?: Array<{
      __typename?: 'SettingClinicCategoryAmount';
      setting_clinic_category_id: number;
      setting_clinic_category_name: string;
      amount_per_visit?: number | null;
    } | null> | null;
  } | null;
  client?: {
    __typename?: 'Client';
    client_id?: number | null;
    client_name?: string | null;
    client_number?: string | null;
    client_diagnosis_exclusion_file?: string | null;
  } | null;
  client_corporate?: {
    __typename?: 'ClientCorporate';
    client_corporate_name?: string | null;
    client_corporate_number?: string | null;
  } | null;
  client_branch?: {
    __typename?: 'ClientBranch';
    client_branch_name?: string | null;
    client_branch_number?: string | null;
  } | null;
};

export type DependentFragment = {
  __typename?: 'Dependent';
  dependent_id?: number | null;
  dependent_name?: string | null;
  dependent_dob?: any | null;
  dependent_nric?: string | null;
  dependent_gender?: Gender | null;
  dependent_joined_date?: any | null;
  dependent_relationship?: string | null;
  dependent_status?: DependentStatus | null;
  dependent_mobile?: string | null;
  dependent_email?: string | null;
  member_id?: number | null;
};

export type MemberBalanceFragment = {
  __typename?: 'MemberBalance';
  member_balance_id?: number | null;
  member_id?: number | null;
  setting_benefit_plan_id?: number | null;
  benefit_plan_year?: number | null;
  member_balance_remaining?: number | null;
  member_balance_status?: MemberBalanceStatus | null;
};

export type SettingBenefitPlanFragment = {
  __typename?: 'SettingBenefitPlan';
  setting_benefit_plan_id?: number | null;
  setting_benefit_plan_name?: string | null;
  setting_benefit_plan_amount?: number | null;
  setting_benefit_plan_created?: any | null;
  setting_benefit_plan_updated?: any | null;
  benefit_plan_clinic_category?: Array<{
    __typename?: 'SettingClinicCategoryAmount';
    setting_clinic_category_id: number;
    setting_clinic_category_name: string;
    amount_per_visit?: number | null;
  } | null> | null;
};

export type ClaimFragment = {
  __typename?: 'Claim';
  claim_id?: number | null;
  claim_number?: string | null;
  total_medication?: number | null;
  total_service?: number | null;
  total_amount?: number | null;
  claim_incurred?: number | null;
  claim_approved?: number | null;
  claim_not_approved?: number | null;
  claim_declined?: number | null;
  reject_reason?: string | null;
  claim_created?: any | null;
  claim_updated?: any | null;
  clinic_patient?: {
    __typename?: 'Patient';
    clinic_patient_no?: string | null;
    clinic_patient_name?: string | null;
    clinic_patient_dob?: any | null;
    clinic_patient_nric?: string | null;
    clinic_patient_nric_type?: NricType | null;
    clinic_patient_gender?: Gender | null;
    is_dependent?: boolean | null;
    dependent?: {
      __typename?: 'Dependent';
      dependent_id?: number | null;
      dependent_name?: string | null;
      dependent_dob?: any | null;
      dependent_nric?: string | null;
      dependent_gender?: Gender | null;
      dependent_joined_date?: any | null;
      dependent_relationship?: string | null;
      dependent_status?: DependentStatus | null;
      dependent_mobile?: string | null;
      dependent_email?: string | null;
      member_id?: number | null;
    } | null;
  } | null;
  member?: {
    __typename?: 'Member';
    member_no?: string | null;
    member_id?: number | null;
    member_name?: string | null;
    member_position?: string | null;
    member_department?: string | null;
    member_nric?: string | null;
    member_gender?: Gender | null;
    member_dob?: any | null;
    member_joined_date?: any | null;
    card_no?: string | null;
    member_mobile?: string | null;
    member_email?: string | null;
    member_remark?: string | null;
    member_clinic_remark?: string | null;
    dependent?: Array<{
      __typename?: 'Dependent';
      dependent_id?: number | null;
      dependent_name?: string | null;
      dependent_dob?: any | null;
      dependent_nric?: string | null;
      dependent_gender?: Gender | null;
      dependent_joined_date?: any | null;
      dependent_relationship?: string | null;
      dependent_status?: DependentStatus | null;
      dependent_mobile?: string | null;
      dependent_email?: string | null;
      member_id?: number | null;
    } | null> | null;
    member_balance?: Array<{
      __typename?: 'MemberBalance';
      member_balance_id?: number | null;
      member_id?: number | null;
      setting_benefit_plan_id?: number | null;
      benefit_plan_year?: number | null;
      member_balance_remaining?: number | null;
      member_balance_status?: MemberBalanceStatus | null;
    } | null> | null;
    member_active_balance?: {
      __typename?: 'MemberBalance';
      member_balance_id?: number | null;
      member_id?: number | null;
      setting_benefit_plan_id?: number | null;
      benefit_plan_year?: number | null;
      member_balance_remaining?: number | null;
      member_balance_status?: MemberBalanceStatus | null;
    } | null;
    setting_benefit_plan?: {
      __typename?: 'SettingBenefitPlan';
      setting_benefit_plan_id?: number | null;
      setting_benefit_plan_name?: string | null;
      setting_benefit_plan_amount?: number | null;
      setting_benefit_plan_created?: any | null;
      setting_benefit_plan_updated?: any | null;
      benefit_plan_clinic_category?: Array<{
        __typename?: 'SettingClinicCategoryAmount';
        setting_clinic_category_id: number;
        setting_clinic_category_name: string;
        amount_per_visit?: number | null;
      } | null> | null;
    } | null;
    client?: {
      __typename?: 'Client';
      client_id?: number | null;
      client_name?: string | null;
      client_number?: string | null;
      client_diagnosis_exclusion_file?: string | null;
    } | null;
    client_corporate?: {
      __typename?: 'ClientCorporate';
      client_corporate_name?: string | null;
      client_corporate_number?: string | null;
    } | null;
    client_branch?: {
      __typename?: 'ClientBranch';
      client_branch_name?: string | null;
      client_branch_number?: string | null;
    } | null;
  } | null;
  client?: {
    __typename?: 'Client';
    client_id?: number | null;
    client_name?: string | null;
    client_number?: string | null;
    client_diagnosis_exclusion_file?: string | null;
  } | null;
  clinic?: {
    __typename?: 'Clinic';
    clinic_id?: number | null;
    clinic_name?: string | null;
    clinic_number?: string | null;
    clinic_overall_rating?: number | null;
    ongoing_session_count?: number | null;
    setting_clinic_category?: {
      __typename?: 'SettingClinicCategory';
      setting_clinic_category_id: number;
      setting_clinic_category_name: string;
    } | null;
  } | null;
  claim_status?: {
    __typename?: 'ClaimStatus';
    claim_status_id?: number | null;
    claim_status_name?: string | null;
    claim_status_slug?: string | null;
  } | null;
  claim_service?: Array<{
    __typename?: 'ClaimService';
    service_amount?: number | null;
    service_remark?: string | null;
    setting_service?: {
      __typename?: 'SettingService';
      service_id?: number | null;
      service_name?: string | null;
    } | null;
  } | null> | null;
  claim_medication?: Array<{
    __typename?: 'ClaimMedication';
    medication_name?: string | null;
    medication_amount?: number | null;
    medication_quantity?: number | null;
  } | null> | null;
  claim_diagnosis?: Array<{
    __typename?: 'ClaimDiagnosis';
    is_eligible?: boolean | null;
    diagnosis?: {
      __typename?: 'SettingDiagnosis';
      diagnosis_name?: string | null;
      diagnosis_code?: string | null;
    } | null;
  } | null> | null;
  medical_certificate?: {
    __typename?: 'MedicalCertificate';
    start_date?: any | null;
    end_date?: any | null;
    number_of_days?: number | null;
  } | null;
  claim_reject_reason?: {
    __typename?: 'ClaimRejectReason';
    reject_reason_id?: number | null;
    reject_reason_name?: string | null;
    reject_reason_slug?: string | null;
    reject_reason_status?: string | null;
  } | null;
  letter_of_appointment?: {
    __typename?: 'MediaData';
    media_url?: string | null;
    media_name?: string | null;
    media_type?: string | null;
  } | null;
  setting_benefit_plan?: {
    __typename?: 'SettingBenefitPlan';
    setting_benefit_plan_id?: number | null;
    setting_benefit_plan_name?: string | null;
    setting_benefit_plan_amount?: number | null;
    setting_benefit_plan_created?: any | null;
    setting_benefit_plan_updated?: any | null;
    benefit_plan_clinic_category?: Array<{
      __typename?: 'SettingClinicCategoryAmount';
      setting_clinic_category_id: number;
      setting_clinic_category_name: string;
      amount_per_visit?: number | null;
    } | null> | null;
  } | null;
};

export type ClinicFragment = {
  __typename?: 'Clinic';
  clinic_id?: number | null;
  clinic_name?: string | null;
  clinic_number?: string | null;
  clinic_overall_rating?: number | null;
  ongoing_session_count?: number | null;
  setting_clinic_category?: {
    __typename?: 'SettingClinicCategory';
    setting_clinic_category_id: number;
    setting_clinic_category_name: string;
  } | null;
};

export type ClientFragment = {
  __typename?: 'Client';
  client_id?: number | null;
  client_name?: string | null;
  client_number?: string | null;
  client_diagnosis_exclusion_file?: string | null;
};

export type PermissionFragment = {
  __typename?: 'Permission';
  id?: number | null;
  name?: string | null;
  group_name?: string | null;
  display_name?: string | null;
  user_type_slug?: string | null;
};

export type RoleFragment = {
  __typename?: 'Role';
  id?: number | null;
  name?: string | null;
  team_id?: number | null;
  guard_name?: string | null;
  user_type_slug?: UserTypeRole | null;
  description?: string | null;
  status?: RolesStatus | null;
  permissions?: Array<{
    __typename?: 'Permission';
    id?: number | null;
    name?: string | null;
    group_name?: string | null;
    display_name?: string | null;
    user_type_slug?: string | null;
  } | null> | null;
  client?: {
    __typename?: 'Client';
    client_id?: number | null;
    client_name?: string | null;
    client_number?: string | null;
    client_diagnosis_exclusion_file?: string | null;
  } | null;
  clinic?: {
    __typename?: 'Clinic';
    clinic_id?: number | null;
    clinic_name?: string | null;
    clinic_number?: string | null;
    clinic_overall_rating?: number | null;
    ongoing_session_count?: number | null;
    setting_clinic_category?: {
      __typename?: 'SettingClinicCategory';
      setting_clinic_category_id: number;
      setting_clinic_category_name: string;
    } | null;
  } | null;
};

export type ActivityLogListingQueryVariables = Exact<{
  input?: InputMaybe<ActivityLogListingInput>;
  first?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;

export type ActivityLogListingQuery = {
  __typename?: 'Query';
  ActivityLogListing?: {
    __typename?: 'ActivityPaginator';
    data: Array<{
      __typename?: 'Activity';
      id?: number | null;
      description?: string | null;
      event?: string | null;
      causer_id?: number | null;
      causer_type?: string | null;
      subject_id?: number | null;
      subject_type?: string | null;
      changes?: any | null;
      properties?: any | null;
      created_at?: string | null;
      updated_at?: string | null;
      user_causer?: {
        __typename?: 'UserCauser';
        user_id?: number | null;
        username?: string | null;
      } | null;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
  } | null;
};

export type ActivityFragment = {
  __typename?: 'Activity';
  id?: number | null;
  description?: string | null;
  event?: string | null;
  causer_id?: number | null;
  causer_type?: string | null;
  subject_id?: number | null;
  subject_type?: string | null;
  changes?: any | null;
  properties?: any | null;
  created_at?: string | null;
  updated_at?: string | null;
  user_causer?: {
    __typename?: 'UserCauser';
    user_id?: number | null;
    username?: string | null;
  } | null;
};

export const MediaFragmentDoc = gql`
  fragment Media on Images {
    media_id
    full
    thumb
  }
`;
export const UserTypeFragmentDoc = gql`
  fragment UserType on UserType {
    user_type_id
    user_type_name
    user_type_slug
  }
`;
export const ClientFragmentDoc = gql`
  fragment Client on Client {
    client_id
    client_name
    client_number
    client_diagnosis_exclusion_file
  }
`;
export const ClinicFragmentDoc = gql`
  fragment Clinic on Clinic {
    clinic_id
    clinic_name
    clinic_number
    setting_clinic_category {
      setting_clinic_category_id
      setting_clinic_category_name
    }
    clinic_overall_rating
    ongoing_session_count
  }
`;
export const RoleFragmentDoc = gql`
  fragment Role on Role {
    id
    name
    team_id
    guard_name
    user_type_slug
    description
    status
    permissions {
      id
      name
      group_name
      display_name
      user_type_slug
    }
    client {
      ...Client
    }
    clinic {
      ...Clinic
    }
  }
  ${ClientFragmentDoc}
  ${ClinicFragmentDoc}
`;
export const UserFragmentDoc = gql`
  fragment User on User {
    user_id
    username
    user_email
    user_mobile
    user_fullname
    user_gender
    user_nric
    user_nationality
    user_address
    user_address2
    user_dob
    user_postcode
    user_status
    user_logindate
    user_description
    user_state
    user_city
    user_profile_photo {
      ...Media
    }
    user_type {
      ...UserType
    }
    clinic {
      clinic_id
      clinic_number
      clinic_logo
      clinic_name
      clinic_image
      clinic_overall_rating
    }
    user_role {
      ...Role
    }
  }
  ${MediaFragmentDoc}
  ${UserTypeFragmentDoc}
  ${RoleFragmentDoc}
`;
export const BulkManagementFragmentDoc = gql`
  fragment BulkManagement on BulkManagement {
    bulk_management_id
    bulk_management_module
    bulk_management_type
    bulk_management_status
    bulk_management_created
    bulk_management_updated
    bulk_management_media {
      media_url
      media_name
      media_type
    }
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`;
export const ImagesFragmentDoc = gql`
  fragment Images on Images {
    media_id
    full
    thumb
  }
`;
export const PermissionFragmentDoc = gql`
  fragment Permission on Permission {
    id
    name
    group_name
    display_name
    user_type_slug
  }
`;
export const UserRoleFragmentDoc = gql`
  fragment UserRole on Role {
    id
    name
    guard_name
    user_type_slug
    description
    status
    permissions {
      ...Permission
    }
  }
  ${PermissionFragmentDoc}
`;
export const UserHasRolesFragmentDoc = gql`
  fragment UserHasRoles on UserHasRoles {
    user_id
    user_no
    username
    user_email
    user_mobile
    user_fullname
    user_profile_photo {
      ...Images
    }
    user_gender
    user_address
    user_address2
    user_nric
    user_dob
    user_city
    user_state
    user_postcode
    user_department
    user_type {
      ...UserType
    }
    user_created
    user_role {
      ...UserRole
    }
    user_status
    clinic {
      clinic_id
      clinic_name
      clinic_number
    }
    client {
      client_id
      client_name
      client_number
    }
  }
  ${ImagesFragmentDoc}
  ${UserTypeFragmentDoc}
  ${UserRoleFragmentDoc}
`;
export const PaginatorInfoFragmentDoc = gql`
  fragment PaginatorInfo on PaginatorInfo {
    count
    currentPage
    firstItem
    hasMorePages
    lastItem
    lastPage
    perPage
    total
  }
`;
export const SuccessResponseFragmentDoc = gql`
  fragment SuccessResponse on SuccessResponse {
    status
    message
    data
  }
`;
export const DependentFragmentDoc = gql`
  fragment Dependent on Dependent {
    dependent_id
    dependent_name
    dependent_dob
    dependent_nric
    dependent_gender
    dependent_joined_date
    dependent_relationship
    dependent_status
    dependent_mobile
    dependent_email
    member_id
  }
`;
export const PatientFragmentDoc = gql`
  fragment Patient on Patient {
    clinic_patient_no
    clinic_patient_name
    clinic_patient_dob
    clinic_patient_nric
    clinic_patient_nric_type
    clinic_patient_gender
    is_dependent
    dependent {
      ...Dependent
    }
  }
  ${DependentFragmentDoc}
`;
export const MemberBalanceFragmentDoc = gql`
  fragment MemberBalance on MemberBalance {
    member_balance_id
    member_id
    setting_benefit_plan_id
    benefit_plan_year
    member_balance_remaining
    member_balance_status
  }
`;
export const SettingBenefitPlanFragmentDoc = gql`
  fragment SettingBenefitPlan on SettingBenefitPlan {
    setting_benefit_plan_id
    setting_benefit_plan_name
    setting_benefit_plan_amount
    benefit_plan_clinic_category {
      setting_clinic_category_id
      setting_clinic_category_name
      amount_per_visit
    }
    setting_benefit_plan_created
    setting_benefit_plan_updated
  }
`;
export const MemberFragmentDoc = gql`
  fragment Member on Member {
    member_no
    member_id
    member_name
    member_position
    member_department
    member_nric
    member_gender
    member_dob
    member_joined_date
    card_no
    member_mobile
    member_email
    dependent {
      ...Dependent
    }
    member_balance {
      ...MemberBalance
    }
    member_active_balance {
      ...MemberBalance
    }
    setting_benefit_plan {
      ...SettingBenefitPlan
    }
    client {
      ...Client
    }
    client_corporate {
      client_corporate_name
      client_corporate_number
    }
    client_branch {
      client_branch_name
      client_branch_number
    }
    member_remark
    member_clinic_remark
  }
  ${DependentFragmentDoc}
  ${MemberBalanceFragmentDoc}
  ${SettingBenefitPlanFragmentDoc}
  ${ClientFragmentDoc}
`;
export const ClaimFragmentDoc = gql`
  fragment Claim on Claim {
    claim_id
    clinic_patient {
      ...Patient
    }
    member {
      ...Member
    }
    client {
      ...Client
    }
    clinic {
      ...Clinic
    }
    claim_number
    total_medication
    total_service
    total_amount
    claim_incurred
    claim_approved
    claim_not_approved
    claim_declined
    claim_status {
      claim_status_id
      claim_status_name
      claim_status_slug
    }
    claim_service {
      setting_service {
        service_id
        service_name
      }
      service_amount
      service_remark
    }
    claim_medication {
      medication_name
      medication_amount
      medication_quantity
    }
    claim_diagnosis {
      diagnosis {
        diagnosis_name
        diagnosis_code
      }
      is_eligible
    }
    medical_certificate {
      start_date
      end_date
      number_of_days
    }
    claim_reject_reason {
      reject_reason_id
      reject_reason_name
      reject_reason_slug
      reject_reason_status
    }
    reject_reason
    claim_created
    claim_updated
    letter_of_appointment {
      media_url
      media_name
      media_type
    }
    setting_benefit_plan {
      ...SettingBenefitPlan
    }
  }
  ${PatientFragmentDoc}
  ${MemberFragmentDoc}
  ${ClientFragmentDoc}
  ${ClinicFragmentDoc}
  ${SettingBenefitPlanFragmentDoc}
`;
export const SuccessResponseCheckoutFragmentDoc = gql`
  fragment SuccessResponseCheckout on SuccessResponseCheckout {
    status
    message
    claim {
      ...Claim
    }
  }
  ${ClaimFragmentDoc}
`;
export const SessionStatusFragmentDoc = gql`
  fragment SessionStatus on SessionStatus {
    session_status_id
    session_status_name
    session_status_slug
  }
`;
export const ActivityFragmentDoc = gql`
  fragment Activity on Activity {
    id
    description
    event
    causer_id
    causer_type
    subject_id
    subject_type
    changes
    properties
    created_at
    updated_at
    user_causer {
      user_id
      username
    }
  }
`;
export const AdminListingDocument = gql`
  query adminListing($input: AdminListingInput, $first: Int, $page: Int) {
    AdminListing(input: $input, first: $first, page: $page) {
      data {
        ...UserHasRoles
      }
      paginatorInfo {
        ...PaginatorInfo
      }
    }
    AdminStatusCount(input: $input) {
      admin_status_name
      admin_status_count
    }
  }
  ${UserHasRolesFragmentDoc}
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __useAdminListingQuery__
 *
 * To run a query within a React component, call `useAdminListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAdminListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminListingQuery,
    AdminListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminListingQuery, AdminListingQueryVariables>(
    AdminListingDocument,
    options
  );
}
export function useAdminListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminListingQuery,
    AdminListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminListingQuery, AdminListingQueryVariables>(
    AdminListingDocument,
    options
  );
}
export type AdminListingQueryHookResult = ReturnType<
  typeof useAdminListingQuery
>;
export type AdminListingLazyQueryHookResult = ReturnType<
  typeof useAdminListingLazyQuery
>;
export type AdminListingQueryResult = Apollo.QueryResult<
  AdminListingQuery,
  AdminListingQueryVariables
>;
export const AdminDetailDocument = gql`
  query adminDetail($user_id: Int) {
    AdminDetail(user_id: $user_id) {
      ...UserHasRoles
    }
  }
  ${UserHasRolesFragmentDoc}
`;

/**
 * __useAdminDetailQuery__
 *
 * To run a query within a React component, call `useAdminDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDetailQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useAdminDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminDetailQuery,
    AdminDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminDetailQuery, AdminDetailQueryVariables>(
    AdminDetailDocument,
    options
  );
}
export function useAdminDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminDetailQuery,
    AdminDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdminDetailQuery, AdminDetailQueryVariables>(
    AdminDetailDocument,
    options
  );
}
export type AdminDetailQueryHookResult = ReturnType<typeof useAdminDetailQuery>;
export type AdminDetailLazyQueryHookResult = ReturnType<
  typeof useAdminDetailLazyQuery
>;
export type AdminDetailQueryResult = Apollo.QueryResult<
  AdminDetailQuery,
  AdminDetailQueryVariables
>;
export const AdminRolesListingDocument = gql`
  query adminRolesListing(
    $input: AdminRolesInputListingQuery
    $first: Int
    $page: Int
  ) {
    AdminRolesListing(input: $input, first: $first, page: $page) {
      data {
        id
        name
        team_id
        guard_name
        user_type_slug
        description
        status
        permissions {
          ...Permission
        }
      }
      paginatorInfo {
        ...PaginatorInfo
      }
    }
    AdminRolesStatusCount(input: $input) {
      role_status_name
      role_status_count
    }
  }
  ${PermissionFragmentDoc}
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __useAdminRolesListingQuery__
 *
 * To run a query within a React component, call `useAdminRolesListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRolesListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRolesListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAdminRolesListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminRolesListingQuery,
    AdminRolesListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminRolesListingQuery,
    AdminRolesListingQueryVariables
  >(AdminRolesListingDocument, options);
}
export function useAdminRolesListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminRolesListingQuery,
    AdminRolesListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminRolesListingQuery,
    AdminRolesListingQueryVariables
  >(AdminRolesListingDocument, options);
}
export type AdminRolesListingQueryHookResult = ReturnType<
  typeof useAdminRolesListingQuery
>;
export type AdminRolesListingLazyQueryHookResult = ReturnType<
  typeof useAdminRolesListingLazyQuery
>;
export type AdminRolesListingQueryResult = Apollo.QueryResult<
  AdminRolesListingQuery,
  AdminRolesListingQueryVariables
>;
export const AdminPermissionListingDocument = gql`
  query adminPermissionListing($user_type_slug: UserTypeRole) {
    AdminPermissionListing(user_type_slug: $user_type_slug) {
      id
      name
      group_name
      display_name
      user_type_slug
    }
  }
`;

/**
 * __useAdminPermissionListingQuery__
 *
 * To run a query within a React component, call `useAdminPermissionListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPermissionListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPermissionListingQuery({
 *   variables: {
 *      user_type_slug: // value for 'user_type_slug'
 *   },
 * });
 */
export function useAdminPermissionListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminPermissionListingQuery,
    AdminPermissionListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminPermissionListingQuery,
    AdminPermissionListingQueryVariables
  >(AdminPermissionListingDocument, options);
}
export function useAdminPermissionListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminPermissionListingQuery,
    AdminPermissionListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminPermissionListingQuery,
    AdminPermissionListingQueryVariables
  >(AdminPermissionListingDocument, options);
}
export type AdminPermissionListingQueryHookResult = ReturnType<
  typeof useAdminPermissionListingQuery
>;
export type AdminPermissionListingLazyQueryHookResult = ReturnType<
  typeof useAdminPermissionListingLazyQuery
>;
export type AdminPermissionListingQueryResult = Apollo.QueryResult<
  AdminPermissionListingQuery,
  AdminPermissionListingQueryVariables
>;
export const AdminStatusCountDocument = gql`
  query AdminStatusCount($input: AdminListingInput) {
    AdminStatusCount(input: $input) {
      admin_status_name
      admin_status_count
    }
  }
`;

/**
 * __useAdminStatusCountQuery__
 *
 * To run a query within a React component, call `useAdminStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStatusCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminStatusCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminStatusCountQuery,
    AdminStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminStatusCountQuery, AdminStatusCountQueryVariables>(
    AdminStatusCountDocument,
    options
  );
}
export function useAdminStatusCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminStatusCountQuery,
    AdminStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminStatusCountQuery,
    AdminStatusCountQueryVariables
  >(AdminStatusCountDocument, options);
}
export type AdminStatusCountQueryHookResult = ReturnType<
  typeof useAdminStatusCountQuery
>;
export type AdminStatusCountLazyQueryHookResult = ReturnType<
  typeof useAdminStatusCountLazyQuery
>;
export type AdminStatusCountQueryResult = Apollo.QueryResult<
  AdminStatusCountQuery,
  AdminStatusCountQueryVariables
>;
export const AdminRolesStatusCountDocument = gql`
  query AdminRolesStatusCount($input: AdminRolesInputListingQuery) {
    AdminRolesStatusCount(input: $input) {
      role_status_name
      role_status_count
    }
  }
`;

/**
 * __useAdminRolesStatusCountQuery__
 *
 * To run a query within a React component, call `useAdminRolesStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRolesStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRolesStatusCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminRolesStatusCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminRolesStatusCountQuery,
    AdminRolesStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminRolesStatusCountQuery,
    AdminRolesStatusCountQueryVariables
  >(AdminRolesStatusCountDocument, options);
}
export function useAdminRolesStatusCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminRolesStatusCountQuery,
    AdminRolesStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminRolesStatusCountQuery,
    AdminRolesStatusCountQueryVariables
  >(AdminRolesStatusCountDocument, options);
}
export type AdminRolesStatusCountQueryHookResult = ReturnType<
  typeof useAdminRolesStatusCountQuery
>;
export type AdminRolesStatusCountLazyQueryHookResult = ReturnType<
  typeof useAdminRolesStatusCountLazyQuery
>;
export type AdminRolesStatusCountQueryResult = Apollo.QueryResult<
  AdminRolesStatusCountQuery,
  AdminRolesStatusCountQueryVariables
>;
export const AdminRolesDetailDocument = gql`
  query adminRolesDetail($role_id: Int) {
    AdminRolesDetail(role_id: $role_id) {
      id
      name
      team_id
      guard_name
      user_type_slug
      description
      status
      permissions {
        ...Permission
      }
    }
  }
  ${PermissionFragmentDoc}
`;

/**
 * __useAdminRolesDetailQuery__
 *
 * To run a query within a React component, call `useAdminRolesDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRolesDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRolesDetailQuery({
 *   variables: {
 *      role_id: // value for 'role_id'
 *   },
 * });
 */
export function useAdminRolesDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminRolesDetailQuery,
    AdminRolesDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdminRolesDetailQuery, AdminRolesDetailQueryVariables>(
    AdminRolesDetailDocument,
    options
  );
}
export function useAdminRolesDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminRolesDetailQuery,
    AdminRolesDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminRolesDetailQuery,
    AdminRolesDetailQueryVariables
  >(AdminRolesDetailDocument, options);
}
export type AdminRolesDetailQueryHookResult = ReturnType<
  typeof useAdminRolesDetailQuery
>;
export type AdminRolesDetailLazyQueryHookResult = ReturnType<
  typeof useAdminRolesDetailLazyQuery
>;
export type AdminRolesDetailQueryResult = Apollo.QueryResult<
  AdminRolesDetailQuery,
  AdminRolesDetailQueryVariables
>;
export const AdminTeamRolesCreateDocument = gql`
  mutation adminTeamRolesCreate($input: TeamRolesInput) {
    AdminTeamRolesCreate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type AdminTeamRolesCreateMutationFn = Apollo.MutationFunction<
  AdminTeamRolesCreateMutation,
  AdminTeamRolesCreateMutationVariables
>;

/**
 * __useAdminTeamRolesCreateMutation__
 *
 * To run a mutation, you first call `useAdminTeamRolesCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTeamRolesCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTeamRolesCreateMutation, { data, loading, error }] = useAdminTeamRolesCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminTeamRolesCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminTeamRolesCreateMutation,
    AdminTeamRolesCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminTeamRolesCreateMutation,
    AdminTeamRolesCreateMutationVariables
  >(AdminTeamRolesCreateDocument, options);
}
export type AdminTeamRolesCreateMutationHookResult = ReturnType<
  typeof useAdminTeamRolesCreateMutation
>;
export type AdminTeamRolesCreateMutationResult =
  Apollo.MutationResult<AdminTeamRolesCreateMutation>;
export type AdminTeamRolesCreateMutationOptions = Apollo.BaseMutationOptions<
  AdminTeamRolesCreateMutation,
  AdminTeamRolesCreateMutationVariables
>;
export const AdminTeamRolesUpdateDocument = gql`
  mutation adminTeamRolesUpdate($input: TeamRolesUpdateInput) {
    AdminTeamRolesUpdate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type AdminTeamRolesUpdateMutationFn = Apollo.MutationFunction<
  AdminTeamRolesUpdateMutation,
  AdminTeamRolesUpdateMutationVariables
>;

/**
 * __useAdminTeamRolesUpdateMutation__
 *
 * To run a mutation, you first call `useAdminTeamRolesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTeamRolesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTeamRolesUpdateMutation, { data, loading, error }] = useAdminTeamRolesUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminTeamRolesUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminTeamRolesUpdateMutation,
    AdminTeamRolesUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminTeamRolesUpdateMutation,
    AdminTeamRolesUpdateMutationVariables
  >(AdminTeamRolesUpdateDocument, options);
}
export type AdminTeamRolesUpdateMutationHookResult = ReturnType<
  typeof useAdminTeamRolesUpdateMutation
>;
export type AdminTeamRolesUpdateMutationResult =
  Apollo.MutationResult<AdminTeamRolesUpdateMutation>;
export type AdminTeamRolesUpdateMutationOptions = Apollo.BaseMutationOptions<
  AdminTeamRolesUpdateMutation,
  AdminTeamRolesUpdateMutationVariables
>;
export const AdminTeamRolesSuspendDocument = gql`
  mutation adminTeamRolesSuspend($id: Int) {
    AdminTeamRolesSuspend(id: $id) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type AdminTeamRolesSuspendMutationFn = Apollo.MutationFunction<
  AdminTeamRolesSuspendMutation,
  AdminTeamRolesSuspendMutationVariables
>;

/**
 * __useAdminTeamRolesSuspendMutation__
 *
 * To run a mutation, you first call `useAdminTeamRolesSuspendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTeamRolesSuspendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTeamRolesSuspendMutation, { data, loading, error }] = useAdminTeamRolesSuspendMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminTeamRolesSuspendMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminTeamRolesSuspendMutation,
    AdminTeamRolesSuspendMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminTeamRolesSuspendMutation,
    AdminTeamRolesSuspendMutationVariables
  >(AdminTeamRolesSuspendDocument, options);
}
export type AdminTeamRolesSuspendMutationHookResult = ReturnType<
  typeof useAdminTeamRolesSuspendMutation
>;
export type AdminTeamRolesSuspendMutationResult =
  Apollo.MutationResult<AdminTeamRolesSuspendMutation>;
export type AdminTeamRolesSuspendMutationOptions = Apollo.BaseMutationOptions<
  AdminTeamRolesSuspendMutation,
  AdminTeamRolesSuspendMutationVariables
>;
export const AdminTeamRolesActivateDocument = gql`
  mutation AdminTeamRolesActivate($id: Int) {
    AdminTeamRolesActivate(id: $id) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type AdminTeamRolesActivateMutationFn = Apollo.MutationFunction<
  AdminTeamRolesActivateMutation,
  AdminTeamRolesActivateMutationVariables
>;

/**
 * __useAdminTeamRolesActivateMutation__
 *
 * To run a mutation, you first call `useAdminTeamRolesActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTeamRolesActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTeamRolesActivateMutation, { data, loading, error }] = useAdminTeamRolesActivateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminTeamRolesActivateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminTeamRolesActivateMutation,
    AdminTeamRolesActivateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminTeamRolesActivateMutation,
    AdminTeamRolesActivateMutationVariables
  >(AdminTeamRolesActivateDocument, options);
}
export type AdminTeamRolesActivateMutationHookResult = ReturnType<
  typeof useAdminTeamRolesActivateMutation
>;
export type AdminTeamRolesActivateMutationResult =
  Apollo.MutationResult<AdminTeamRolesActivateMutation>;
export type AdminTeamRolesActivateMutationOptions = Apollo.BaseMutationOptions<
  AdminTeamRolesActivateMutation,
  AdminTeamRolesActivateMutationVariables
>;
export const AdminCreateDocument = gql`
  mutation adminCreate($input: AdminCreateInput) {
    AdminCreate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type AdminCreateMutationFn = Apollo.MutationFunction<
  AdminCreateMutation,
  AdminCreateMutationVariables
>;

/**
 * __useAdminCreateMutation__
 *
 * To run a mutation, you first call `useAdminCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMutation, { data, loading, error }] = useAdminCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminCreateMutation,
    AdminCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminCreateMutation, AdminCreateMutationVariables>(
    AdminCreateDocument,
    options
  );
}
export type AdminCreateMutationHookResult = ReturnType<
  typeof useAdminCreateMutation
>;
export type AdminCreateMutationResult =
  Apollo.MutationResult<AdminCreateMutation>;
export type AdminCreateMutationOptions = Apollo.BaseMutationOptions<
  AdminCreateMutation,
  AdminCreateMutationVariables
>;
export const AdminUpdateDocument = gql`
  mutation adminUpdate($input: AdminUpdateInput) {
    AdminUpdate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type AdminUpdateMutationFn = Apollo.MutationFunction<
  AdminUpdateMutation,
  AdminUpdateMutationVariables
>;

/**
 * __useAdminUpdateMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMutation, { data, loading, error }] = useAdminUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminUpdateMutation,
    AdminUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminUpdateMutation, AdminUpdateMutationVariables>(
    AdminUpdateDocument,
    options
  );
}
export type AdminUpdateMutationHookResult = ReturnType<
  typeof useAdminUpdateMutation
>;
export type AdminUpdateMutationResult =
  Apollo.MutationResult<AdminUpdateMutation>;
export type AdminUpdateMutationOptions = Apollo.BaseMutationOptions<
  AdminUpdateMutation,
  AdminUpdateMutationVariables
>;
export const AdminDeleteDocument = gql`
  mutation adminDelete($user_id: Int) {
    AdminDelete(user_id: $user_id) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type AdminDeleteMutationFn = Apollo.MutationFunction<
  AdminDeleteMutation,
  AdminDeleteMutationVariables
>;

/**
 * __useAdminDeleteMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMutation, { data, loading, error }] = useAdminDeleteMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useAdminDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminDeleteMutation,
    AdminDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminDeleteMutation, AdminDeleteMutationVariables>(
    AdminDeleteDocument,
    options
  );
}
export type AdminDeleteMutationHookResult = ReturnType<
  typeof useAdminDeleteMutation
>;
export type AdminDeleteMutationResult =
  Apollo.MutationResult<AdminDeleteMutation>;
export type AdminDeleteMutationOptions = Apollo.BaseMutationOptions<
  AdminDeleteMutation,
  AdminDeleteMutationVariables
>;
export const AdminSuspendDocument = gql`
  mutation adminSuspend($user_id: Int) {
    AdminSuspend(user_id: $user_id) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type AdminSuspendMutationFn = Apollo.MutationFunction<
  AdminSuspendMutation,
  AdminSuspendMutationVariables
>;

/**
 * __useAdminSuspendMutation__
 *
 * To run a mutation, you first call `useAdminSuspendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSuspendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSuspendMutation, { data, loading, error }] = useAdminSuspendMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useAdminSuspendMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminSuspendMutation,
    AdminSuspendMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminSuspendMutation,
    AdminSuspendMutationVariables
  >(AdminSuspendDocument, options);
}
export type AdminSuspendMutationHookResult = ReturnType<
  typeof useAdminSuspendMutation
>;
export type AdminSuspendMutationResult =
  Apollo.MutationResult<AdminSuspendMutation>;
export type AdminSuspendMutationOptions = Apollo.BaseMutationOptions<
  AdminSuspendMutation,
  AdminSuspendMutationVariables
>;
export const AdminActivateDocument = gql`
  mutation adminActivate($user_id: Int) {
    AdminActivate(user_id: $user_id) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type AdminActivateMutationFn = Apollo.MutationFunction<
  AdminActivateMutation,
  AdminActivateMutationVariables
>;

/**
 * __useAdminActivateMutation__
 *
 * To run a mutation, you first call `useAdminActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminActivateMutation, { data, loading, error }] = useAdminActivateMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useAdminActivateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminActivateMutation,
    AdminActivateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminActivateMutation,
    AdminActivateMutationVariables
  >(AdminActivateDocument, options);
}
export type AdminActivateMutationHookResult = ReturnType<
  typeof useAdminActivateMutation
>;
export type AdminActivateMutationResult =
  Apollo.MutationResult<AdminActivateMutation>;
export type AdminActivateMutationOptions = Apollo.BaseMutationOptions<
  AdminActivateMutation,
  AdminActivateMutationVariables
>;
export const BulkManagementListingDocument = gql`
  query BulkManagementListing(
    $input: BulkManagementListingInput
    $first: Int
    $page: Int
  ) {
    BulkManagementListing(input: $input, first: $first, page: $page) {
      data {
        ...BulkManagement
      }
      paginatorInfo {
        ...PaginatorInfo
      }
    }
  }
  ${BulkManagementFragmentDoc}
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __useBulkManagementListingQuery__
 *
 * To run a query within a React component, call `useBulkManagementListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkManagementListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkManagementListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useBulkManagementListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BulkManagementListingQuery,
    BulkManagementListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BulkManagementListingQuery,
    BulkManagementListingQueryVariables
  >(BulkManagementListingDocument, options);
}
export function useBulkManagementListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BulkManagementListingQuery,
    BulkManagementListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BulkManagementListingQuery,
    BulkManagementListingQueryVariables
  >(BulkManagementListingDocument, options);
}
export type BulkManagementListingQueryHookResult = ReturnType<
  typeof useBulkManagementListingQuery
>;
export type BulkManagementListingLazyQueryHookResult = ReturnType<
  typeof useBulkManagementListingLazyQuery
>;
export type BulkManagementListingQueryResult = Apollo.QueryResult<
  BulkManagementListingQuery,
  BulkManagementListingQueryVariables
>;
export const ClinicClientDropdownDocument = gql`
  query ClinicClientDropdown {
    ClinicClientDropdown {
      client_id
      client_name
    }
  }
`;

/**
 * __useClinicClientDropdownQuery__
 *
 * To run a query within a React component, call `useClinicClientDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicClientDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicClientDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useClinicClientDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClinicClientDropdownQuery,
    ClinicClientDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClinicClientDropdownQuery,
    ClinicClientDropdownQueryVariables
  >(ClinicClientDropdownDocument, options);
}
export function useClinicClientDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClinicClientDropdownQuery,
    ClinicClientDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClinicClientDropdownQuery,
    ClinicClientDropdownQueryVariables
  >(ClinicClientDropdownDocument, options);
}
export type ClinicClientDropdownQueryHookResult = ReturnType<
  typeof useClinicClientDropdownQuery
>;
export type ClinicClientDropdownLazyQueryHookResult = ReturnType<
  typeof useClinicClientDropdownLazyQuery
>;
export type ClinicClientDropdownQueryResult = Apollo.QueryResult<
  ClinicClientDropdownQuery,
  ClinicClientDropdownQueryVariables
>;
export const ClientDropdownDocument = gql`
  query ClientDropdown($member_staff_no: String) {
    ClientDropdown(member_staff_no: $member_staff_no) {
      client_id
      client_name
    }
  }
`;

/**
 * __useClientDropdownQuery__
 *
 * To run a query within a React component, call `useClientDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDropdownQuery({
 *   variables: {
 *      member_staff_no: // value for 'member_staff_no'
 *   },
 * });
 */
export function useClientDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClientDropdownQuery,
    ClientDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClientDropdownQuery, ClientDropdownQueryVariables>(
    ClientDropdownDocument,
    options
  );
}
export function useClientDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientDropdownQuery,
    ClientDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClientDropdownQuery, ClientDropdownQueryVariables>(
    ClientDropdownDocument,
    options
  );
}
export type ClientDropdownQueryHookResult = ReturnType<
  typeof useClientDropdownQuery
>;
export type ClientDropdownLazyQueryHookResult = ReturnType<
  typeof useClientDropdownLazyQuery
>;
export type ClientDropdownQueryResult = Apollo.QueryResult<
  ClientDropdownQuery,
  ClientDropdownQueryVariables
>;
export const ClientCorporateDropdownDocument = gql`
  query ClientCorporateDropdown($client_id: Int) {
    ClientCorporateDropdown(client_id: $client_id) {
      client_corporate_id
      client_corporate_name
    }
  }
`;

/**
 * __useClientCorporateDropdownQuery__
 *
 * To run a query within a React component, call `useClientCorporateDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCorporateDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCorporateDropdownQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *   },
 * });
 */
export function useClientCorporateDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClientCorporateDropdownQuery,
    ClientCorporateDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientCorporateDropdownQuery,
    ClientCorporateDropdownQueryVariables
  >(ClientCorporateDropdownDocument, options);
}
export function useClientCorporateDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientCorporateDropdownQuery,
    ClientCorporateDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientCorporateDropdownQuery,
    ClientCorporateDropdownQueryVariables
  >(ClientCorporateDropdownDocument, options);
}
export type ClientCorporateDropdownQueryHookResult = ReturnType<
  typeof useClientCorporateDropdownQuery
>;
export type ClientCorporateDropdownLazyQueryHookResult = ReturnType<
  typeof useClientCorporateDropdownLazyQuery
>;
export type ClientCorporateDropdownQueryResult = Apollo.QueryResult<
  ClientCorporateDropdownQuery,
  ClientCorporateDropdownQueryVariables
>;
export const SettingDiagnosisDropdownDocument = gql`
  query SettingDiagnosisDropdown {
    SettingDiagnosisDropdown {
      diagnosis_id
      diagnosis_name
      diagnosis_code
    }
  }
`;

/**
 * __useSettingDiagnosisDropdownQuery__
 *
 * To run a query within a React component, call `useSettingDiagnosisDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingDiagnosisDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingDiagnosisDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingDiagnosisDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SettingDiagnosisDropdownQuery,
    SettingDiagnosisDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SettingDiagnosisDropdownQuery,
    SettingDiagnosisDropdownQueryVariables
  >(SettingDiagnosisDropdownDocument, options);
}
export function useSettingDiagnosisDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SettingDiagnosisDropdownQuery,
    SettingDiagnosisDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SettingDiagnosisDropdownQuery,
    SettingDiagnosisDropdownQueryVariables
  >(SettingDiagnosisDropdownDocument, options);
}
export type SettingDiagnosisDropdownQueryHookResult = ReturnType<
  typeof useSettingDiagnosisDropdownQuery
>;
export type SettingDiagnosisDropdownLazyQueryHookResult = ReturnType<
  typeof useSettingDiagnosisDropdownLazyQuery
>;
export type SettingDiagnosisDropdownQueryResult = Apollo.QueryResult<
  SettingDiagnosisDropdownQuery,
  SettingDiagnosisDropdownQueryVariables
>;
export const SettingServiceDropdownDocument = gql`
  query SettingServiceDropdown {
    SettingServiceDropdown {
      service_id
      service_name
    }
  }
`;

/**
 * __useSettingServiceDropdownQuery__
 *
 * To run a query within a React component, call `useSettingServiceDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingServiceDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingServiceDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingServiceDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SettingServiceDropdownQuery,
    SettingServiceDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SettingServiceDropdownQuery,
    SettingServiceDropdownQueryVariables
  >(SettingServiceDropdownDocument, options);
}
export function useSettingServiceDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SettingServiceDropdownQuery,
    SettingServiceDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SettingServiceDropdownQuery,
    SettingServiceDropdownQueryVariables
  >(SettingServiceDropdownDocument, options);
}
export type SettingServiceDropdownQueryHookResult = ReturnType<
  typeof useSettingServiceDropdownQuery
>;
export type SettingServiceDropdownLazyQueryHookResult = ReturnType<
  typeof useSettingServiceDropdownLazyQuery
>;
export type SettingServiceDropdownQueryResult = Apollo.QueryResult<
  SettingServiceDropdownQuery,
  SettingServiceDropdownQueryVariables
>;
export const SettingStateDropdownDocument = gql`
  query SettingStateDropdown {
    SettingStateDropdown {
      state_id
      state_name
    }
  }
`;

/**
 * __useSettingStateDropdownQuery__
 *
 * To run a query within a React component, call `useSettingStateDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingStateDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingStateDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingStateDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SettingStateDropdownQuery,
    SettingStateDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SettingStateDropdownQuery,
    SettingStateDropdownQueryVariables
  >(SettingStateDropdownDocument, options);
}
export function useSettingStateDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SettingStateDropdownQuery,
    SettingStateDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SettingStateDropdownQuery,
    SettingStateDropdownQueryVariables
  >(SettingStateDropdownDocument, options);
}
export type SettingStateDropdownQueryHookResult = ReturnType<
  typeof useSettingStateDropdownQuery
>;
export type SettingStateDropdownLazyQueryHookResult = ReturnType<
  typeof useSettingStateDropdownLazyQuery
>;
export type SettingStateDropdownQueryResult = Apollo.QueryResult<
  SettingStateDropdownQuery,
  SettingStateDropdownQueryVariables
>;
export const SettingCityDropdownDocument = gql`
  query SettingCityDropdown($state_id: Int) {
    SettingCityDropdown(state_id: $state_id) {
      city_id
      city_name
    }
  }
`;

/**
 * __useSettingCityDropdownQuery__
 *
 * To run a query within a React component, call `useSettingCityDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingCityDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingCityDropdownQuery({
 *   variables: {
 *      state_id: // value for 'state_id'
 *   },
 * });
 */
export function useSettingCityDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SettingCityDropdownQuery,
    SettingCityDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SettingCityDropdownQuery,
    SettingCityDropdownQueryVariables
  >(SettingCityDropdownDocument, options);
}
export function useSettingCityDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SettingCityDropdownQuery,
    SettingCityDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SettingCityDropdownQuery,
    SettingCityDropdownQueryVariables
  >(SettingCityDropdownDocument, options);
}
export type SettingCityDropdownQueryHookResult = ReturnType<
  typeof useSettingCityDropdownQuery
>;
export type SettingCityDropdownLazyQueryHookResult = ReturnType<
  typeof useSettingCityDropdownLazyQuery
>;
export type SettingCityDropdownQueryResult = Apollo.QueryResult<
  SettingCityDropdownQuery,
  SettingCityDropdownQueryVariables
>;
export const AdminRolesDropdownDocument = gql`
  query AdminRolesDropdown($input: AdminRolesInputQuery) {
    AdminRolesDropdown(input: $input) {
      id
      name
    }
  }
`;

/**
 * __useAdminRolesDropdownQuery__
 *
 * To run a query within a React component, call `useAdminRolesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRolesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRolesDropdownQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminRolesDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminRolesDropdownQuery,
    AdminRolesDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AdminRolesDropdownQuery,
    AdminRolesDropdownQueryVariables
  >(AdminRolesDropdownDocument, options);
}
export function useAdminRolesDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminRolesDropdownQuery,
    AdminRolesDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AdminRolesDropdownQuery,
    AdminRolesDropdownQueryVariables
  >(AdminRolesDropdownDocument, options);
}
export type AdminRolesDropdownQueryHookResult = ReturnType<
  typeof useAdminRolesDropdownQuery
>;
export type AdminRolesDropdownLazyQueryHookResult = ReturnType<
  typeof useAdminRolesDropdownLazyQuery
>;
export type AdminRolesDropdownQueryResult = Apollo.QueryResult<
  AdminRolesDropdownQuery,
  AdminRolesDropdownQueryVariables
>;
export const MeDocument = gql`
  query Me {
    Me {
      ...User
    }
  }
  ${UserFragmentDoc}
`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(
  baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const LoginDocument = gql`
  mutation Login($input: LoginInput) {
    Login(input: $input) {
      token
      token_type
    }
  }
`;
export type LoginMutationFn = Apollo.MutationFunction<
  LoginMutation,
  LoginMutationVariables
>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginMutation,
    LoginMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(
    LoginDocument,
    options
  );
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<
  LoginMutation,
  LoginMutationVariables
>;
export const ResetPasswordSendEmailDocument = gql`
  mutation ResetPasswordSendEmail($email: String) {
    ResetPasswordSendEmail(email: $email) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type ResetPasswordSendEmailMutationFn = Apollo.MutationFunction<
  ResetPasswordSendEmailMutation,
  ResetPasswordSendEmailMutationVariables
>;

/**
 * __useResetPasswordSendEmailMutation__
 *
 * To run a mutation, you first call `useResetPasswordSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordSendEmailMutation, { data, loading, error }] = useResetPasswordSendEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordSendEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordSendEmailMutation,
    ResetPasswordSendEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetPasswordSendEmailMutation,
    ResetPasswordSendEmailMutationVariables
  >(ResetPasswordSendEmailDocument, options);
}
export type ResetPasswordSendEmailMutationHookResult = ReturnType<
  typeof useResetPasswordSendEmailMutation
>;
export type ResetPasswordSendEmailMutationResult =
  Apollo.MutationResult<ResetPasswordSendEmailMutation>;
export type ResetPasswordSendEmailMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordSendEmailMutation,
  ResetPasswordSendEmailMutationVariables
>;
export const ResetPasswordCheckDocument = gql`
  mutation ResetPasswordCheck($token: String) {
    ResetPasswordCheck(token: $token) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type ResetPasswordCheckMutationFn = Apollo.MutationFunction<
  ResetPasswordCheckMutation,
  ResetPasswordCheckMutationVariables
>;

/**
 * __useResetPasswordCheckMutation__
 *
 * To run a mutation, you first call `useResetPasswordCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordCheckMutation, { data, loading, error }] = useResetPasswordCheckMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordCheckMutation,
    ResetPasswordCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetPasswordCheckMutation,
    ResetPasswordCheckMutationVariables
  >(ResetPasswordCheckDocument, options);
}
export type ResetPasswordCheckMutationHookResult = ReturnType<
  typeof useResetPasswordCheckMutation
>;
export type ResetPasswordCheckMutationResult =
  Apollo.MutationResult<ResetPasswordCheckMutation>;
export type ResetPasswordCheckMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordCheckMutation,
  ResetPasswordCheckMutationVariables
>;
export const ResetPasswordDocument = gql`
  mutation ResetPassword($input: ResetPasswordInput) {
    ResetPassword(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >(ResetPasswordDocument, options);
}
export type ResetPasswordMutationHookResult = ReturnType<
  typeof useResetPasswordMutation
>;
export type ResetPasswordMutationResult =
  Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const SessionListingDocument = gql`
  query SessionListing($input: SessionListingInput, $first: Int, $page: Int) {
    SessionListing(input: $input, first: $first, page: $page) {
      paginatorInfo {
        ...PaginatorInfo
      }
      data {
        session_id
        clinic_patient {
          ...Patient
        }
        member {
          ...Member
        }
        session_status {
          ...SessionStatus
        }
        session_created
        claim {
          claim_number
          claim_created
        }
      }
    }
    SessionStatusCount(input: $input) {
      session_status_count
      session_status_name
      session_status_slug
    }
  }
  ${PaginatorInfoFragmentDoc}
  ${PatientFragmentDoc}
  ${MemberFragmentDoc}
  ${SessionStatusFragmentDoc}
`;

/**
 * __useSessionListingQuery__
 *
 * To run a query within a React component, call `useSessionListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSessionListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SessionListingQuery,
    SessionListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SessionListingQuery, SessionListingQueryVariables>(
    SessionListingDocument,
    options
  );
}
export function useSessionListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SessionListingQuery,
    SessionListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SessionListingQuery, SessionListingQueryVariables>(
    SessionListingDocument,
    options
  );
}
export type SessionListingQueryHookResult = ReturnType<
  typeof useSessionListingQuery
>;
export type SessionListingLazyQueryHookResult = ReturnType<
  typeof useSessionListingLazyQuery
>;
export type SessionListingQueryResult = Apollo.QueryResult<
  SessionListingQuery,
  SessionListingQueryVariables
>;
export const SessionStatusCountDocument = gql`
  query SessionStatusCount($input: SessionListingInput) {
    SessionStatusCount(input: $input) {
      session_status_count
      session_status_name
      session_status_slug
    }
  }
`;

/**
 * __useSessionStatusCountQuery__
 *
 * To run a query within a React component, call `useSessionStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionStatusCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionStatusCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SessionStatusCountQuery,
    SessionStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SessionStatusCountQuery,
    SessionStatusCountQueryVariables
  >(SessionStatusCountDocument, options);
}
export function useSessionStatusCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SessionStatusCountQuery,
    SessionStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SessionStatusCountQuery,
    SessionStatusCountQueryVariables
  >(SessionStatusCountDocument, options);
}
export type SessionStatusCountQueryHookResult = ReturnType<
  typeof useSessionStatusCountQuery
>;
export type SessionStatusCountLazyQueryHookResult = ReturnType<
  typeof useSessionStatusCountLazyQuery
>;
export type SessionStatusCountQueryResult = Apollo.QueryResult<
  SessionStatusCountQuery,
  SessionStatusCountQueryVariables
>;
export const SessionCancelDocument = gql`
  mutation SessionCancel($input: SessionCancelInput) {
    SessionCancel(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type SessionCancelMutationFn = Apollo.MutationFunction<
  SessionCancelMutation,
  SessionCancelMutationVariables
>;

/**
 * __useSessionCancelMutation__
 *
 * To run a mutation, you first call `useSessionCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionCancelMutation, { data, loading, error }] = useSessionCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionCancelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SessionCancelMutation,
    SessionCancelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SessionCancelMutation,
    SessionCancelMutationVariables
  >(SessionCancelDocument, options);
}
export type SessionCancelMutationHookResult = ReturnType<
  typeof useSessionCancelMutation
>;
export type SessionCancelMutationResult =
  Apollo.MutationResult<SessionCancelMutation>;
export type SessionCancelMutationOptions = Apollo.BaseMutationOptions<
  SessionCancelMutation,
  SessionCancelMutationVariables
>;
export const PatientDetailDocument = gql`
  query PatientDetail($input: PatientDetailInput) {
    PatientDetail(input: $input) {
      patient {
        ...Patient
      }
      member {
        ...Member
      }
      client {
        ...Client
      }
      client_corporate {
        client_corporate_name
        client_corporate_number
      }
      client_branch {
        client_branch_name
        client_branch_number
      }
      clinic {
        ...Clinic
      }
    }
  }
  ${PatientFragmentDoc}
  ${MemberFragmentDoc}
  ${ClientFragmentDoc}
  ${ClinicFragmentDoc}
`;

/**
 * __usePatientDetailQuery__
 *
 * To run a query within a React component, call `usePatientDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatientDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PatientDetailQuery,
    PatientDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PatientDetailQuery, PatientDetailQueryVariables>(
    PatientDetailDocument,
    options
  );
}
export function usePatientDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PatientDetailQuery,
    PatientDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PatientDetailQuery, PatientDetailQueryVariables>(
    PatientDetailDocument,
    options
  );
}
export type PatientDetailQueryHookResult = ReturnType<
  typeof usePatientDetailQuery
>;
export type PatientDetailLazyQueryHookResult = ReturnType<
  typeof usePatientDetailLazyQuery
>;
export type PatientDetailQueryResult = Apollo.QueryResult<
  PatientDetailQuery,
  PatientDetailQueryVariables
>;
export const SessionCreateDocument = gql`
  mutation SessionCreate($input: SessionCreateInput) {
    SessionCreate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type SessionCreateMutationFn = Apollo.MutationFunction<
  SessionCreateMutation,
  SessionCreateMutationVariables
>;

/**
 * __useSessionCreateMutation__
 *
 * To run a mutation, you first call `useSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionCreateMutation, { data, loading, error }] = useSessionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SessionCreateMutation,
    SessionCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SessionCreateMutation,
    SessionCreateMutationVariables
  >(SessionCreateDocument, options);
}
export type SessionCreateMutationHookResult = ReturnType<
  typeof useSessionCreateMutation
>;
export type SessionCreateMutationResult =
  Apollo.MutationResult<SessionCreateMutation>;
export type SessionCreateMutationOptions = Apollo.BaseMutationOptions<
  SessionCreateMutation,
  SessionCreateMutationVariables
>;
export const SessionCheckoutDocument = gql`
  mutation SessionCheckout($input: SessionCheckoutInput) {
    SessionCheckout(input: $input) {
      ...SuccessResponseCheckout
    }
  }
  ${SuccessResponseCheckoutFragmentDoc}
`;
export type SessionCheckoutMutationFn = Apollo.MutationFunction<
  SessionCheckoutMutation,
  SessionCheckoutMutationVariables
>;

/**
 * __useSessionCheckoutMutation__
 *
 * To run a mutation, you first call `useSessionCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionCheckoutMutation, { data, loading, error }] = useSessionCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSessionCheckoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SessionCheckoutMutation,
    SessionCheckoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SessionCheckoutMutation,
    SessionCheckoutMutationVariables
  >(SessionCheckoutDocument, options);
}
export type SessionCheckoutMutationHookResult = ReturnType<
  typeof useSessionCheckoutMutation
>;
export type SessionCheckoutMutationResult =
  Apollo.MutationResult<SessionCheckoutMutation>;
export type SessionCheckoutMutationOptions = Apollo.BaseMutationOptions<
  SessionCheckoutMutation,
  SessionCheckoutMutationVariables
>;
export const ClaimListingDocument = gql`
  query ClaimListing($input: ClaimListingInput, $first: Int, $page: Int) {
    ClaimListing(input: $input, first: $first, page: $page) {
      paginatorInfo {
        ...PaginatorInfo
      }
      data {
        ...Claim
      }
    }
    ClaimStatusCount(input: $input) {
      claim_status_count
      claim_status_name
      claim_status_slug
    }
  }
  ${PaginatorInfoFragmentDoc}
  ${ClaimFragmentDoc}
`;

/**
 * __useClaimListingQuery__
 *
 * To run a query within a React component, call `useClaimListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useClaimListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClaimListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useClaimListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClaimListingQuery,
    ClaimListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClaimListingQuery, ClaimListingQueryVariables>(
    ClaimListingDocument,
    options
  );
}
export function useClaimListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClaimListingQuery,
    ClaimListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClaimListingQuery, ClaimListingQueryVariables>(
    ClaimListingDocument,
    options
  );
}
export type ClaimListingQueryHookResult = ReturnType<
  typeof useClaimListingQuery
>;
export type ClaimListingLazyQueryHookResult = ReturnType<
  typeof useClaimListingLazyQuery
>;
export type ClaimListingQueryResult = Apollo.QueryResult<
  ClaimListingQuery,
  ClaimListingQueryVariables
>;
export const ClaimStatusCountDocument = gql`
  query ClaimStatusCount($input: ClaimListingInput) {
    ClaimStatusCount(input: $input) {
      claim_status_count
      claim_status_name
      claim_status_slug
    }
  }
`;

/**
 * __useClaimStatusCountQuery__
 *
 * To run a query within a React component, call `useClaimStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useClaimStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClaimStatusCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClaimStatusCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClaimStatusCountQuery,
    ClaimStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClaimStatusCountQuery, ClaimStatusCountQueryVariables>(
    ClaimStatusCountDocument,
    options
  );
}
export function useClaimStatusCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClaimStatusCountQuery,
    ClaimStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClaimStatusCountQuery,
    ClaimStatusCountQueryVariables
  >(ClaimStatusCountDocument, options);
}
export type ClaimStatusCountQueryHookResult = ReturnType<
  typeof useClaimStatusCountQuery
>;
export type ClaimStatusCountLazyQueryHookResult = ReturnType<
  typeof useClaimStatusCountLazyQuery
>;
export type ClaimStatusCountQueryResult = Apollo.QueryResult<
  ClaimStatusCountQuery,
  ClaimStatusCountQueryVariables
>;
export const ReportExportUrlDocument = gql`
  mutation ReportExportUrl($input: ReportInput) {
    ReportExportUrl(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type ReportExportUrlMutationFn = Apollo.MutationFunction<
  ReportExportUrlMutation,
  ReportExportUrlMutationVariables
>;

/**
 * __useReportExportUrlMutation__
 *
 * To run a mutation, you first call `useReportExportUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportExportUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportExportUrlMutation, { data, loading, error }] = useReportExportUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportExportUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReportExportUrlMutation,
    ReportExportUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReportExportUrlMutation,
    ReportExportUrlMutationVariables
  >(ReportExportUrlDocument, options);
}
export type ReportExportUrlMutationHookResult = ReturnType<
  typeof useReportExportUrlMutation
>;
export type ReportExportUrlMutationResult =
  Apollo.MutationResult<ReportExportUrlMutation>;
export type ReportExportUrlMutationOptions = Apollo.BaseMutationOptions<
  ReportExportUrlMutation,
  ReportExportUrlMutationVariables
>;
export const SessionReminderDocument = gql`
  query SessionReminder {
    SessionReminder {
      pending_session
    }
  }
`;

/**
 * __useSessionReminderQuery__
 *
 * To run a query within a React component, call `useSessionReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionReminderQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionReminderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SessionReminderQuery,
    SessionReminderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SessionReminderQuery, SessionReminderQueryVariables>(
    SessionReminderDocument,
    options
  );
}
export function useSessionReminderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SessionReminderQuery,
    SessionReminderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SessionReminderQuery,
    SessionReminderQueryVariables
  >(SessionReminderDocument, options);
}
export type SessionReminderQueryHookResult = ReturnType<
  typeof useSessionReminderQuery
>;
export type SessionReminderLazyQueryHookResult = ReturnType<
  typeof useSessionReminderLazyQuery
>;
export type SessionReminderQueryResult = Apollo.QueryResult<
  SessionReminderQuery,
  SessionReminderQueryVariables
>;
export const SettingDetailDocument = gql`
  query SettingDetail($setting_slug: SettingSlug) {
    SettingDetail(setting_slug: $setting_slug) {
      setting_id
      setting_slug
      setting_value
      setting_description
      is_editable
      setting_type
      setting_media {
        media_url
        media_name
        media_type
      }
    }
  }
`;

/**
 * __useSettingDetailQuery__
 *
 * To run a query within a React component, call `useSettingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingDetailQuery({
 *   variables: {
 *      setting_slug: // value for 'setting_slug'
 *   },
 * });
 */
export function useSettingDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SettingDetailQuery,
    SettingDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SettingDetailQuery, SettingDetailQueryVariables>(
    SettingDetailDocument,
    options
  );
}
export function useSettingDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SettingDetailQuery,
    SettingDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SettingDetailQuery, SettingDetailQueryVariables>(
    SettingDetailDocument,
    options
  );
}
export type SettingDetailQueryHookResult = ReturnType<
  typeof useSettingDetailQuery
>;
export type SettingDetailLazyQueryHookResult = ReturnType<
  typeof useSettingDetailLazyQuery
>;
export type SettingDetailQueryResult = Apollo.QueryResult<
  SettingDetailQuery,
  SettingDetailQueryVariables
>;
export const ActivityLogListingDocument = gql`
  query activityLogListing(
    $input: ActivityLogListingInput
    $first: Int
    $page: Int
  ) {
    ActivityLogListing(input: $input, first: $first, page: $page) {
      data {
        ...Activity
      }
      paginatorInfo {
        ...PaginatorInfo
      }
    }
  }
  ${ActivityFragmentDoc}
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __useActivityLogListingQuery__
 *
 * To run a query within a React component, call `useActivityLogListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useActivityLogListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActivityLogListingQuery,
    ActivityLogListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ActivityLogListingQuery,
    ActivityLogListingQueryVariables
  >(ActivityLogListingDocument, options);
}
export function useActivityLogListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityLogListingQuery,
    ActivityLogListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ActivityLogListingQuery,
    ActivityLogListingQueryVariables
  >(ActivityLogListingDocument, options);
}
export type ActivityLogListingQueryHookResult = ReturnType<
  typeof useActivityLogListingQuery
>;
export type ActivityLogListingLazyQueryHookResult = ReturnType<
  typeof useActivityLogListingLazyQuery
>;
export type ActivityLogListingQueryResult = Apollo.QueryResult<
  ActivityLogListingQuery,
  ActivityLogListingQueryVariables
>;
